import type { FeatureCollection, MultiPolygon, Polygon } from "geojson";

export const oklahomaCountyBoundaries = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -100.94557,
              36.998152
            ],
            [
              -100.94532,
              36.877549
            ],
            [
              -100.94549,
              36.848615
            ],
            [
              -100.95383,
              36.848087
            ],
            [
              -100.95389,
              36.717847
            ],
            [
              -100.95402,
              36.625027
            ],
            [
              -100.95391,
              36.587607
            ],
            [
              -100.954146,
              36.499621
            ],
            [
              -100.82422,
              36.499618
            ],
            [
              -100.70863,
              36.499521
            ],
            [
              -100.4952,
              36.49929
            ],
            [
              -100.48919,
              36.499475
            ],
            [
              -100.33446,
              36.49942
            ],
            [
              -100.29287,
              36.499876
            ],
            [
              -100.18122,
              36.499633
            ],
            [
              -100.00367,
              36.499642
            ],
            [
              -100.00379,
              36.514111
            ],
            [
              -100.003,
              36.593195
            ],
            [
              -100.003385,
              36.644239
            ],
            [
              -100.00368,
              36.746446
            ],
            [
              -100.00405,
              36.775763
            ],
            [
              -100.00324,
              36.90596
            ],
            [
              -100.00262,
              36.944011
            ],
            [
              -100.00256,
              37.001706
            ],
            [
              -100.08949,
              37.002306
            ],
            [
              -100.24993,
              37.001882
            ],
            [
              -100.30735,
              37.001813
            ],
            [
              -100.37542,
              37.001343
            ],
            [
              -100.498884,
              37.00085
            ],
            [
              -100.59764,
              37.00027
            ],
            [
              -100.63939,
              36.999741
            ],
            [
              -100.69355,
              36.999598
            ],
            [
              -100.73452,
              36.999059
            ],
            [
              -100.81428,
              36.999085
            ],
            [
              -100.85563,
              36.998626
            ],
            [
              -100.90427,
              36.998745
            ],
            [
              -100.94557,
              36.998152
            ]
          ]
        ]
      },
      "properties": {
        "county": "40007",
        "name": "Beaver"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.4562,
              36.999471
            ],
            [
              -99.45288,
              36.995549
            ],
            [
              -99.44341,
              36.995491
            ],
            [
              -99.439949,
              36.990734
            ],
            [
              -99.43919,
              36.980377
            ],
            [
              -99.43405,
              36.970064
            ],
            [
              -99.42722,
              36.959951
            ],
            [
              -99.42822,
              36.955332
            ],
            [
              -99.420519,
              36.941137
            ],
            [
              -99.41399,
              36.935457
            ],
            [
              -99.4049,
              36.925144
            ],
            [
              -99.398092,
              36.921539
            ],
            [
              -99.393,
              36.912726
            ],
            [
              -99.38698,
              36.905874
            ],
            [
              -99.38831,
              36.901579
            ],
            [
              -99.38368,
              36.891094
            ],
            [
              -99.37771,
              36.885947
            ],
            [
              -99.373,
              36.87861
            ],
            [
              -99.36531,
              36.877569
            ],
            [
              -99.35641,
              36.872015
            ],
            [
              -99.33025,
              36.862972
            ],
            [
              -99.32211,
              36.857214
            ],
            [
              -99.31429,
              36.856191
            ],
            [
              -99.31825,
              36.85002
            ],
            [
              -99.31742,
              36.842331
            ],
            [
              -99.31075,
              36.834717
            ],
            [
              -99.30843,
              36.828882
            ],
            [
              -99.299082,
              36.823909
            ],
            [
              -99.29519,
              36.819566
            ],
            [
              -99.29426,
              36.805939
            ],
            [
              -99.27726,
              36.795818
            ],
            [
              -99.27022,
              36.789727
            ],
            [
              -99.25038,
              36.785015
            ],
            [
              -99.22983,
              36.788161
            ],
            [
              -99.21776,
              36.786811
            ],
            [
              -99.21056,
              36.79069
            ],
            [
              -99.19906,
              36.790885
            ],
            [
              -99.18909,
              36.787363
            ],
            [
              -99.18084,
              36.787411
            ],
            [
              -99.16666,
              36.790602
            ],
            [
              -99.1523,
              36.787624
            ],
            [
              -99.13985,
              36.78304
            ],
            [
              -99.12827,
              36.769411
            ],
            [
              -99.12656,
              36.762566
            ],
            [
              -99.10775,
              36.750448
            ],
            [
              -99.10675,
              36.74744
            ],
            [
              -99.09745,
              36.74206
            ],
            [
              -99.09572,
              36.736752
            ],
            [
              -99.08449,
              36.721582
            ],
            [
              -99.07569,
              36.716989
            ],
            [
              -99.06151,
              36.71545
            ],
            [
              -99.04435,
              36.694948
            ],
            [
              -99.0481,
              36.686468
            ],
            [
              -99.03993,
              36.678569
            ],
            [
              -99.03915,
              36.67371
            ],
            [
              -99.03226,
              36.665929
            ],
            [
              -99.02351,
              36.661131
            ],
            [
              -99.02479,
              36.652218
            ],
            [
              -99.02254,
              36.642434
            ],
            [
              -99.01296,
              36.640241
            ],
            [
              -99.010087,
              36.633268
            ],
            [
              -99.00027,
              36.629448
            ],
            [
              -98.989083,
              36.616004
            ],
            [
              -98.97609,
              36.603052
            ],
            [
              -98.971486,
              36.60032
            ],
            [
              -98.959973,
              36.598992
            ],
            [
              -98.96033,
              36.506914
            ],
            [
              -98.87537,
              36.506664
            ],
            [
              -98.843646,
              36.506248
            ],
            [
              -98.83847,
              36.500034
            ],
            [
              -98.82913,
              36.484163
            ],
            [
              -98.81946,
              36.470995
            ],
            [
              -98.80782,
              36.460744
            ],
            [
              -98.792471,
              36.453263
            ],
            [
              -98.7777,
              36.448442
            ],
            [
              -98.76446,
              36.446666
            ],
            [
              -98.74334,
              36.448617
            ],
            [
              -98.72681,
              36.445332
            ],
            [
              -98.71854,
              36.437497
            ],
            [
              -98.70922,
              36.421958
            ],
            [
              -98.699493,
              36.416013
            ],
            [
              -98.66278,
              36.404571
            ],
            [
              -98.64427,
              36.397167
            ],
            [
              -98.625361,
              36.392595
            ],
            [
              -98.60281,
              36.390848
            ],
            [
              -98.59345,
              36.392031
            ],
            [
              -98.56403,
              36.400182
            ],
            [
              -98.55254,
              36.402318
            ],
            [
              -98.53355,
              36.397592
            ],
            [
              -98.53357,
              36.46333
            ],
            [
              -98.53324,
              36.521054
            ],
            [
              -98.53341,
              36.594259
            ],
            [
              -98.54048,
              36.594284
            ],
            [
              -98.54031,
              36.608709
            ],
            [
              -98.54054,
              36.688232
            ],
            [
              -98.54024,
              36.818887
            ],
            [
              -98.5406,
              36.884491
            ],
            [
              -98.54035,
              36.942213
            ],
            [
              -98.54503,
              36.942329
            ],
            [
              -98.54487,
              36.998997
            ],
            [
              -98.65866,
              36.998859
            ],
            [
              -98.7616,
              36.999425
            ],
            [
              -98.797452,
              36.999229
            ],
            [
              -98.85169,
              36.999454
            ],
            [
              -99.029337,
              36.999595
            ],
            [
              -99.04969,
              36.999221
            ],
            [
              -99.1057,
              36.999451
            ],
            [
              -99.27751,
              36.999579
            ],
            [
              -99.38721,
              37.000109
            ],
            [
              -99.40701,
              36.999579
            ],
            [
              -99.4562,
              36.999471
            ]
          ]
        ]
      },
      "properties": {
        "county": "40151",
        "name": "Woods"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.623149,
              35.551597
            ],
            [
              -98.6234,
              35.53555
            ],
            [
              -98.62323,
              35.464419
            ],
            [
              -98.6233,
              35.306831
            ],
            [
              -98.62373,
              35.250055
            ],
            [
              -98.62375,
              35.204231
            ],
            [
              -98.61789,
              35.204165
            ],
            [
              -98.61801,
              35.101703
            ],
            [
              -98.62105,
              35.097352
            ],
            [
              -98.620644,
              35.029121
            ],
            [
              -98.620039,
              35.000537
            ],
            [
              -98.61982,
              34.854953
            ],
            [
              -98.56178,
              34.85528
            ],
            [
              -98.49268,
              34.855012
            ],
            [
              -98.37707,
              34.855284
            ],
            [
              -98.3482,
              34.855088
            ],
            [
              -98.15153,
              34.854735
            ],
            [
              -98.09264,
              34.854919
            ],
            [
              -98.09293,
              34.912753
            ],
            [
              -98.092777,
              34.941633
            ],
            [
              -98.09336,
              34.970626
            ],
            [
              -98.09288,
              34.985032
            ],
            [
              -98.09309,
              35.028611
            ],
            [
              -98.09297,
              35.087951
            ],
            [
              -98.09113,
              35.088684
            ],
            [
              -98.091257,
              35.203651
            ],
            [
              -98.09488,
              35.203719
            ],
            [
              -98.09489,
              35.276249
            ],
            [
              -98.09596,
              35.377726
            ],
            [
              -98.20131,
              35.376812
            ],
            [
              -98.23654,
              35.376643
            ],
            [
              -98.26563,
              35.3771
            ],
            [
              -98.30637,
              35.377177
            ],
            [
              -98.30617,
              35.507328
            ],
            [
              -98.30671,
              35.541043
            ],
            [
              -98.3083,
              35.551505
            ],
            [
              -98.31325,
              35.551523
            ],
            [
              -98.35955,
              35.551336
            ],
            [
              -98.40705,
              35.551483
            ],
            [
              -98.50078,
              35.551397
            ],
            [
              -98.623149,
              35.551597
            ]
          ]
        ]
      },
      "properties": {
        "county": "40015",
        "name": "Caddo"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.671555,
              35.334212
            ],
            [
              -97.67144,
              35.333901
            ],
            [
              -97.6708,
              35.324253
            ],
            [
              -97.67094,
              35.203678
            ],
            [
              -97.67043,
              35.203655
            ],
            [
              -97.67056,
              35.116809
            ],
            [
              -97.67048,
              35.005835
            ],
            [
              -97.67036,
              34.898723
            ],
            [
              -97.67084,
              34.855217
            ],
            [
              -97.668,
              34.855137
            ],
            [
              -97.50783,
              34.855171
            ],
            [
              -97.34616,
              34.855318
            ],
            [
              -97.31574,
              34.855146
            ],
            [
              -97.18763,
              34.855161
            ],
            [
              -97.1253,
              34.854964
            ],
            [
              -96.9839,
              34.854856
            ],
            [
              -96.93263,
              34.854473
            ],
            [
              -96.93082,
              34.854564
            ],
            [
              -96.93051,
              34.952096
            ],
            [
              -96.92977,
              34.96513
            ],
            [
              -96.933751,
              34.965742
            ],
            [
              -96.944912,
              34.961573
            ],
            [
              -96.957636,
              34.948713
            ],
            [
              -96.965698,
              34.936435
            ],
            [
              -96.975797,
              34.932993
            ],
            [
              -96.97858,
              34.929535
            ],
            [
              -96.98757,
              34.926843
            ],
            [
              -96.997821,
              34.914301
            ],
            [
              -97.0097,
              34.909018
            ],
            [
              -97.018012,
              34.909076
            ],
            [
              -97.03914,
              34.913884
            ],
            [
              -97.064288,
              34.926509
            ],
            [
              -97.07345,
              34.927445
            ],
            [
              -97.088814,
              34.93164
            ],
            [
              -97.098241,
              34.925613
            ],
            [
              -97.107924,
              34.927581
            ],
            [
              -97.11366,
              34.921816
            ],
            [
              -97.120527,
              34.925533
            ],
            [
              -97.121687,
              34.933889
            ],
            [
              -97.125955,
              34.935584
            ],
            [
              -97.135225,
              34.926571
            ],
            [
              -97.142257,
              34.928448
            ],
            [
              -97.149188,
              34.931403
            ],
            [
              -97.159505,
              34.931191
            ],
            [
              -97.174922,
              34.929022
            ],
            [
              -97.189531,
              34.92898
            ],
            [
              -97.19876,
              34.934067
            ],
            [
              -97.206092,
              34.942341
            ],
            [
              -97.21526,
              34.944967
            ],
            [
              -97.220852,
              34.943074
            ],
            [
              -97.228715,
              34.933806
            ],
            [
              -97.234035,
              34.944937
            ],
            [
              -97.240883,
              34.944438
            ],
            [
              -97.244561,
              34.949297
            ],
            [
              -97.251729,
              34.950287
            ],
            [
              -97.2593,
              34.95584
            ],
            [
              -97.26965,
              34.954441
            ],
            [
              -97.280692,
              34.954618
            ],
            [
              -97.282168,
              34.958331
            ],
            [
              -97.278509,
              34.96197
            ],
            [
              -97.283796,
              34.965551
            ],
            [
              -97.294488,
              34.959538
            ],
            [
              -97.305012,
              34.956771
            ],
            [
              -97.311214,
              34.953606
            ],
            [
              -97.322251,
              34.953184
            ],
            [
              -97.324964,
              34.955709
            ],
            [
              -97.319413,
              34.964498
            ],
            [
              -97.322518,
              34.968963
            ],
            [
              -97.33239,
              34.970821
            ],
            [
              -97.345772,
              34.970547
            ],
            [
              -97.347579,
              34.97449
            ],
            [
              -97.345012,
              34.980275
            ],
            [
              -97.352001,
              34.990049
            ],
            [
              -97.345802,
              35.008455
            ],
            [
              -97.347339,
              35.014498
            ],
            [
              -97.353297,
              35.019078
            ],
            [
              -97.351603,
              35.027052
            ],
            [
              -97.356135,
              35.032439
            ],
            [
              -97.354668,
              35.036062
            ],
            [
              -97.348016,
              35.038686
            ],
            [
              -97.352523,
              35.053245
            ],
            [
              -97.353129,
              35.072473
            ],
            [
              -97.353475,
              35.073403
            ],
            [
              -97.356327,
              35.079132
            ],
            [
              -97.362662,
              35.084628
            ],
            [
              -97.369137,
              35.08576
            ],
            [
              -97.386323,
              35.080911
            ],
            [
              -97.394736,
              35.086711
            ],
            [
              -97.403824,
              35.090605
            ],
            [
              -97.406757,
              35.100454
            ],
            [
              -97.402795,
              35.116398
            ],
            [
              -97.402932,
              35.117151
            ],
            [
              -97.405488,
              35.126618
            ],
            [
              -97.404994,
              35.135638
            ],
            [
              -97.414086,
              35.141432
            ],
            [
              -97.429628,
              35.142636
            ],
            [
              -97.438839,
              35.149764
            ],
            [
              -97.441633,
              35.158277
            ],
            [
              -97.445674,
              35.160405
            ],
            [
              -97.446567,
              35.160559
            ],
            [
              -97.449236,
              35.161479
            ],
            [
              -97.44997,
              35.161895
            ],
            [
              -97.457961,
              35.168266
            ],
            [
              -97.462841,
              35.180359
            ],
            [
              -97.478405,
              35.188023
            ],
            [
              -97.483899,
              35.19407
            ],
            [
              -97.485003,
              35.194819
            ],
            [
              -97.491547,
              35.202358
            ],
            [
              -97.495061,
              35.198774
            ],
            [
              -97.508615,
              35.205051
            ],
            [
              -97.520859,
              35.216258
            ],
            [
              -97.525354,
              35.210943
            ],
            [
              -97.53054,
              35.209462
            ],
            [
              -97.534573,
              35.215176
            ],
            [
              -97.547848,
              35.217708
            ],
            [
              -97.548033,
              35.218187
            ],
            [
              -97.550342,
              35.224481
            ],
            [
              -97.55984,
              35.230305
            ],
            [
              -97.554383,
              35.232964
            ],
            [
              -97.562792,
              35.238615
            ],
            [
              -97.566264,
              35.244173
            ],
            [
              -97.553272,
              35.250353
            ],
            [
              -97.563148,
              35.254523
            ],
            [
              -97.564422,
              35.258391
            ],
            [
              -97.559303,
              35.265388
            ],
            [
              -97.554355,
              35.279297
            ],
            [
              -97.556887,
              35.283834
            ],
            [
              -97.567775,
              35.290619
            ],
            [
              -97.567832,
              35.291033
            ],
            [
              -97.56881,
              35.297414
            ],
            [
              -97.577609,
              35.302318
            ],
            [
              -97.588568,
              35.302048
            ],
            [
              -97.598225,
              35.303466
            ],
            [
              -97.598762,
              35.303289
            ],
            [
              -97.599601,
              35.303068
            ],
            [
              -97.620074,
              35.303463
            ],
            [
              -97.620716,
              35.307992
            ],
            [
              -97.627955,
              35.307158
            ],
            [
              -97.634253,
              35.31035
            ],
            [
              -97.645209,
              35.328198
            ],
            [
              -97.652521,
              35.330194
            ],
            [
              -97.664871,
              35.329087
            ],
            [
              -97.667858,
              35.33071
            ],
            [
              -97.670192,
              35.332803
            ],
            [
              -97.670643,
              35.333233
            ],
            [
              -97.671213,
              35.333865
            ],
            [
              -97.671555,
              35.334212
            ]
          ]
        ]
      },
      "properties": {
        "county": "40087",
        "name": "Mcclain"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -94.466283,
              34.507433
            ],
            [
              -94.461149,
              34.507457
            ],
            [
              -94.457209,
              34.646764
            ],
            [
              -94.453171,
              34.772562
            ],
            [
              -94.450957,
              34.830693
            ],
            [
              -94.44903,
              34.890762
            ],
            [
              -94.449253,
              34.895869
            ],
            [
              -94.446401,
              34.969346
            ],
            [
              -94.44123,
              35.119724
            ],
            [
              -94.43886,
              35.187183
            ],
            [
              -94.439084,
              35.197298
            ],
            [
              -94.43659,
              35.250094
            ],
            [
              -94.43517,
              35.292364
            ],
            [
              -94.434415,
              35.297793
            ],
            [
              -94.433215,
              35.335392
            ],
            [
              -94.431515,
              35.369591
            ],
            [
              -94.433415,
              35.376291
            ],
            [
              -94.432315,
              35.384691
            ],
            [
              -94.43391,
              35.387391
            ],
            [
              -94.435781,
              35.380374
            ],
            [
              -94.444326,
              35.375552
            ],
            [
              -94.466635,
              35.377849
            ],
            [
              -94.477057,
              35.374942
            ],
            [
              -94.486136,
              35.367123
            ],
            [
              -94.494941,
              35.352604
            ],
            [
              -94.495628,
              35.345837
            ],
            [
              -94.494392,
              35.334333
            ],
            [
              -94.49932,
              35.322706
            ],
            [
              -94.508747,
              35.312873
            ],
            [
              -94.515201,
              35.308692
            ],
            [
              -94.533528,
              35.304331
            ],
            [
              -94.542732,
              35.304961
            ],
            [
              -94.55463,
              35.310219
            ],
            [
              -94.565201,
              35.322632
            ],
            [
              -94.576472,
              35.328867
            ],
            [
              -94.594801,
              35.327974
            ],
            [
              -94.603862,
              35.321683
            ],
            [
              -94.615879,
              35.304111
            ],
            [
              -94.625221,
              35.297522
            ],
            [
              -94.633432,
              35.293769
            ],
            [
              -94.647967,
              35.29123
            ],
            [
              -94.66313,
              35.292563
            ],
            [
              -94.668796,
              35.295029
            ],
            [
              -94.678342,
              35.3048
            ],
            [
              -94.678889,
              35.318409
            ],
            [
              -94.683459,
              35.326252
            ],
            [
              -94.68912,
              35.32925
            ],
            [
              -94.705518,
              35.333238
            ],
            [
              -94.714589,
              35.339689
            ],
            [
              -94.725697,
              35.349702
            ],
            [
              -94.735959,
              35.354138
            ],
            [
              -94.750224,
              35.356969
            ],
            [
              -94.769709,
              35.355294
            ],
            [
              -94.778444,
              35.350895
            ],
            [
              -94.785001,
              35.342186
            ],
            [
              -94.790528,
              35.331334
            ],
            [
              -94.794374,
              35.327086
            ],
            [
              -94.800908,
              35.324952
            ],
            [
              -94.813629,
              35.323344
            ],
            [
              -94.81363,
              35.323249
            ],
            [
              -94.81376,
              35.312849
            ],
            [
              -94.814178,
              35.275063
            ],
            [
              -94.81424,
              35.267573
            ],
            [
              -94.814416,
              35.250096
            ],
            [
              -94.81439,
              35.242214
            ],
            [
              -94.81443,
              35.223858
            ],
            [
              -94.814625,
              35.216417
            ],
            [
              -94.8143,
              35.209887
            ],
            [
              -94.814282,
              35.20554
            ],
            [
              -94.814284,
              35.202331
            ],
            [
              -94.81973,
              35.202381
            ],
            [
              -94.836968,
              35.202264
            ],
            [
              -94.874176,
              35.202485
            ],
            [
              -94.889559,
              35.202487
            ],
            [
              -94.88981,
              35.202556
            ],
            [
              -94.927941,
              35.202564
            ],
            [
              -94.92811,
              35.175135
            ],
            [
              -94.92803,
              35.155353
            ],
            [
              -94.928056,
              35.1519
            ],
            [
              -94.928053,
              35.150692
            ],
            [
              -94.928035,
              35.125613
            ],
            [
              -94.92797,
              35.120119
            ],
            [
              -94.927973,
              35.119877
            ],
            [
              -94.92793,
              35.076347
            ],
            [
              -94.92793,
              35.076168
            ],
            [
              -94.927875,
              35.064815
            ],
            [
              -94.927864,
              35.058473
            ],
            [
              -94.927863,
              35.058279
            ],
            [
              -94.927862,
              35.057041
            ],
            [
              -94.927838,
              35.043028
            ],
            [
              -94.927825,
              35.035379
            ],
            [
              -94.927703,
              35.014329
            ],
            [
              -94.927687,
              34.998541
            ],
            [
              -94.9277,
              34.99297
            ],
            [
              -94.92775,
              34.973187
            ],
            [
              -94.92779,
              34.957219
            ],
            [
              -94.927832,
              34.942213
            ],
            [
              -94.975783,
              34.942174
            ],
            [
              -94.98097,
              34.942139
            ],
            [
              -94.987408,
              34.942145
            ],
            [
              -94.997964,
              34.942156
            ],
            [
              -94.998074,
              34.942157
            ],
            [
              -94.99804,
              34.936194
            ],
            [
              -94.99791,
              34.913099
            ],
            [
              -94.9979,
              34.911218
            ],
            [
              -94.997845,
              34.900403
            ],
            [
              -94.997836,
              34.898491
            ],
            [
              -94.997836,
              34.889014
            ],
            [
              -94.997852,
              34.877635
            ],
            [
              -94.997601,
              34.866268
            ],
            [
              -94.997621,
              34.856262
            ],
            [
              -94.997731,
              34.856102
            ],
            [
              -94.997651,
              34.855055
            ],
            [
              -95.000236,
              34.855056
            ],
            [
              -95.00508,
              34.855131
            ],
            [
              -95.0056,
              34.855168
            ],
            [
              -95.015606,
              34.855127
            ],
            [
              -95.059512,
              34.855019
            ],
            [
              -95.059475,
              34.850576
            ],
            [
              -95.059446,
              34.837656
            ],
            [
              -95.05944,
              34.834679
            ],
            [
              -95.05958,
              34.82743
            ],
            [
              -95.05972,
              34.824044
            ],
            [
              -95.059712,
              34.822735
            ],
            [
              -95.05945,
              34.820455
            ],
            [
              -95.059446,
              34.820333
            ],
            [
              -95.06005,
              34.803962
            ],
            [
              -95.059976,
              34.79646
            ],
            [
              -95.059934,
              34.788072
            ],
            [
              -95.0598,
              34.76374
            ],
            [
              -95.059754,
              34.761313
            ],
            [
              -95.05993,
              34.726577
            ],
            [
              -95.059931,
              34.725059
            ],
            [
              -95.0598,
              34.717129
            ],
            [
              -95.05963,
              34.692684
            ],
            [
              -95.059616,
              34.680736
            ],
            [
              -95.034521,
              34.680722
            ],
            [
              -95.01681,
              34.680786
            ],
            [
              -95.015764,
              34.68082
            ],
            [
              -95.012164,
              34.680904
            ],
            [
              -95.00439,
              34.680957
            ],
            [
              -95.00388,
              34.680964
            ],
            [
              -94.997102,
              34.680937
            ],
            [
              -94.98147,
              34.680876
            ],
            [
              -94.975705,
              34.680809
            ],
            [
              -94.94982,
              34.680756
            ],
            [
              -94.943864,
              34.680796
            ],
            [
              -94.93776,
              34.679924
            ],
            [
              -94.93762,
              34.653798
            ],
            [
              -94.937526,
              34.621189
            ],
            [
              -94.937478,
              34.592335
            ],
            [
              -94.937422,
              34.574061
            ],
            [
              -94.937416,
              34.571091
            ],
            [
              -94.9374,
              34.563388
            ],
            [
              -94.937565,
              34.550184
            ],
            [
              -94.93758,
              34.549635
            ],
            [
              -94.937757,
              34.538964
            ],
            [
              -94.93762,
              34.53805
            ],
            [
              -94.937535,
              34.534253
            ],
            [
              -94.937583,
              34.514633
            ],
            [
              -94.937585,
              34.514056
            ],
            [
              -94.937604,
              34.506887
            ],
            [
              -94.93535,
              34.506747
            ],
            [
              -94.932114,
              34.506517
            ],
            [
              -94.89231,
              34.507036
            ],
            [
              -94.83681,
              34.507338
            ],
            [
              -94.750223,
              34.50728
            ],
            [
              -94.747854,
              34.50728
            ],
            [
              -94.697082,
              34.50724
            ],
            [
              -94.68165,
              34.507293
            ],
            [
              -94.673159,
              34.507321
            ],
            [
              -94.641331,
              34.50749
            ],
            [
              -94.62522,
              34.507486
            ],
            [
              -94.616794,
              34.507445
            ],
            [
              -94.570586,
              34.507316
            ],
            [
              -94.56329,
              34.507281
            ],
            [
              -94.533183,
              34.507289
            ],
            [
              -94.466283,
              34.507433
            ]
          ]
        ]
      },
      "properties": {
        "county": "40079",
        "name": "Le Flore"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -94.43391,
              35.387391
            ],
            [
              -94.431215,
              35.39429
            ],
            [
              -94.4399,
              35.441201
            ],
            [
              -94.449955,
              35.498055
            ],
            [
              -94.450421,
              35.502285
            ],
            [
              -94.47265,
              35.638556
            ],
            [
              -94.48046,
              35.638512
            ],
            [
              -94.49202,
              35.638451
            ],
            [
              -94.500216,
              35.63836
            ],
            [
              -94.515161,
              35.63838
            ],
            [
              -94.533761,
              35.6383
            ],
            [
              -94.572337,
              35.638329
            ],
            [
              -94.583537,
              35.63828
            ],
            [
              -94.58636,
              35.638277
            ],
            [
              -94.62979,
              35.638293
            ],
            [
              -94.64326,
              35.638476
            ],
            [
              -94.665894,
              35.638519
            ],
            [
              -94.676927,
              35.63833
            ],
            [
              -94.684951,
              35.638228
            ],
            [
              -94.70407,
              35.638413
            ],
            [
              -94.750223,
              35.638599
            ],
            [
              -94.778704,
              35.638515
            ],
            [
              -94.786922,
              35.638586
            ],
            [
              -94.78953,
              35.638602
            ],
            [
              -94.798473,
              35.638604
            ],
            [
              -94.807297,
              35.638604
            ],
            [
              -94.80822,
              35.638605
            ],
            [
              -94.828956,
              35.638617
            ],
            [
              -94.839394,
              35.638661
            ],
            [
              -94.903681,
              35.638726
            ],
            [
              -94.910399,
              35.638644
            ],
            [
              -94.911921,
              35.638594
            ],
            [
              -94.937082,
              35.638569
            ],
            [
              -94.94157,
              35.638617
            ],
            [
              -94.944038,
              35.638777
            ],
            [
              -94.95549,
              35.638541
            ],
            [
              -94.973231,
              35.638318
            ],
            [
              -94.99146,
              35.638374
            ],
            [
              -94.99162,
              35.638374
            ],
            [
              -95.00055,
              35.638383
            ],
            [
              -95.019194,
              35.638467
            ],
            [
              -95.027413,
              35.638553
            ],
            [
              -95.051133,
              35.638795
            ],
            [
              -95.100936,
              35.638783
            ],
            [
              -95.125236,
              35.638846
            ],
            [
              -95.127464,
              35.638894
            ],
            [
              -95.127573,
              35.612727
            ],
            [
              -95.12752,
              35.601968
            ],
            [
              -95.127494,
              35.597006
            ],
            [
              -95.12752,
              35.55676
            ],
            [
              -95.132437,
              35.551696
            ],
            [
              -95.132526,
              35.544024
            ],
            [
              -95.132509,
              35.539824
            ],
            [
              -95.132437,
              35.526196
            ],
            [
              -95.125237,
              35.515996
            ],
            [
              -95.123736,
              35.510296
            ],
            [
              -95.115235,
              35.500396
            ],
            [
              -95.106736,
              35.492395
            ],
            [
              -95.106036,
              35.491895
            ],
            [
              -95.102336,
              35.489895
            ],
            [
              -95.097336,
              35.486896
            ],
            [
              -95.092436,
              35.479696
            ],
            [
              -95.092036,
              35.478496
            ],
            [
              -95.091635,
              35.477196
            ],
            [
              -95.091035,
              35.475896
            ],
            [
              -95.088335,
              35.464796
            ],
            [
              -95.085635,
              35.461396
            ],
            [
              -95.082335,
              35.459596
            ],
            [
              -95.079635,
              35.458796
            ],
            [
              -95.078435,
              35.458696
            ],
            [
              -95.077235,
              35.458796
            ],
            [
              -95.075135,
              35.459495
            ],
            [
              -95.065534,
              35.464795
            ],
            [
              -95.061234,
              35.465095
            ],
            [
              -95.047534,
              35.457995
            ],
            [
              -95.046234,
              35.457495
            ],
            [
              -95.037833,
              35.456895
            ],
            [
              -95.025433,
              35.453395
            ],
            [
              -95.023332,
              35.448495
            ],
            [
              -95.024233,
              35.431395
            ],
            [
              -95.022833,
              35.428695
            ],
            [
              -95.021533,
              35.426795
            ],
            [
              -95.015432,
              35.421695
            ],
            [
              -95.00651,
              35.4146
            ],
            [
              -94.986829,
              35.40838
            ],
            [
              -94.971475,
              35.407099
            ],
            [
              -94.965956,
              35.406716
            ],
            [
              -94.959155,
              35.40827
            ],
            [
              -94.955164,
              35.408689
            ],
            [
              -94.951328,
              35.408334
            ],
            [
              -94.948857,
              35.407266
            ],
            [
              -94.946491,
              35.404888
            ],
            [
              -94.938516,
              35.396595
            ],
            [
              -94.934137,
              35.395483
            ],
            [
              -94.931373,
              35.394593
            ],
            [
              -94.928892,
              35.39342
            ],
            [
              -94.925745,
              35.392845
            ],
            [
              -94.920495,
              35.393104
            ],
            [
              -94.917045,
              35.393763
            ],
            [
              -94.911143,
              35.397183
            ],
            [
              -94.908155,
              35.398381
            ],
            [
              -94.904816,
              35.398821
            ],
            [
              -94.904685,
              35.398838
            ],
            [
              -94.901832,
              35.39794
            ],
            [
              -94.896275,
              35.391773
            ],
            [
              -94.8923,
              35.384345
            ],
            [
              -94.894616,
              35.373007
            ],
            [
              -94.90587,
              35.364832
            ],
            [
              -94.91703,
              35.356686
            ],
            [
              -94.919579,
              35.353317
            ],
            [
              -94.918707,
              35.350414
            ],
            [
              -94.916629,
              35.348731
            ],
            [
              -94.914454,
              35.347525
            ],
            [
              -94.911917,
              35.346651
            ],
            [
              -94.908063,
              35.346424
            ],
            [
              -94.90198,
              35.346709
            ],
            [
              -94.892824,
              35.349807
            ],
            [
              -94.888236,
              35.35109
            ],
            [
              -94.8824,
              35.352479
            ],
            [
              -94.875228,
              35.354322
            ],
            [
              -94.868941,
              35.355564
            ],
            [
              -94.85406,
              35.364117
            ],
            [
              -94.849677,
              35.368574
            ],
            [
              -94.847662,
              35.369784
            ],
            [
              -94.845184,
              35.370785
            ],
            [
              -94.842143,
              35.371086
            ],
            [
              -94.838538,
              35.370203
            ],
            [
              -94.831227,
              35.365549
            ],
            [
              -94.828972,
              35.361546
            ],
            [
              -94.829013,
              35.346798
            ],
            [
              -94.82746,
              35.337412
            ],
            [
              -94.825099,
              35.331867
            ],
            [
              -94.820681,
              35.325889
            ],
            [
              -94.817259,
              35.323867
            ],
            [
              -94.813629,
              35.323344
            ],
            [
              -94.800908,
              35.324952
            ],
            [
              -94.794374,
              35.327086
            ],
            [
              -94.790528,
              35.331334
            ],
            [
              -94.785001,
              35.342186
            ],
            [
              -94.778444,
              35.350895
            ],
            [
              -94.769709,
              35.355294
            ],
            [
              -94.750224,
              35.356969
            ],
            [
              -94.735959,
              35.354138
            ],
            [
              -94.725697,
              35.349702
            ],
            [
              -94.714589,
              35.339689
            ],
            [
              -94.705518,
              35.333238
            ],
            [
              -94.68912,
              35.32925
            ],
            [
              -94.683459,
              35.326252
            ],
            [
              -94.678889,
              35.318409
            ],
            [
              -94.678342,
              35.3048
            ],
            [
              -94.668796,
              35.295029
            ],
            [
              -94.66313,
              35.292563
            ],
            [
              -94.647967,
              35.29123
            ],
            [
              -94.633432,
              35.293769
            ],
            [
              -94.625221,
              35.297522
            ],
            [
              -94.615879,
              35.304111
            ],
            [
              -94.603862,
              35.321683
            ],
            [
              -94.594801,
              35.327974
            ],
            [
              -94.576472,
              35.328867
            ],
            [
              -94.565201,
              35.322632
            ],
            [
              -94.55463,
              35.310219
            ],
            [
              -94.542732,
              35.304961
            ],
            [
              -94.533528,
              35.304331
            ],
            [
              -94.515201,
              35.308692
            ],
            [
              -94.508747,
              35.312873
            ],
            [
              -94.49932,
              35.322706
            ],
            [
              -94.494392,
              35.334333
            ],
            [
              -94.495628,
              35.345837
            ],
            [
              -94.494941,
              35.352604
            ],
            [
              -94.486136,
              35.367123
            ],
            [
              -94.477057,
              35.374942
            ],
            [
              -94.466635,
              35.377849
            ],
            [
              -94.444326,
              35.375552
            ],
            [
              -94.435781,
              35.380374
            ],
            [
              -94.43391,
              35.387391
            ]
          ]
        ]
      },
      "properties": {
        "county": "40135",
        "name": "Sequoyah"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.46228,
              36.998685
            ],
            [
              -97.4624,
              36.926965
            ],
            [
              -97.46245,
              36.825363
            ],
            [
              -97.46221,
              36.781731
            ],
            [
              -97.46238,
              36.68045
            ],
            [
              -97.46246,
              36.593453
            ],
            [
              -97.46164,
              36.593454
            ],
            [
              -97.42641,
              36.593776
            ],
            [
              -97.3643,
              36.593568
            ],
            [
              -97.29003,
              36.593729
            ],
            [
              -97.11911,
              36.594041
            ],
            [
              -97.057415,
              36.593647
            ],
            [
              -97.05766,
              36.594115
            ],
            [
              -97.0571,
              36.597833
            ],
            [
              -97.04597,
              36.597968
            ],
            [
              -97.044416,
              36.5993
            ],
            [
              -97.04468,
              36.602721
            ],
            [
              -97.05171,
              36.61111
            ],
            [
              -97.04962,
              36.620184
            ],
            [
              -97.04856,
              36.623233
            ],
            [
              -97.0512,
              36.630524
            ],
            [
              -97.05099,
              36.632591
            ],
            [
              -97.05096,
              36.6344
            ],
            [
              -97.0511,
              36.636605
            ],
            [
              -97.05301,
              36.643934
            ],
            [
              -97.06144,
              36.651114
            ],
            [
              -97.06319,
              36.657378
            ],
            [
              -97.06307,
              36.65853
            ],
            [
              -97.06344,
              36.664227
            ],
            [
              -97.06445,
              36.66603
            ],
            [
              -97.06441,
              36.681831
            ],
            [
              -97.06228,
              36.686002
            ],
            [
              -97.05324,
              36.69221
            ],
            [
              -97.04306,
              36.697025
            ],
            [
              -97.03739,
              36.700041
            ],
            [
              -97.03252,
              36.701959
            ],
            [
              -97.02756,
              36.699158
            ],
            [
              -97.02419,
              36.693405
            ],
            [
              -97.01925,
              36.693066
            ],
            [
              -97.01225,
              36.694069
            ],
            [
              -97.00031,
              36.689914
            ],
            [
              -96.99568,
              36.688208
            ],
            [
              -96.99432,
              36.687853
            ],
            [
              -96.99106,
              36.688101
            ],
            [
              -96.98976,
              36.688245
            ],
            [
              -96.98097,
              36.688369
            ],
            [
              -96.97805,
              36.688618
            ],
            [
              -96.9729,
              36.688273
            ],
            [
              -96.96709,
              36.688536
            ],
            [
              -96.96527,
              36.687809
            ],
            [
              -96.96007,
              36.686615
            ],
            [
              -96.95709,
              36.685539
            ],
            [
              -96.943726,
              36.683885
            ],
            [
              -96.94194,
              36.684432
            ],
            [
              -96.93194,
              36.686098
            ],
            [
              -96.927262,
              36.688797
            ],
            [
              -96.92809,
              36.69559
            ],
            [
              -96.92679,
              36.697813
            ],
            [
              -96.9259,
              36.698952
            ],
            [
              -96.9226,
              36.702869
            ],
            [
              -96.92091,
              36.717102
            ],
            [
              -96.90974,
              36.727097
            ],
            [
              -96.90743,
              36.735842
            ],
            [
              -96.89844,
              36.743296
            ],
            [
              -96.89082,
              36.750036
            ],
            [
              -96.88761,
              36.752107
            ],
            [
              -96.87531,
              36.752855
            ],
            [
              -96.87181,
              36.753648
            ],
            [
              -96.86637,
              36.752943
            ],
            [
              -96.85363,
              36.746111
            ],
            [
              -96.83897,
              36.743711
            ],
            [
              -96.8341,
              36.743438
            ],
            [
              -96.82664,
              36.745342
            ],
            [
              -96.82167,
              36.750036
            ],
            [
              -96.81806,
              36.758987
            ],
            [
              -96.818827,
              36.763661
            ],
            [
              -96.81579,
              36.767558
            ],
            [
              -96.81224,
              36.767556
            ],
            [
              -96.78869,
              36.767554
            ],
            [
              -96.78866,
              36.781972
            ],
            [
              -96.75246,
              36.782051
            ],
            [
              -96.75283,
              36.850995
            ],
            [
              -96.7521,
              36.858901
            ],
            [
              -96.75208,
              36.861587
            ],
            [
              -96.75242,
              36.875034
            ],
            [
              -96.75215,
              36.941262
            ],
            [
              -96.75031,
              36.941272
            ],
            [
              -96.75,
              36.947808
            ],
            [
              -96.74989,
              36.981488
            ],
            [
              -96.74984,
              36.998988
            ],
            [
              -96.79206,
              36.99918
            ],
            [
              -96.91709,
              36.999182
            ],
            [
              -97.07565,
              36.998934
            ],
            [
              -97.12974,
              36.999126
            ],
            [
              -97.19232,
              36.998937
            ],
            [
              -97.318754,
              36.998731
            ],
            [
              -97.36493,
              36.998882
            ],
            [
              -97.46228,
              36.998685
            ]
          ]
        ]
      },
      "properties": {
        "county": "40071",
        "name": "Kay"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -102.02821,
              36.993125
            ],
            [
              -102.02809,
              36.893058
            ],
            [
              -102.02832,
              36.849144
            ],
            [
              -102.03217,
              36.849184
            ],
            [
              -102.03174,
              36.798509
            ],
            [
              -102.031737,
              36.73313
            ],
            [
              -102.03231,
              36.581297
            ],
            [
              -102.03234,
              36.500575
            ],
            [
              -101.89944,
              36.500426
            ],
            [
              -101.87815,
              36.500026
            ],
            [
              -101.83845,
              36.500026
            ],
            [
              -101.83361,
              36.499533
            ],
            [
              -101.775558,
              36.49976
            ],
            [
              -101.69868,
              36.499508
            ],
            [
              -101.4966,
              36.499455
            ],
            [
              -101.37544,
              36.499343
            ],
            [
              -101.37358,
              36.499583
            ],
            [
              -101.21926,
              36.499463
            ],
            [
              -101.12543,
              36.499519
            ],
            [
              -101.09899,
              36.499118
            ],
            [
              -101.05397,
              36.499532
            ],
            [
              -100.954146,
              36.499621
            ],
            [
              -100.95391,
              36.587607
            ],
            [
              -100.95402,
              36.625027
            ],
            [
              -100.95389,
              36.717847
            ],
            [
              -100.95383,
              36.848087
            ],
            [
              -100.94549,
              36.848615
            ],
            [
              -100.94532,
              36.877549
            ],
            [
              -100.94557,
              36.998152
            ],
            [
              -101.10766,
              36.99775
            ],
            [
              -101.21451,
              36.996998
            ],
            [
              -101.25237,
              36.996941
            ],
            [
              -101.36527,
              36.996229
            ],
            [
              -101.41072,
              36.996125
            ],
            [
              -101.4564,
              36.995507
            ],
            [
              -101.48715,
              36.995656
            ],
            [
              -101.63223,
              36.994919
            ],
            [
              -101.77632,
              36.99421
            ],
            [
              -101.86594,
              36.993763
            ],
            [
              -102.02821,
              36.993125
            ]
          ]
        ]
      },
      "properties": {
        "county": "40139",
        "name": "Texas"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.29519,
              36.819566
            ],
            [
              -99.29492,
              36.768697
            ],
            [
              -99.29518,
              36.754248
            ],
            [
              -99.29537,
              36.681777
            ],
            [
              -99.29526,
              36.595123
            ],
            [
              -99.389784,
              36.59405
            ],
            [
              -99.44016,
              36.593876
            ],
            [
              -99.47239,
              36.59409
            ],
            [
              -99.50039,
              36.593288
            ],
            [
              -99.605565,
              36.592753
            ],
            [
              -99.60494,
              36.500036
            ],
            [
              -99.60558,
              36.464176
            ],
            [
              -99.6056,
              36.34701
            ],
            [
              -99.60479,
              36.246629
            ],
            [
              -99.59582,
              36.246701
            ],
            [
              -99.59596,
              36.164059
            ],
            [
              -99.50039,
              36.164645
            ],
            [
              -99.45336,
              36.163923
            ],
            [
              -99.38216,
              36.1643
            ],
            [
              -99.271381,
              36.164173
            ],
            [
              -99.245689,
              36.163407
            ],
            [
              -99.17194,
              36.162587
            ],
            [
              -99.12538,
              36.162257
            ],
            [
              -99.11726,
              36.162812
            ],
            [
              -99.07502,
              36.162376
            ],
            [
              -98.95586,
              36.161569
            ],
            [
              -98.95619,
              36.240433
            ],
            [
              -98.95594,
              36.24668
            ],
            [
              -98.96088,
              36.246772
            ],
            [
              -98.96093,
              36.319147
            ],
            [
              -98.96047,
              36.391248
            ],
            [
              -98.96057,
              36.496474
            ],
            [
              -98.96033,
              36.506914
            ],
            [
              -98.959973,
              36.598992
            ],
            [
              -98.971486,
              36.60032
            ],
            [
              -98.97609,
              36.603052
            ],
            [
              -98.989083,
              36.616004
            ],
            [
              -99.00027,
              36.629448
            ],
            [
              -99.010087,
              36.633268
            ],
            [
              -99.01296,
              36.640241
            ],
            [
              -99.02254,
              36.642434
            ],
            [
              -99.02479,
              36.652218
            ],
            [
              -99.02351,
              36.661131
            ],
            [
              -99.03226,
              36.665929
            ],
            [
              -99.03915,
              36.67371
            ],
            [
              -99.03993,
              36.678569
            ],
            [
              -99.0481,
              36.686468
            ],
            [
              -99.04435,
              36.694948
            ],
            [
              -99.06151,
              36.71545
            ],
            [
              -99.07569,
              36.716989
            ],
            [
              -99.08449,
              36.721582
            ],
            [
              -99.09572,
              36.736752
            ],
            [
              -99.09745,
              36.74206
            ],
            [
              -99.10675,
              36.74744
            ],
            [
              -99.10775,
              36.750448
            ],
            [
              -99.12656,
              36.762566
            ],
            [
              -99.12827,
              36.769411
            ],
            [
              -99.13985,
              36.78304
            ],
            [
              -99.1523,
              36.787624
            ],
            [
              -99.16666,
              36.790602
            ],
            [
              -99.18084,
              36.787411
            ],
            [
              -99.18909,
              36.787363
            ],
            [
              -99.19906,
              36.790885
            ],
            [
              -99.21056,
              36.79069
            ],
            [
              -99.21776,
              36.786811
            ],
            [
              -99.22983,
              36.788161
            ],
            [
              -99.25038,
              36.785015
            ],
            [
              -99.27022,
              36.789727
            ],
            [
              -99.27726,
              36.795818
            ],
            [
              -99.29426,
              36.805939
            ],
            [
              -99.29519,
              36.819566
            ]
          ]
        ]
      },
      "properties": {
        "county": "40153",
        "name": "Woodward"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -94.61808,
              36.667863
            ],
            [
              -94.68593,
              36.667718
            ],
            [
              -94.77924,
              36.667763
            ],
            [
              -94.78223,
              36.670622
            ],
            [
              -94.91392,
              36.670491
            ],
            [
              -94.99957,
              36.670684
            ],
            [
              -94.9996,
              36.597966
            ],
            [
              -95.00569,
              36.597445
            ],
            [
              -95.00572,
              36.509779
            ],
            [
              -95.00592,
              36.463133
            ],
            [
              -95.00561,
              36.353954
            ],
            [
              -95.00594,
              36.249547
            ],
            [
              -95.01138,
              36.249468
            ],
            [
              -95.01107,
              36.166926
            ],
            [
              -95.0113,
              36.161798
            ],
            [
              -94.95365,
              36.161439
            ],
            [
              -94.90986,
              36.161735
            ],
            [
              -94.79728,
              36.16139
            ],
            [
              -94.7559,
              36.161192
            ],
            [
              -94.74621,
              36.16162
            ],
            [
              -94.66347,
              36.161636
            ],
            [
              -94.5628,
              36.161749
            ],
            [
              -94.58022,
              36.26383
            ],
            [
              -94.59428,
              36.350937
            ],
            [
              -94.60198,
              36.40212
            ],
            [
              -94.606317,
              36.427168
            ],
            [
              -94.61383,
              36.476248
            ],
            [
              -94.61792,
              36.499414
            ],
            [
              -94.618,
              36.53428
            ],
            [
              -94.61771,
              36.624799
            ],
            [
              -94.61808,
              36.667863
            ]
          ]
        ]
      },
      "properties": {
        "county": "40041",
        "name": "Delaware"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.057415,
              36.593647
            ],
            [
              -97.11911,
              36.594041
            ],
            [
              -97.29003,
              36.593729
            ],
            [
              -97.3643,
              36.593568
            ],
            [
              -97.42641,
              36.593776
            ],
            [
              -97.46164,
              36.593454
            ],
            [
              -97.46148,
              36.534962
            ],
            [
              -97.4617,
              36.492941
            ],
            [
              -97.46141,
              36.376126
            ],
            [
              -97.46114,
              36.360972
            ],
            [
              -97.46131,
              36.246849
            ],
            [
              -97.46049,
              36.244882
            ],
            [
              -97.46074,
              36.164463
            ],
            [
              -97.35388,
              36.164292
            ],
            [
              -97.354009,
              36.159141
            ],
            [
              -97.31858,
              36.159056
            ],
            [
              -97.26454,
              36.159436
            ],
            [
              -97.230332,
              36.159144
            ],
            [
              -97.14076,
              36.159212
            ],
            [
              -97.1411,
              36.202867
            ],
            [
              -97.14107,
              36.246362
            ],
            [
              -97.00031,
              36.246607
            ],
            [
              -96.96579,
              36.246348
            ],
            [
              -96.92512,
              36.246533
            ],
            [
              -96.92506,
              36.275462
            ],
            [
              -96.92501,
              36.289928
            ],
            [
              -96.92506,
              36.326254
            ],
            [
              -96.92494,
              36.333258
            ],
            [
              -96.9336,
              36.333258
            ],
            [
              -96.94296,
              36.333258
            ],
            [
              -97.03209,
              36.333366
            ],
            [
              -97.03231,
              36.3585
            ],
            [
              -97.03209,
              36.420353
            ],
            [
              -97.03207,
              36.434544
            ],
            [
              -97.03203,
              36.457441
            ],
            [
              -97.03204,
              36.469542
            ],
            [
              -97.03202,
              36.482861
            ],
            [
              -97.032,
              36.487911
            ],
            [
              -97.03208,
              36.494941
            ],
            [
              -97.0322,
              36.507023
            ],
            [
              -97.0149,
              36.50695
            ],
            [
              -97.01276,
              36.50697
            ],
            [
              -97.01061,
              36.506944
            ],
            [
              -97.009785,
              36.506935
            ],
            [
              -97.00917,
              36.514292
            ],
            [
              -97.0083,
              36.516949
            ],
            [
              -97.000316,
              36.526465
            ],
            [
              -96.98815,
              36.532378
            ],
            [
              -96.97148,
              36.535956
            ],
            [
              -96.95852,
              36.534306
            ],
            [
              -96.949923,
              36.537302
            ],
            [
              -96.94398,
              36.543469
            ],
            [
              -96.930465,
              36.550369
            ],
            [
              -96.92621,
              36.552083
            ],
            [
              -96.91615,
              36.552997
            ],
            [
              -96.90679,
              36.552002
            ],
            [
              -96.89908,
              36.553224
            ],
            [
              -96.89037,
              36.563605
            ],
            [
              -96.88821,
              36.573407
            ],
            [
              -96.8883,
              36.57559
            ],
            [
              -96.90446,
              36.588944
            ],
            [
              -96.90645,
              36.592659
            ],
            [
              -96.90871,
              36.595792
            ],
            [
              -96.91277,
              36.598977
            ],
            [
              -96.92048,
              36.600664
            ],
            [
              -96.926431,
              36.599591
            ],
            [
              -96.93386,
              36.595472
            ],
            [
              -96.94157,
              36.594029
            ],
            [
              -96.9486,
              36.589981
            ],
            [
              -96.95559,
              36.589029
            ],
            [
              -96.96537,
              36.586892
            ],
            [
              -96.971,
              36.586058
            ],
            [
              -96.978595,
              36.585671
            ],
            [
              -96.98278,
              36.585684
            ],
            [
              -97.00168,
              36.582711
            ],
            [
              -97.00435,
              36.582604
            ],
            [
              -97.006738,
              36.582799
            ],
            [
              -97.01002,
              36.583194
            ],
            [
              -97.02529,
              36.584925
            ],
            [
              -97.02912,
              36.585208
            ],
            [
              -97.0419,
              36.588354
            ],
            [
              -97.045909,
              36.589414
            ],
            [
              -97.05704,
              36.593359
            ],
            [
              -97.057415,
              36.593647
            ]
          ]
        ]
      },
      "properties": {
        "county": "40103",
        "name": "Noble"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.605565,
              36.592753
            ],
            [
              -99.62539,
              36.593113
            ],
            [
              -99.67736,
              36.592981
            ],
            [
              -99.78448,
              36.593116
            ],
            [
              -99.83647,
              36.593299
            ],
            [
              -99.91528,
              36.593152
            ],
            [
              -99.944082,
              36.593443
            ],
            [
              -100.003,
              36.593195
            ],
            [
              -100.00379,
              36.514111
            ],
            [
              -100.00367,
              36.499642
            ],
            [
              -100.00041,
              36.499702
            ],
            [
              -100.0004,
              36.360965
            ],
            [
              -100.0004,
              36.260148
            ],
            [
              -100.0004,
              36.163706
            ],
            [
              -100.0004,
              36.043475
            ],
            [
              -100.0004,
              35.880948
            ],
            [
              -99.98544,
              35.884053
            ],
            [
              -99.97211,
              35.888776
            ],
            [
              -99.95616,
              35.901803
            ],
            [
              -99.94905,
              35.903909
            ],
            [
              -99.92515,
              35.913664
            ],
            [
              -99.91893,
              35.921812
            ],
            [
              -99.90839,
              35.928122
            ],
            [
              -99.9056,
              35.936727
            ],
            [
              -99.90705,
              35.942338
            ],
            [
              -99.91067,
              35.94444
            ],
            [
              -99.91253,
              35.954986
            ],
            [
              -99.91145,
              35.961924
            ],
            [
              -99.90827,
              35.966634
            ],
            [
              -99.89505,
              35.97712
            ],
            [
              -99.89337,
              35.985295
            ],
            [
              -99.888309,
              35.987847
            ],
            [
              -99.87539,
              35.987798
            ],
            [
              -99.86889,
              35.990927
            ],
            [
              -99.85501,
              36.003685
            ],
            [
              -99.8473,
              36.006078
            ],
            [
              -99.83795,
              36.006794
            ],
            [
              -99.823561,
              36.005529
            ],
            [
              -99.81381,
              36.003076
            ],
            [
              -99.80944,
              36.000044
            ],
            [
              -99.804919,
              35.988447
            ],
            [
              -99.80594,
              35.983823
            ],
            [
              -99.80229,
              35.971603
            ],
            [
              -99.80792,
              35.960342
            ],
            [
              -99.80971,
              35.945367
            ],
            [
              -99.80739,
              35.940548
            ],
            [
              -99.81047,
              35.933979
            ],
            [
              -99.81021,
              35.928889
            ],
            [
              -99.80231,
              35.920391
            ],
            [
              -99.80139,
              35.910645
            ],
            [
              -99.788712,
              35.903727
            ],
            [
              -99.78681,
              35.900413
            ],
            [
              -99.77929,
              35.896503
            ],
            [
              -99.777139,
              35.889103
            ],
            [
              -99.76702,
              35.882648
            ],
            [
              -99.76108,
              35.880745
            ],
            [
              -99.75329,
              35.882627
            ],
            [
              -99.74643,
              35.881962
            ],
            [
              -99.73838,
              35.875045
            ],
            [
              -99.729391,
              35.870293
            ],
            [
              -99.72258,
              35.862182
            ],
            [
              -99.7171,
              35.859769
            ],
            [
              -99.67782,
              35.851008
            ],
            [
              -99.66443,
              35.851806
            ],
            [
              -99.653183,
              35.850123
            ],
            [
              -99.63497,
              35.843104
            ],
            [
              -99.61767,
              35.84286
            ],
            [
              -99.61073,
              35.847555
            ],
            [
              -99.601773,
              35.855871
            ],
            [
              -99.57736,
              35.85959
            ],
            [
              -99.56191,
              35.863374
            ],
            [
              -99.55849,
              35.865988
            ],
            [
              -99.55505,
              35.878979
            ],
            [
              -99.54971,
              35.887218
            ],
            [
              -99.55193,
              35.894721
            ],
            [
              -99.54965,
              35.900114
            ],
            [
              -99.53587,
              35.908987
            ],
            [
              -99.524699,
              35.91987
            ],
            [
              -99.51531,
              35.925795
            ],
            [
              -99.50924,
              35.939224
            ],
            [
              -99.50894,
              35.945855
            ],
            [
              -99.50604,
              35.948902
            ],
            [
              -99.5054,
              35.957778
            ],
            [
              -99.496395,
              35.977689
            ],
            [
              -99.4855,
              35.98595
            ],
            [
              -99.47751,
              35.98564
            ],
            [
              -99.46993,
              35.991259
            ],
            [
              -99.463254,
              36.000045
            ],
            [
              -99.45281,
              36.005241
            ],
            [
              -99.42215,
              36.011926
            ],
            [
              -99.39951,
              36.011905
            ],
            [
              -99.38347,
              36.013668
            ],
            [
              -99.38102,
              36.012925
            ],
            [
              -99.382177,
              36.087462
            ],
            [
              -99.38216,
              36.1643
            ],
            [
              -99.45336,
              36.163923
            ],
            [
              -99.50039,
              36.164645
            ],
            [
              -99.59596,
              36.164059
            ],
            [
              -99.59582,
              36.246701
            ],
            [
              -99.60479,
              36.246629
            ],
            [
              -99.6056,
              36.34701
            ],
            [
              -99.60558,
              36.464176
            ],
            [
              -99.60494,
              36.500036
            ],
            [
              -99.605565,
              36.592753
            ]
          ]
        ]
      },
      "properties": {
        "county": "40045",
        "name": "Ellis"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.92512,
              36.246533
            ],
            [
              -96.96579,
              36.246348
            ],
            [
              -97.00031,
              36.246607
            ],
            [
              -97.14107,
              36.246362
            ],
            [
              -97.1411,
              36.202867
            ],
            [
              -97.14076,
              36.159212
            ],
            [
              -97.230332,
              36.159144
            ],
            [
              -97.26454,
              36.159436
            ],
            [
              -97.31858,
              36.159056
            ],
            [
              -97.354009,
              36.159141
            ],
            [
              -97.35371,
              36.130043
            ],
            [
              -97.35397,
              36.012604
            ],
            [
              -97.35387,
              35.984934
            ],
            [
              -97.33975,
              35.993673
            ],
            [
              -97.33411,
              36.004612
            ],
            [
              -97.32764,
              36.008574
            ],
            [
              -97.31913,
              36.011231
            ],
            [
              -97.30861,
              36.010986
            ],
            [
              -97.30052,
              36.009307
            ],
            [
              -97.2946,
              36.005562
            ],
            [
              -97.287467,
              35.996682
            ],
            [
              -97.28453,
              35.985448
            ],
            [
              -97.28614,
              35.980348
            ],
            [
              -97.27533,
              35.973102
            ],
            [
              -97.264812,
              35.973339
            ],
            [
              -97.24317,
              35.972182
            ],
            [
              -97.22119,
              35.964572
            ],
            [
              -97.20359,
              35.944795
            ],
            [
              -97.19264,
              35.941639
            ],
            [
              -97.17238,
              35.941006
            ],
            [
              -97.15915,
              35.944723
            ],
            [
              -97.14289,
              35.954219
            ],
            [
              -97.14071,
              35.951341
            ],
            [
              -97.14052,
              35.941817
            ],
            [
              -97.087244,
              35.942171
            ],
            [
              -97.02965,
              35.941894
            ],
            [
              -96.94504,
              35.942062
            ],
            [
              -96.891591,
              35.941357
            ],
            [
              -96.87397,
              35.942119
            ],
            [
              -96.76723,
              35.942103
            ],
            [
              -96.642286,
              35.941922
            ],
            [
              -96.6211,
              35.941519
            ],
            [
              -96.62115,
              35.962094
            ],
            [
              -96.62096,
              35.971766
            ],
            [
              -96.62126,
              35.978233
            ],
            [
              -96.62137,
              35.984263
            ],
            [
              -96.62177,
              35.995657
            ],
            [
              -96.62211,
              36.000592
            ],
            [
              -96.62276,
              36.033731
            ],
            [
              -96.62285,
              36.04696
            ],
            [
              -96.62278,
              36.058655
            ],
            [
              -96.62273,
              36.065702
            ],
            [
              -96.622537,
              36.112351
            ],
            [
              -96.62246,
              36.118448
            ],
            [
              -96.62144,
              36.159929
            ],
            [
              -96.6242,
              36.159935
            ],
            [
              -96.6253,
              36.159915
            ],
            [
              -96.64188,
              36.159831
            ],
            [
              -96.659808,
              36.159768
            ],
            [
              -96.66142,
              36.159676
            ],
            [
              -96.71183,
              36.159584
            ],
            [
              -96.72235,
              36.159537
            ],
            [
              -96.7358,
              36.159479
            ],
            [
              -96.74006,
              36.159472
            ],
            [
              -96.76638,
              36.159436
            ],
            [
              -96.78393,
              36.159258
            ],
            [
              -96.79229,
              36.159305
            ],
            [
              -96.80482,
              36.159078
            ],
            [
              -96.80648,
              36.159078
            ],
            [
              -96.81908,
              36.158917
            ],
            [
              -96.81897,
              36.181982
            ],
            [
              -96.818795,
              36.183592
            ],
            [
              -96.81881,
              36.183724
            ],
            [
              -96.81899,
              36.187849
            ],
            [
              -96.81882,
              36.20236
            ],
            [
              -96.81874,
              36.222247
            ],
            [
              -96.81888,
              36.223052
            ],
            [
              -96.818996,
              36.224883
            ],
            [
              -96.81852,
              36.231613
            ],
            [
              -96.81859,
              36.235512
            ],
            [
              -96.818968,
              36.246513
            ],
            [
              -96.86736,
              36.246497
            ],
            [
              -96.87011,
              36.246477
            ],
            [
              -96.88985,
              36.246419
            ],
            [
              -96.89127,
              36.24642
            ],
            [
              -96.89994,
              36.246429
            ],
            [
              -96.90733,
              36.246437
            ],
            [
              -96.908104,
              36.246475
            ],
            [
              -96.90853,
              36.246462
            ],
            [
              -96.92512,
              36.246533
            ]
          ]
        ]
      },
      "properties": {
        "county": "40119",
        "name": "Payne"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.46074,
              36.164463
            ],
            [
              -97.586,
              36.164749
            ],
            [
              -97.675712,
              36.164663
            ],
            [
              -97.67564,
              36.072767
            ],
            [
              -97.67585,
              36.043712
            ],
            [
              -97.67564,
              35.927484
            ],
            [
              -97.67454,
              35.898428
            ],
            [
              -97.67433,
              35.82772
            ],
            [
              -97.67392,
              35.725985
            ],
            [
              -97.66511,
              35.725985
            ],
            [
              -97.64237,
              35.725964
            ],
            [
              -97.56702,
              35.72585
            ],
            [
              -97.54942,
              35.72575
            ],
            [
              -97.51392,
              35.725551
            ],
            [
              -97.50296,
              35.725523
            ],
            [
              -97.49245,
              35.725422
            ],
            [
              -97.4864,
              35.725373
            ],
            [
              -97.48362,
              35.725351
            ],
            [
              -97.478218,
              35.725351
            ],
            [
              -97.46579,
              35.725284
            ],
            [
              -97.46008,
              35.725248
            ],
            [
              -97.44012,
              35.725172
            ],
            [
              -97.43872,
              35.725152
            ],
            [
              -97.42522,
              35.725152
            ],
            [
              -97.41952,
              35.725205
            ],
            [
              -97.41722,
              35.725153
            ],
            [
              -97.41292,
              35.725153
            ],
            [
              -97.40932,
              35.725253
            ],
            [
              -97.40732,
              35.725253
            ],
            [
              -97.40196,
              35.725253
            ],
            [
              -97.39976,
              35.725205
            ],
            [
              -97.38801,
              35.725163
            ],
            [
              -97.37151,
              35.725153
            ],
            [
              -97.36243,
              35.725238
            ],
            [
              -97.35768,
              35.725247
            ],
            [
              -97.35407,
              35.725254
            ],
            [
              -97.35365,
              35.725253
            ],
            [
              -97.33761,
              35.725154
            ],
            [
              -97.33621,
              35.725154
            ],
            [
              -97.32362,
              35.725154
            ],
            [
              -97.31841,
              35.725154
            ],
            [
              -97.30068,
              35.724999
            ],
            [
              -97.29668,
              35.725015
            ],
            [
              -97.2882,
              35.724995
            ],
            [
              -97.28553,
              35.724967
            ],
            [
              -97.28284,
              35.724969
            ],
            [
              -97.26503,
              35.724983
            ],
            [
              -97.23361,
              35.724904
            ],
            [
              -97.22501,
              35.724936
            ],
            [
              -97.22156,
              35.724876
            ],
            [
              -97.21212,
              35.724713
            ],
            [
              -97.19644,
              35.724537
            ],
            [
              -97.19437,
              35.724553
            ],
            [
              -97.18457,
              35.724537
            ],
            [
              -97.17673,
              35.724441
            ],
            [
              -97.16906,
              35.724442
            ],
            [
              -97.14952,
              35.724378
            ],
            [
              -97.140997,
              35.724442
            ],
            [
              -97.14137,
              35.778108
            ],
            [
              -97.14123,
              35.821926
            ],
            [
              -97.14178,
              35.875055
            ],
            [
              -97.14065,
              35.898366
            ],
            [
              -97.14052,
              35.941817
            ],
            [
              -97.14071,
              35.951341
            ],
            [
              -97.14289,
              35.954219
            ],
            [
              -97.15915,
              35.944723
            ],
            [
              -97.17238,
              35.941006
            ],
            [
              -97.19264,
              35.941639
            ],
            [
              -97.20359,
              35.944795
            ],
            [
              -97.22119,
              35.964572
            ],
            [
              -97.24317,
              35.972182
            ],
            [
              -97.264812,
              35.973339
            ],
            [
              -97.27533,
              35.973102
            ],
            [
              -97.28614,
              35.980348
            ],
            [
              -97.28453,
              35.985448
            ],
            [
              -97.287467,
              35.996682
            ],
            [
              -97.2946,
              36.005562
            ],
            [
              -97.30052,
              36.009307
            ],
            [
              -97.30861,
              36.010986
            ],
            [
              -97.31913,
              36.011231
            ],
            [
              -97.32764,
              36.008574
            ],
            [
              -97.33411,
              36.004612
            ],
            [
              -97.33975,
              35.993673
            ],
            [
              -97.35387,
              35.984934
            ],
            [
              -97.35397,
              36.012604
            ],
            [
              -97.35371,
              36.130043
            ],
            [
              -97.354009,
              36.159141
            ],
            [
              -97.35388,
              36.164292
            ],
            [
              -97.46074,
              36.164463
            ]
          ]
        ]
      },
      "properties": {
        "county": "40083",
        "name": "Logan"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -94.79728,
              36.16139
            ],
            [
              -94.90986,
              36.161735
            ],
            [
              -94.95365,
              36.161439
            ],
            [
              -95.0113,
              36.161798
            ],
            [
              -95.11846,
              36.161638
            ],
            [
              -95.117841,
              36.12859
            ],
            [
              -95.11837,
              36.118059
            ],
            [
              -95.118198,
              36.074431
            ],
            [
              -95.207946,
              36.074708
            ],
            [
              -95.20795,
              36.074578
            ],
            [
              -95.20792,
              36.060322
            ],
            [
              -95.20792,
              36.049953
            ],
            [
              -95.20797,
              36.039879
            ],
            [
              -95.22534,
              36.039841
            ],
            [
              -95.22547,
              36.0092
            ],
            [
              -95.23025,
              36.009261
            ],
            [
              -95.2303,
              36.002315
            ],
            [
              -95.23427,
              36.002282
            ],
            [
              -95.23444,
              35.991299
            ],
            [
              -95.23844,
              35.987999
            ],
            [
              -95.25219,
              35.987845
            ],
            [
              -95.25498,
              35.984933
            ],
            [
              -95.25778,
              35.982856
            ],
            [
              -95.27113,
              35.974524
            ],
            [
              -95.27761,
              35.966476
            ],
            [
              -95.27888,
              35.96233
            ],
            [
              -95.27856,
              35.961479
            ],
            [
              -95.27363,
              35.956198
            ],
            [
              -95.269691,
              35.946381
            ],
            [
              -95.26942,
              35.944111
            ],
            [
              -95.26936,
              35.943053
            ],
            [
              -95.26918,
              35.940946
            ],
            [
              -95.26898,
              35.939508
            ],
            [
              -95.26885,
              35.938353
            ],
            [
              -95.27001,
              35.92864
            ],
            [
              -95.27136,
              35.927617
            ],
            [
              -95.27662,
              35.923537
            ],
            [
              -95.27874,
              35.921233
            ],
            [
              -95.28292,
              35.912575
            ],
            [
              -95.28313,
              35.910039
            ],
            [
              -95.28156,
              35.904081
            ],
            [
              -95.27101,
              35.892704
            ],
            [
              -95.26863,
              35.890479
            ],
            [
              -95.26499,
              35.884004
            ],
            [
              -95.2577,
              35.877297
            ],
            [
              -95.25089,
              35.875636
            ],
            [
              -95.25024,
              35.875692
            ],
            [
              -95.23652,
              35.873958
            ],
            [
              -95.22934,
              35.869053
            ],
            [
              -95.2275,
              35.862166
            ],
            [
              -95.23146,
              35.851195
            ],
            [
              -95.23723,
              35.847884
            ],
            [
              -95.25317,
              35.832486
            ],
            [
              -95.25248,
              35.828405
            ],
            [
              -95.25568,
              35.82468
            ],
            [
              -95.2665,
              35.820442
            ],
            [
              -95.26568,
              35.813266
            ],
            [
              -95.2543,
              35.813271
            ],
            [
              -95.25221,
              35.813269
            ],
            [
              -95.25024,
              35.813268
            ],
            [
              -95.24535,
              35.81308
            ],
            [
              -95.24011,
              35.813093
            ],
            [
              -95.23883,
              35.813096
            ],
            [
              -95.23605,
              35.813103
            ],
            [
              -95.23552,
              35.813105
            ],
            [
              -95.23194,
              35.813106
            ],
            [
              -95.22935,
              35.813103
            ],
            [
              -95.22239,
              35.813096
            ],
            [
              -95.21852,
              35.813092
            ],
            [
              -95.21668,
              35.813091
            ],
            [
              -95.21401,
              35.81308
            ],
            [
              -95.20679,
              35.813054
            ],
            [
              -95.19889,
              35.813025
            ],
            [
              -95.18894,
              35.813012
            ],
            [
              -95.18577,
              35.813008
            ],
            [
              -95.18089,
              35.813003
            ],
            [
              -95.17208,
              35.812979
            ],
            [
              -95.16332,
              35.812931
            ],
            [
              -95.15452,
              35.812896
            ],
            [
              -95.13624,
              35.812826
            ],
            [
              -95.13171,
              35.812814
            ],
            [
              -95.12751,
              35.812805
            ],
            [
              -95.12753,
              35.805744
            ],
            [
              -95.12755,
              35.797857
            ],
            [
              -95.12757,
              35.792709
            ],
            [
              -95.12764,
              35.784968
            ],
            [
              -95.12765,
              35.783916
            ],
            [
              -95.12767,
              35.776211
            ],
            [
              -95.1277,
              35.768532
            ],
            [
              -95.1276,
              35.764504
            ],
            [
              -95.12753,
              35.750096
            ],
            [
              -95.1275,
              35.716626
            ],
            [
              -95.12736,
              35.683043
            ],
            [
              -95.12753,
              35.673105
            ],
            [
              -95.12781,
              35.654767
            ],
            [
              -95.12746,
              35.638894
            ],
            [
              -95.100936,
              35.638783
            ],
            [
              -95.07883,
              35.638695
            ],
            [
              -95.056,
              35.638777
            ],
            [
              -95.05498,
              35.638781
            ],
            [
              -95.05327,
              35.638787
            ],
            [
              -95.05113,
              35.638795
            ],
            [
              -95.02741,
              35.638553
            ],
            [
              -95.019194,
              35.638467
            ],
            [
              -95.00055,
              35.638383
            ],
            [
              -94.99162,
              35.638374
            ],
            [
              -94.99146,
              35.638374
            ],
            [
              -94.973231,
              35.638318
            ],
            [
              -94.95549,
              35.638541
            ],
            [
              -94.944038,
              35.638777
            ],
            [
              -94.94157,
              35.638617
            ],
            [
              -94.937082,
              35.638569
            ],
            [
              -94.911921,
              35.638594
            ],
            [
              -94.910399,
              35.638644
            ],
            [
              -94.903681,
              35.638726
            ],
            [
              -94.839394,
              35.638661
            ],
            [
              -94.828956,
              35.638617
            ],
            [
              -94.80822,
              35.638605
            ],
            [
              -94.8073,
              35.638604
            ],
            [
              -94.80753,
              35.660896
            ],
            [
              -94.80775,
              35.682198
            ],
            [
              -94.80779,
              35.750089
            ],
            [
              -94.80736,
              35.762925
            ],
            [
              -94.80755,
              35.797825
            ],
            [
              -94.807218,
              35.871053
            ],
            [
              -94.80733,
              35.900926
            ],
            [
              -94.79721,
              35.90088
            ],
            [
              -94.79732,
              36.007973
            ],
            [
              -94.79727,
              36.113105
            ],
            [
              -94.79687,
              36.125156
            ],
            [
              -94.79728,
              36.16139
            ]
          ]
        ]
      },
      "properties": {
        "county": "40021",
        "name": "Cherokee"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.38102,
              36.012925
            ],
            [
              -99.38347,
              36.013668
            ],
            [
              -99.39951,
              36.011905
            ],
            [
              -99.42215,
              36.011926
            ],
            [
              -99.45281,
              36.005241
            ],
            [
              -99.463254,
              36.000045
            ],
            [
              -99.46993,
              35.991259
            ],
            [
              -99.47751,
              35.98564
            ],
            [
              -99.4855,
              35.98595
            ],
            [
              -99.496395,
              35.977689
            ],
            [
              -99.5054,
              35.957778
            ],
            [
              -99.50604,
              35.948902
            ],
            [
              -99.50894,
              35.945855
            ],
            [
              -99.50924,
              35.939224
            ],
            [
              -99.51531,
              35.925795
            ],
            [
              -99.524699,
              35.91987
            ],
            [
              -99.53587,
              35.908987
            ],
            [
              -99.54965,
              35.900114
            ],
            [
              -99.55193,
              35.894721
            ],
            [
              -99.54971,
              35.887218
            ],
            [
              -99.55505,
              35.878979
            ],
            [
              -99.55849,
              35.865988
            ],
            [
              -99.56191,
              35.863374
            ],
            [
              -99.57736,
              35.85959
            ],
            [
              -99.601773,
              35.855871
            ],
            [
              -99.61073,
              35.847555
            ],
            [
              -99.61767,
              35.84286
            ],
            [
              -99.63497,
              35.843104
            ],
            [
              -99.653183,
              35.850123
            ],
            [
              -99.66443,
              35.851806
            ],
            [
              -99.67782,
              35.851008
            ],
            [
              -99.7171,
              35.859769
            ],
            [
              -99.72258,
              35.862182
            ],
            [
              -99.729391,
              35.870293
            ],
            [
              -99.73838,
              35.875045
            ],
            [
              -99.74643,
              35.881962
            ],
            [
              -99.75329,
              35.882627
            ],
            [
              -99.76108,
              35.880745
            ],
            [
              -99.76702,
              35.882648
            ],
            [
              -99.777139,
              35.889103
            ],
            [
              -99.77929,
              35.896503
            ],
            [
              -99.78681,
              35.900413
            ],
            [
              -99.788712,
              35.903727
            ],
            [
              -99.80139,
              35.910645
            ],
            [
              -99.80231,
              35.920391
            ],
            [
              -99.81021,
              35.928889
            ],
            [
              -99.81047,
              35.933979
            ],
            [
              -99.80739,
              35.940548
            ],
            [
              -99.80971,
              35.945367
            ],
            [
              -99.80792,
              35.960342
            ],
            [
              -99.80229,
              35.971603
            ],
            [
              -99.80594,
              35.983823
            ],
            [
              -99.804919,
              35.988447
            ],
            [
              -99.80944,
              36.000044
            ],
            [
              -99.81381,
              36.003076
            ],
            [
              -99.823561,
              36.005529
            ],
            [
              -99.83795,
              36.006794
            ],
            [
              -99.8473,
              36.006078
            ],
            [
              -99.85501,
              36.003685
            ],
            [
              -99.86889,
              35.990927
            ],
            [
              -99.87539,
              35.987798
            ],
            [
              -99.888309,
              35.987847
            ],
            [
              -99.89337,
              35.985295
            ],
            [
              -99.89505,
              35.97712
            ],
            [
              -99.90827,
              35.966634
            ],
            [
              -99.91145,
              35.961924
            ],
            [
              -99.91253,
              35.954986
            ],
            [
              -99.91067,
              35.94444
            ],
            [
              -99.90705,
              35.942338
            ],
            [
              -99.9056,
              35.936727
            ],
            [
              -99.90839,
              35.928122
            ],
            [
              -99.91893,
              35.921812
            ],
            [
              -99.92515,
              35.913664
            ],
            [
              -99.94905,
              35.903909
            ],
            [
              -99.95616,
              35.901803
            ],
            [
              -99.97211,
              35.888776
            ],
            [
              -99.98544,
              35.884053
            ],
            [
              -100.0004,
              35.880948
            ],
            [
              -100.00039,
              35.761228
            ],
            [
              -100.000392,
              35.588653
            ],
            [
              -100.000389,
              35.42234
            ],
            [
              -99.929381,
              35.422428
            ],
            [
              -99.80597,
              35.422198
            ],
            [
              -99.75038,
              35.422297
            ],
            [
              -99.6996,
              35.421694
            ],
            [
              -99.61125,
              35.421547
            ],
            [
              -99.57572,
              35.421693
            ],
            [
              -99.57596,
              35.500049
            ],
            [
              -99.5756,
              35.50895
            ],
            [
              -99.5188,
              35.508644
            ],
            [
              -99.49082,
              35.50912
            ],
            [
              -99.3641,
              35.508825
            ],
            [
              -99.36399,
              35.551675
            ],
            [
              -99.37695,
              35.551739
            ],
            [
              -99.37691,
              35.678572
            ],
            [
              -99.37662,
              35.740085
            ],
            [
              -99.37603,
              35.81218
            ],
            [
              -99.37583,
              35.898754
            ],
            [
              -99.38108,
              35.898831
            ],
            [
              -99.380798,
              35.910555
            ],
            [
              -99.38102,
              36.012925
            ]
          ]
        ]
      },
      "properties": {
        "county": "40129",
        "name": "Roger Mills"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.44139,
              35.290095
            ],
            [
              -96.44137,
              35.402002
            ],
            [
              -96.44129,
              35.467673
            ],
            [
              -96.4464,
              35.458442
            ],
            [
              -96.45264,
              35.45819
            ],
            [
              -96.45921,
              35.461394
            ],
            [
              -96.46548,
              35.458096
            ],
            [
              -96.47407,
              35.463954
            ],
            [
              -96.48131,
              35.453605
            ],
            [
              -96.486765,
              35.449987
            ],
            [
              -96.48816,
              35.445958
            ],
            [
              -96.48307,
              35.442618
            ],
            [
              -96.48762,
              35.432522
            ],
            [
              -96.49755,
              35.428627
            ],
            [
              -96.51849,
              35.430987
            ],
            [
              -96.52213,
              35.43877
            ],
            [
              -96.53253,
              35.446167
            ],
            [
              -96.544999,
              35.452602
            ],
            [
              -96.5528,
              35.454021
            ],
            [
              -96.55384,
              35.448025
            ],
            [
              -96.561448,
              35.447477
            ],
            [
              -96.56931,
              35.438985
            ],
            [
              -96.56469,
              35.436032
            ],
            [
              -96.55602,
              35.434795
            ],
            [
              -96.56083,
              35.42239
            ],
            [
              -96.555158,
              35.422962
            ],
            [
              -96.547917,
              35.417879
            ],
            [
              -96.54669,
              35.412683
            ],
            [
              -96.537545,
              35.411308
            ],
            [
              -96.53752,
              35.403641
            ],
            [
              -96.53201,
              35.39952
            ],
            [
              -96.53708,
              35.390663
            ],
            [
              -96.5413,
              35.392655
            ],
            [
              -96.55058,
              35.39229
            ],
            [
              -96.55689,
              35.395083
            ],
            [
              -96.55661,
              35.40259
            ],
            [
              -96.56612,
              35.399386
            ],
            [
              -96.57663,
              35.402132
            ],
            [
              -96.58077,
              35.409113
            ],
            [
              -96.59005,
              35.41124
            ],
            [
              -96.59617,
              35.400412
            ],
            [
              -96.60405,
              35.399425
            ],
            [
              -96.61163,
              35.394386
            ],
            [
              -96.61733,
              35.395872
            ],
            [
              -96.6237,
              35.400956
            ],
            [
              -96.62996,
              35.393143
            ],
            [
              -96.637727,
              35.397793
            ],
            [
              -96.64301,
              35.393881
            ],
            [
              -96.65227,
              35.391755
            ],
            [
              -96.65442,
              35.395579
            ],
            [
              -96.66152,
              35.395512
            ],
            [
              -96.66535,
              35.399015
            ],
            [
              -96.67454,
              35.400457
            ],
            [
              -96.682988,
              35.405952
            ],
            [
              -96.69003,
              35.403823
            ],
            [
              -96.69302,
              35.408974
            ],
            [
              -96.70052,
              35.409523
            ],
            [
              -96.70208,
              35.415657
            ],
            [
              -96.711341,
              35.415702
            ],
            [
              -96.71674,
              35.418127
            ],
            [
              -96.72166,
              35.424604
            ],
            [
              -96.73201,
              35.423227
            ],
            [
              -96.73735,
              35.420135
            ],
            [
              -96.73637,
              35.415237
            ],
            [
              -96.74162,
              35.414525
            ],
            [
              -96.740055,
              35.409215
            ],
            [
              -96.74296,
              35.40681
            ],
            [
              -96.767483,
              35.408955
            ],
            [
              -96.7677,
              35.40951
            ],
            [
              -96.77056,
              35.407146
            ],
            [
              -96.7767,
              35.411374
            ],
            [
              -96.77662,
              35.354476
            ],
            [
              -96.777117,
              35.289668
            ],
            [
              -96.77682,
              35.268149
            ],
            [
              -96.77692,
              35.173724
            ],
            [
              -96.7756,
              35.130355
            ],
            [
              -96.77528,
              35.028913
            ],
            [
              -96.77578,
              34.956661
            ],
            [
              -96.77568,
              34.899958
            ],
            [
              -96.76065,
              34.90084
            ],
            [
              -96.75552,
              34.899809
            ],
            [
              -96.748793,
              34.890283
            ],
            [
              -96.74719,
              34.881783
            ],
            [
              -96.74209,
              34.869383
            ],
            [
              -96.73249,
              34.858884
            ],
            [
              -96.72289,
              34.856784
            ],
            [
              -96.715292,
              34.858684
            ],
            [
              -96.69418,
              34.868495
            ],
            [
              -96.68729,
              34.880984
            ],
            [
              -96.6863,
              34.888548
            ],
            [
              -96.68919,
              34.895583
            ],
            [
              -96.69569,
              34.903614
            ],
            [
              -96.70353,
              34.909305
            ],
            [
              -96.71129,
              34.911913
            ],
            [
              -96.71149,
              34.916283
            ],
            [
              -96.706493,
              34.923983
            ],
            [
              -96.699493,
              34.930282
            ],
            [
              -96.69197,
              34.933312
            ],
            [
              -96.68161,
              34.93286
            ],
            [
              -96.66769,
              34.929583
            ],
            [
              -96.65799,
              34.920983
            ],
            [
              -96.65309,
              34.910383
            ],
            [
              -96.64699,
              34.902184
            ],
            [
              -96.63369,
              34.898584
            ],
            [
              -96.61319,
              34.900484
            ],
            [
              -96.59579,
              34.905984
            ],
            [
              -96.57709,
              34.916584
            ],
            [
              -96.56409,
              34.917284
            ],
            [
              -96.556889,
              34.914184
            ],
            [
              -96.55529,
              34.907484
            ],
            [
              -96.55589,
              34.898085
            ],
            [
              -96.549579,
              34.887112
            ],
            [
              -96.54376,
              34.880097
            ],
            [
              -96.52859,
              34.869586
            ],
            [
              -96.51699,
              34.871586
            ],
            [
              -96.51219,
              34.875986
            ],
            [
              -96.50619,
              34.886485
            ],
            [
              -96.50029,
              34.893465
            ],
            [
              -96.49799,
              34.902685
            ],
            [
              -96.49079,
              34.910585
            ],
            [
              -96.49067,
              35.078323
            ],
            [
              -96.49043,
              35.11592
            ],
            [
              -96.44135,
              35.115792
            ],
            [
              -96.44116,
              35.144932
            ],
            [
              -96.44139,
              35.290095
            ]
          ]
        ]
      },
      "properties": {
        "county": "40133",
        "name": "Seminole"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.36432,
              35.465381
            ],
            [
              -99.36459,
              35.363882
            ],
            [
              -99.36455,
              35.305867
            ],
            [
              -99.36481,
              35.276872
            ],
            [
              -99.36429,
              35.204437
            ],
            [
              -99.36008,
              35.204393
            ],
            [
              -99.36008,
              35.116684
            ],
            [
              -99.19234,
              35.11651
            ],
            [
              -99.09588,
              35.116483
            ],
            [
              -98.92023,
              35.116373
            ],
            [
              -98.750344,
              35.116343
            ],
            [
              -98.73837,
              35.10686
            ],
            [
              -98.733107,
              35.110893
            ],
            [
              -98.716775,
              35.113349
            ],
            [
              -98.71691,
              35.108906
            ],
            [
              -98.71245,
              35.104761
            ],
            [
              -98.70351,
              35.110511
            ],
            [
              -98.696315,
              35.111909
            ],
            [
              -98.6918,
              35.10884
            ],
            [
              -98.683215,
              35.107856
            ],
            [
              -98.67499,
              35.108955
            ],
            [
              -98.67223,
              35.119009
            ],
            [
              -98.66261,
              35.118115
            ],
            [
              -98.65924,
              35.12187
            ],
            [
              -98.64845,
              35.122234
            ],
            [
              -98.65043,
              35.114836
            ],
            [
              -98.64564,
              35.111605
            ],
            [
              -98.64121,
              35.113275
            ],
            [
              -98.63892,
              35.123169
            ],
            [
              -98.62997,
              35.116385
            ],
            [
              -98.62934,
              35.110361
            ],
            [
              -98.62591,
              35.109191
            ],
            [
              -98.62534,
              35.102378
            ],
            [
              -98.62105,
              35.097352
            ],
            [
              -98.61801,
              35.101703
            ],
            [
              -98.61789,
              35.204165
            ],
            [
              -98.62375,
              35.204231
            ],
            [
              -98.62373,
              35.250055
            ],
            [
              -98.6233,
              35.306831
            ],
            [
              -98.62323,
              35.464419
            ],
            [
              -98.72914,
              35.464359
            ],
            [
              -98.81803,
              35.464869
            ],
            [
              -98.95847,
              35.465209
            ],
            [
              -99.0639,
              35.465279
            ],
            [
              -99.103567,
              35.465111
            ],
            [
              -99.1989,
              35.465619
            ],
            [
              -99.36432,
              35.465381
            ]
          ]
        ]
      },
      "properties": {
        "county": "40149",
        "name": "Washita"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.04993,
              35.458894
            ],
            [
              -95.05423,
              35.457095
            ],
            [
              -95.05533,
              35.456595
            ],
            [
              -95.056433,
              35.456157
            ],
            [
              -95.06211,
              35.453299
            ],
            [
              -95.06453,
              35.451795
            ],
            [
              -95.06586,
              35.450973
            ],
            [
              -95.06813,
              35.449472
            ],
            [
              -95.06951,
              35.448137
            ],
            [
              -95.07053,
              35.447096
            ],
            [
              -95.07653,
              35.437996
            ],
            [
              -95.07803,
              35.435696
            ],
            [
              -95.07933,
              35.433896
            ],
            [
              -95.08043,
              35.431896
            ],
            [
              -95.08103,
              35.423096
            ],
            [
              -95.08128,
              35.421516
            ],
            [
              -95.08374,
              35.410496
            ],
            [
              -95.08524,
              35.407196
            ],
            [
              -95.08694,
              35.404996
            ],
            [
              -95.10184,
              35.397596
            ],
            [
              -95.10264,
              35.396896
            ],
            [
              -95.10334,
              35.396096
            ],
            [
              -95.10484,
              35.394396
            ],
            [
              -95.10864,
              35.388396
            ],
            [
              -95.10994,
              35.386696
            ],
            [
              -95.11061,
              35.385556
            ],
            [
              -95.11284,
              35.381396
            ],
            [
              -95.11491,
              35.378607
            ],
            [
              -95.11574,
              35.377596
            ],
            [
              -95.11804,
              35.375396
            ],
            [
              -95.11834,
              35.375096
            ],
            [
              -95.12328,
              35.372324
            ],
            [
              -95.12478,
              35.373605
            ],
            [
              -95.13274,
              35.379996
            ],
            [
              -95.13814,
              35.380196
            ],
            [
              -95.140239,
              35.379596
            ],
            [
              -95.16077,
              35.369358
            ],
            [
              -95.159611,
              35.365224
            ],
            [
              -95.15479,
              35.362536
            ],
            [
              -95.15343,
              35.362326
            ],
            [
              -95.14891,
              35.361699
            ],
            [
              -95.14746,
              35.361163
            ],
            [
              -95.1413,
              35.355565
            ],
            [
              -95.14167,
              35.354887
            ],
            [
              -95.14423,
              35.348627
            ],
            [
              -95.146059,
              35.346757
            ],
            [
              -95.1505,
              35.345871
            ],
            [
              -95.15783,
              35.350936
            ],
            [
              -95.17038,
              35.352726
            ],
            [
              -95.17496,
              35.350554
            ],
            [
              -95.18185,
              35.341878
            ],
            [
              -95.18255,
              35.336857
            ],
            [
              -95.17679,
              35.327538
            ],
            [
              -95.17604,
              35.326019
            ],
            [
              -95.17118,
              35.315426
            ],
            [
              -95.171763,
              35.305553
            ],
            [
              -95.17859,
              35.30101
            ],
            [
              -95.18794,
              35.304949
            ],
            [
              -95.19919,
              35.303592
            ],
            [
              -95.2028,
              35.299384
            ],
            [
              -95.20538,
              35.289418
            ],
            [
              -95.20941,
              35.28382
            ],
            [
              -95.21987,
              35.274452
            ],
            [
              -95.22103,
              35.273254
            ],
            [
              -95.2226,
              35.271722
            ],
            [
              -95.22609,
              35.2692
            ],
            [
              -95.23134,
              35.265927
            ],
            [
              -95.243809,
              35.261636
            ],
            [
              -95.25698,
              35.265766
            ],
            [
              -95.26485,
              35.272497
            ],
            [
              -95.26565,
              35.273297
            ],
            [
              -95.26645,
              35.274297
            ],
            [
              -95.27381,
              35.283057
            ],
            [
              -95.27495,
              35.284097
            ],
            [
              -95.28905,
              35.295497
            ],
            [
              -95.28965,
              35.295797
            ],
            [
              -95.29735,
              35.299597
            ],
            [
              -95.29855,
              35.300397
            ],
            [
              -95.30545,
              35.302297
            ],
            [
              -95.30755,
              35.302497
            ],
            [
              -95.31667,
              35.30209
            ],
            [
              -95.33195,
              35.298797
            ],
            [
              -95.33845,
              35.296297
            ],
            [
              -95.33965,
              35.295697
            ],
            [
              -95.34025,
              35.295297
            ],
            [
              -95.34085,
              35.294897
            ],
            [
              -95.34465,
              35.293097
            ],
            [
              -95.35265,
              35.292197
            ],
            [
              -95.35325,
              35.301697
            ],
            [
              -95.35735,
              35.306097
            ],
            [
              -95.37105,
              35.313797
            ],
            [
              -95.38575,
              35.326097
            ],
            [
              -95.39375,
              35.327597
            ],
            [
              -95.411153,
              35.323397
            ],
            [
              -95.41685,
              35.318297
            ],
            [
              -95.427054,
              35.305497
            ],
            [
              -95.43265,
              35.301797
            ],
            [
              -95.45125,
              35.296019
            ],
            [
              -95.45076,
              35.202797
            ],
            [
              -95.45536,
              35.202697
            ],
            [
              -95.45496,
              35.160412
            ],
            [
              -95.43786,
              35.160214
            ],
            [
              -95.349351,
              35.160297
            ],
            [
              -95.34904,
              35.091313
            ],
            [
              -95.34941,
              35.05828
            ],
            [
              -95.254847,
              35.057898
            ],
            [
              -95.15844,
              35.057897
            ],
            [
              -95.09914,
              35.057497
            ],
            [
              -95.00023,
              35.057847
            ],
            [
              -94.98258,
              35.057946
            ],
            [
              -94.95439,
              35.058117
            ],
            [
              -94.940126,
              35.058204
            ],
            [
              -94.92786,
              35.058279
            ],
            [
              -94.92787,
              35.064815
            ],
            [
              -94.92793,
              35.076168
            ],
            [
              -94.92793,
              35.076347
            ],
            [
              -94.927973,
              35.119877
            ],
            [
              -94.92797,
              35.120119
            ],
            [
              -94.928035,
              35.125613
            ],
            [
              -94.928053,
              35.150692
            ],
            [
              -94.928056,
              35.1519
            ],
            [
              -94.92803,
              35.155353
            ],
            [
              -94.92811,
              35.175135
            ],
            [
              -94.927941,
              35.202564
            ],
            [
              -94.88981,
              35.202556
            ],
            [
              -94.889559,
              35.202487
            ],
            [
              -94.874176,
              35.202485
            ],
            [
              -94.836968,
              35.202264
            ],
            [
              -94.81973,
              35.202381
            ],
            [
              -94.81428,
              35.202331
            ],
            [
              -94.81428,
              35.20554
            ],
            [
              -94.8143,
              35.209887
            ],
            [
              -94.814625,
              35.216417
            ],
            [
              -94.81443,
              35.223858
            ],
            [
              -94.81439,
              35.242214
            ],
            [
              -94.814416,
              35.250096
            ],
            [
              -94.81424,
              35.267573
            ],
            [
              -94.814178,
              35.275063
            ],
            [
              -94.81376,
              35.312849
            ],
            [
              -94.81363,
              35.323249
            ],
            [
              -94.81726,
              35.323867
            ],
            [
              -94.82068,
              35.325889
            ],
            [
              -94.825099,
              35.331867
            ],
            [
              -94.82746,
              35.337412
            ],
            [
              -94.82901,
              35.346798
            ],
            [
              -94.82897,
              35.361546
            ],
            [
              -94.831227,
              35.365549
            ],
            [
              -94.83854,
              35.370203
            ],
            [
              -94.84518,
              35.370785
            ],
            [
              -94.84766,
              35.369784
            ],
            [
              -94.84968,
              35.368574
            ],
            [
              -94.85406,
              35.364117
            ],
            [
              -94.868941,
              35.355564
            ],
            [
              -94.875228,
              35.354322
            ],
            [
              -94.8824,
              35.352479
            ],
            [
              -94.888236,
              35.35109
            ],
            [
              -94.892824,
              35.349807
            ],
            [
              -94.90198,
              35.346709
            ],
            [
              -94.908063,
              35.346424
            ],
            [
              -94.91192,
              35.346651
            ],
            [
              -94.91445,
              35.347525
            ],
            [
              -94.91663,
              35.348731
            ],
            [
              -94.91871,
              35.350414
            ],
            [
              -94.919579,
              35.353317
            ],
            [
              -94.91703,
              35.356686
            ],
            [
              -94.90587,
              35.364832
            ],
            [
              -94.89462,
              35.373007
            ],
            [
              -94.8923,
              35.384345
            ],
            [
              -94.89627,
              35.391773
            ],
            [
              -94.90183,
              35.39794
            ],
            [
              -94.90468,
              35.398838
            ],
            [
              -94.90482,
              35.398821
            ],
            [
              -94.90815,
              35.398381
            ],
            [
              -94.91114,
              35.397183
            ],
            [
              -94.91704,
              35.393763
            ],
            [
              -94.92049,
              35.393104
            ],
            [
              -94.92574,
              35.392845
            ],
            [
              -94.92889,
              35.39342
            ],
            [
              -94.93137,
              35.394593
            ],
            [
              -94.93414,
              35.395483
            ],
            [
              -94.93852,
              35.396595
            ],
            [
              -94.946491,
              35.404888
            ],
            [
              -94.94886,
              35.407266
            ],
            [
              -94.95133,
              35.408334
            ],
            [
              -94.965956,
              35.406716
            ],
            [
              -94.971475,
              35.407099
            ],
            [
              -94.98683,
              35.40838
            ],
            [
              -95.00651,
              35.4146
            ],
            [
              -95.015432,
              35.421695
            ],
            [
              -95.021533,
              35.426795
            ],
            [
              -95.022833,
              35.428695
            ],
            [
              -95.02423,
              35.431395
            ],
            [
              -95.02333,
              35.448495
            ],
            [
              -95.025433,
              35.453395
            ],
            [
              -95.037833,
              35.456895
            ],
            [
              -95.046234,
              35.457495
            ],
            [
              -95.047534,
              35.457995
            ],
            [
              -95.04993,
              35.458894
            ]
          ]
        ]
      },
      "properties": {
        "county": "40061",
        "name": "Haskell"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.09596,
              35.377726
            ],
            [
              -98.09489,
              35.276249
            ],
            [
              -98.09488,
              35.203719
            ],
            [
              -98.091257,
              35.203651
            ],
            [
              -98.09113,
              35.088684
            ],
            [
              -98.09297,
              35.087951
            ],
            [
              -98.09309,
              35.028611
            ],
            [
              -98.09288,
              34.985032
            ],
            [
              -98.09336,
              34.970626
            ],
            [
              -98.092777,
              34.941633
            ],
            [
              -98.09293,
              34.912753
            ],
            [
              -98.09264,
              34.854919
            ],
            [
              -98.08956,
              34.854929
            ],
            [
              -98.08901,
              34.837616
            ],
            [
              -98.08931,
              34.796597
            ],
            [
              -98.08908,
              34.768083
            ],
            [
              -98.08908,
              34.681106
            ],
            [
              -97.9672,
              34.681748
            ],
            [
              -97.86161,
              34.681467
            ],
            [
              -97.76137,
              34.681253
            ],
            [
              -97.668431,
              34.681339
            ],
            [
              -97.667984,
              34.820511
            ],
            [
              -97.668,
              34.855137
            ],
            [
              -97.67084,
              34.855217
            ],
            [
              -97.67036,
              34.898723
            ],
            [
              -97.67048,
              35.005835
            ],
            [
              -97.67056,
              35.116809
            ],
            [
              -97.67043,
              35.203655
            ],
            [
              -97.67094,
              35.203678
            ],
            [
              -97.6708,
              35.324253
            ],
            [
              -97.67144,
              35.333901
            ],
            [
              -97.67158,
              35.334285
            ],
            [
              -97.67159,
              35.335934
            ],
            [
              -97.680243,
              35.335785
            ],
            [
              -97.68672,
              35.333837
            ],
            [
              -97.69587,
              35.327709
            ],
            [
              -97.71137,
              35.324861
            ],
            [
              -97.71771,
              35.329466
            ],
            [
              -97.72808,
              35.325288
            ],
            [
              -97.73891,
              35.324525
            ],
            [
              -97.75109,
              35.331308
            ],
            [
              -97.75464,
              35.337196
            ],
            [
              -97.76498,
              35.342476
            ],
            [
              -97.77998,
              35.342012
            ],
            [
              -97.79648,
              35.339083
            ],
            [
              -97.80707,
              35.340539
            ],
            [
              -97.81434,
              35.333947
            ],
            [
              -97.83311,
              35.335051
            ],
            [
              -97.84338,
              35.334059
            ],
            [
              -97.85597,
              35.342139
            ],
            [
              -97.86378,
              35.361394
            ],
            [
              -97.870017,
              35.362354
            ],
            [
              -97.88269,
              35.349792
            ],
            [
              -97.890346,
              35.35079
            ],
            [
              -97.891546,
              35.347062
            ],
            [
              -97.89747,
              35.345664
            ],
            [
              -97.90695,
              35.351081
            ],
            [
              -97.90929,
              35.355297
            ],
            [
              -97.91942,
              35.354333
            ],
            [
              -97.92785,
              35.35986
            ],
            [
              -97.930806,
              35.36378
            ],
            [
              -97.93259,
              35.373398
            ],
            [
              -97.94277,
              35.37723
            ],
            [
              -97.94582,
              35.375477
            ],
            [
              -97.94677,
              35.359543
            ],
            [
              -97.9499,
              35.352009
            ],
            [
              -97.95848,
              35.347748
            ],
            [
              -97.96413,
              35.348869
            ],
            [
              -97.975981,
              35.357386
            ],
            [
              -97.98406,
              35.360177
            ],
            [
              -97.99905,
              35.361155
            ],
            [
              -98.01006,
              35.364554
            ],
            [
              -98.01324,
              35.372825
            ],
            [
              -98.02075,
              35.377526
            ],
            [
              -98.03414,
              35.377911
            ],
            [
              -98.09596,
              35.377726
            ]
          ]
        ]
      },
      "properties": {
        "county": "40051",
        "name": "Grady"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.45125,
              35.296019
            ],
            [
              -95.461656,
              35.292997
            ],
            [
              -95.48006,
              35.298497
            ],
            [
              -95.49206,
              35.300897
            ],
            [
              -95.50036,
              35.300897
            ],
            [
              -95.50756,
              35.296897
            ],
            [
              -95.51196,
              35.289097
            ],
            [
              -95.51666,
              35.284997
            ],
            [
              -95.51906,
              35.279497
            ],
            [
              -95.51296,
              35.266097
            ],
            [
              -95.51596,
              35.262697
            ],
            [
              -95.52166,
              35.262397
            ],
            [
              -95.54326,
              35.251897
            ],
            [
              -95.55696,
              35.249397
            ],
            [
              -95.56296,
              35.246397
            ],
            [
              -95.572662,
              35.244298
            ],
            [
              -95.586262,
              35.234098
            ],
            [
              -95.594263,
              35.224898
            ],
            [
              -95.59938,
              35.221651
            ],
            [
              -95.60842,
              35.22041
            ],
            [
              -95.616864,
              35.221398
            ],
            [
              -95.62246,
              35.224698
            ],
            [
              -95.61986,
              35.230398
            ],
            [
              -95.60676,
              35.235098
            ],
            [
              -95.603463,
              35.239398
            ],
            [
              -95.606063,
              35.247098
            ],
            [
              -95.61566,
              35.249698
            ],
            [
              -95.62806,
              35.246798
            ],
            [
              -95.63496,
              35.241698
            ],
            [
              -95.65747,
              35.231398
            ],
            [
              -95.67207,
              35.227298
            ],
            [
              -95.68097,
              35.220998
            ],
            [
              -95.682767,
              35.216398
            ],
            [
              -95.67527,
              35.210162
            ],
            [
              -95.67998,
              35.203459
            ],
            [
              -95.68682,
              35.204993
            ],
            [
              -95.70715,
              35.202301
            ],
            [
              -95.71238,
              35.19713
            ],
            [
              -95.71616,
              35.189352
            ],
            [
              -95.72977,
              35.192045
            ],
            [
              -95.74229,
              35.192509
            ],
            [
              -95.74582,
              35.190472
            ],
            [
              -95.74957,
              35.183709
            ],
            [
              -95.75597,
              35.177198
            ],
            [
              -95.76847,
              35.178998
            ],
            [
              -95.78247,
              35.193898
            ],
            [
              -95.79327,
              35.197298
            ],
            [
              -95.80417,
              35.196298
            ],
            [
              -95.81327,
              35.193497
            ],
            [
              -95.82427,
              35.187497
            ],
            [
              -95.839673,
              35.184397
            ],
            [
              -95.84947,
              35.188297
            ],
            [
              -95.85677,
              35.186597
            ],
            [
              -95.87066,
              35.185986
            ],
            [
              -95.87451,
              35.180272
            ],
            [
              -95.88357,
              35.162597
            ],
            [
              -95.888374,
              35.155696
            ],
            [
              -95.89997,
              35.146896
            ],
            [
              -95.90797,
              35.143496
            ],
            [
              -95.91777,
              35.142496
            ],
            [
              -95.928475,
              35.143596
            ],
            [
              -95.94658,
              35.149996
            ],
            [
              -95.96768,
              35.152596
            ],
            [
              -95.98371,
              35.151557
            ],
            [
              -96.003853,
              35.149066
            ],
            [
              -96.012263,
              35.145106
            ],
            [
              -96.01364,
              35.141787
            ],
            [
              -96.00888,
              35.122201
            ],
            [
              -96.01387,
              35.116558
            ],
            [
              -96.02624,
              35.120584
            ],
            [
              -96.03163,
              35.118571
            ],
            [
              -96.04186,
              35.104348
            ],
            [
              -96.05493,
              35.097299
            ],
            [
              -96.06271,
              35.08807
            ],
            [
              -96.0643,
              35.071134
            ],
            [
              -96.06924,
              35.056585
            ],
            [
              -96.07324,
              35.053409
            ],
            [
              -96.08884,
              35.049863
            ],
            [
              -96.08872,
              35.017085
            ],
            [
              -96.08921,
              34.949117
            ],
            [
              -96.089,
              34.901972
            ],
            [
              -96.089121,
              34.854853
            ],
            [
              -96.09201,
              34.854853
            ],
            [
              -96.09212,
              34.76759
            ],
            [
              -96.09237,
              34.709293
            ],
            [
              -96.09217,
              34.680586
            ],
            [
              -96.00027,
              34.680374
            ],
            [
              -95.9608,
              34.680827
            ],
            [
              -95.92062,
              34.680349
            ],
            [
              -95.8821,
              34.680475
            ],
            [
              -95.88217,
              34.593521
            ],
            [
              -95.70248,
              34.594108
            ],
            [
              -95.67198,
              34.593852
            ],
            [
              -95.62587,
              34.593845
            ],
            [
              -95.57552,
              34.594158
            ],
            [
              -95.51431,
              34.594153
            ],
            [
              -95.51481,
              34.619219
            ],
            [
              -95.514514,
              34.681142
            ],
            [
              -95.51411,
              34.784695
            ],
            [
              -95.51438,
              34.841706
            ],
            [
              -95.513963,
              34.854795
            ],
            [
              -95.50753,
              34.854811
            ],
            [
              -95.50751,
              34.910704
            ],
            [
              -95.50779,
              34.945843
            ],
            [
              -95.50746,
              35.000097
            ],
            [
              -95.50766,
              35.029197
            ],
            [
              -95.40545,
              35.029497
            ],
            [
              -95.34944,
              35.029299
            ],
            [
              -95.34941,
              35.05828
            ],
            [
              -95.34904,
              35.091313
            ],
            [
              -95.349351,
              35.160297
            ],
            [
              -95.43786,
              35.160214
            ],
            [
              -95.45496,
              35.160412
            ],
            [
              -95.45536,
              35.202697
            ],
            [
              -95.45076,
              35.202797
            ],
            [
              -95.45125,
              35.296019
            ]
          ]
        ]
      },
      "properties": {
        "county": "40121",
        "name": "Pittsburg"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.98138,
              35.289899
            ],
            [
              -96.0169,
              35.289652
            ],
            [
              -96.11387,
              35.289812
            ],
            [
              -96.188632,
              35.290183
            ],
            [
              -96.2688,
              35.290015
            ],
            [
              -96.37032,
              35.290202
            ],
            [
              -96.44139,
              35.290095
            ],
            [
              -96.44116,
              35.144932
            ],
            [
              -96.44135,
              35.115792
            ],
            [
              -96.49043,
              35.11592
            ],
            [
              -96.49067,
              35.078323
            ],
            [
              -96.49079,
              34.910585
            ],
            [
              -96.4814,
              34.914966
            ],
            [
              -96.47027,
              34.916993
            ],
            [
              -96.45579,
              34.913786
            ],
            [
              -96.43258,
              34.903635
            ],
            [
              -96.424586,
              34.903786
            ],
            [
              -96.41499,
              34.914486
            ],
            [
              -96.40969,
              34.924486
            ],
            [
              -96.40694,
              34.924281
            ],
            [
              -96.40618,
              34.908387
            ],
            [
              -96.40641,
              34.852954
            ],
            [
              -96.40608,
              34.790691
            ],
            [
              -96.40648,
              34.76759
            ],
            [
              -96.29508,
              34.766791
            ],
            [
              -96.22848,
              34.766892
            ],
            [
              -96.12528,
              34.767243
            ],
            [
              -96.09212,
              34.76759
            ],
            [
              -96.09201,
              34.854853
            ],
            [
              -96.089121,
              34.854853
            ],
            [
              -96.089,
              34.901972
            ],
            [
              -96.08921,
              34.949117
            ],
            [
              -96.08872,
              35.017085
            ],
            [
              -96.08884,
              35.049863
            ],
            [
              -96.07324,
              35.053409
            ],
            [
              -96.06924,
              35.056585
            ],
            [
              -96.0643,
              35.071134
            ],
            [
              -96.06271,
              35.08807
            ],
            [
              -96.05493,
              35.097299
            ],
            [
              -96.04186,
              35.104348
            ],
            [
              -96.03163,
              35.118571
            ],
            [
              -96.02624,
              35.120584
            ],
            [
              -96.01387,
              35.116558
            ],
            [
              -96.00888,
              35.122201
            ],
            [
              -96.01364,
              35.141787
            ],
            [
              -96.012263,
              35.145106
            ],
            [
              -96.003853,
              35.149066
            ],
            [
              -95.98371,
              35.151557
            ],
            [
              -95.98336,
              35.198495
            ],
            [
              -95.98159,
              35.202677
            ],
            [
              -95.98107,
              35.2176
            ],
            [
              -95.98138,
              35.289899
            ]
          ]
        ]
      },
      "properties": {
        "county": "40063",
        "name": "Hughes"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.77568,
              34.899958
            ],
            [
              -96.78507,
              34.899145
            ],
            [
              -96.79059,
              34.900834
            ],
            [
              -96.79908,
              34.9064
            ],
            [
              -96.7994,
              34.919352
            ],
            [
              -96.79821,
              34.929992
            ],
            [
              -96.81177,
              34.943504
            ],
            [
              -96.82149,
              34.946112
            ],
            [
              -96.834995,
              34.939427
            ],
            [
              -96.84137,
              34.933797
            ],
            [
              -96.85237,
              34.92877
            ],
            [
              -96.868097,
              34.929415
            ],
            [
              -96.87632,
              34.926029
            ],
            [
              -96.88891,
              34.92748
            ],
            [
              -96.89053,
              34.932617
            ],
            [
              -96.89684,
              34.94219
            ],
            [
              -96.90316,
              34.946092
            ],
            [
              -96.91061,
              34.958659
            ],
            [
              -96.92129,
              34.963986
            ],
            [
              -96.92977,
              34.96513
            ],
            [
              -96.93051,
              34.952096
            ],
            [
              -96.93082,
              34.854564
            ],
            [
              -96.93263,
              34.854473
            ],
            [
              -96.93241,
              34.810927
            ],
            [
              -96.93264,
              34.767701
            ],
            [
              -96.93239,
              34.709352
            ],
            [
              -96.93245,
              34.636727
            ],
            [
              -96.93242,
              34.593101
            ],
            [
              -96.82729,
              34.59317
            ],
            [
              -96.82729,
              34.505989
            ],
            [
              -96.67649,
              34.505599
            ],
            [
              -96.64534,
              34.505691
            ],
            [
              -96.51386,
              34.505389
            ],
            [
              -96.51248,
              34.505525
            ],
            [
              -96.51197,
              34.527341
            ],
            [
              -96.51225,
              34.614513
            ],
            [
              -96.51213,
              34.680016
            ],
            [
              -96.4065,
              34.680163
            ],
            [
              -96.40601,
              34.698235
            ],
            [
              -96.40642,
              34.716684
            ],
            [
              -96.40648,
              34.76759
            ],
            [
              -96.40608,
              34.790691
            ],
            [
              -96.40641,
              34.852954
            ],
            [
              -96.40618,
              34.908387
            ],
            [
              -96.40694,
              34.924281
            ],
            [
              -96.40969,
              34.924486
            ],
            [
              -96.41499,
              34.914486
            ],
            [
              -96.424586,
              34.903786
            ],
            [
              -96.43258,
              34.903635
            ],
            [
              -96.45579,
              34.913786
            ],
            [
              -96.47027,
              34.916993
            ],
            [
              -96.4814,
              34.914966
            ],
            [
              -96.49079,
              34.910585
            ],
            [
              -96.49799,
              34.902685
            ],
            [
              -96.50029,
              34.893465
            ],
            [
              -96.50619,
              34.886485
            ],
            [
              -96.51219,
              34.875986
            ],
            [
              -96.51699,
              34.871586
            ],
            [
              -96.52859,
              34.869586
            ],
            [
              -96.54376,
              34.880097
            ],
            [
              -96.549579,
              34.887112
            ],
            [
              -96.55589,
              34.898085
            ],
            [
              -96.55529,
              34.907484
            ],
            [
              -96.556889,
              34.914184
            ],
            [
              -96.56409,
              34.917284
            ],
            [
              -96.57709,
              34.916584
            ],
            [
              -96.59579,
              34.905984
            ],
            [
              -96.61319,
              34.900484
            ],
            [
              -96.63369,
              34.898584
            ],
            [
              -96.64699,
              34.902184
            ],
            [
              -96.65309,
              34.910383
            ],
            [
              -96.65799,
              34.920983
            ],
            [
              -96.66769,
              34.929583
            ],
            [
              -96.68161,
              34.93286
            ],
            [
              -96.69197,
              34.933312
            ],
            [
              -96.699493,
              34.930282
            ],
            [
              -96.706493,
              34.923983
            ],
            [
              -96.71149,
              34.916283
            ],
            [
              -96.71129,
              34.911913
            ],
            [
              -96.70353,
              34.909305
            ],
            [
              -96.69569,
              34.903614
            ],
            [
              -96.68919,
              34.895583
            ],
            [
              -96.6863,
              34.888548
            ],
            [
              -96.68729,
              34.880984
            ],
            [
              -96.69418,
              34.868495
            ],
            [
              -96.715292,
              34.858684
            ],
            [
              -96.72289,
              34.856784
            ],
            [
              -96.73249,
              34.858884
            ],
            [
              -96.74209,
              34.869383
            ],
            [
              -96.74719,
              34.881783
            ],
            [
              -96.748793,
              34.890283
            ],
            [
              -96.75552,
              34.899809
            ],
            [
              -96.76065,
              34.90084
            ],
            [
              -96.77568,
              34.899958
            ]
          ]
        ]
      },
      "properties": {
        "county": "40123",
        "name": "Pontotoc"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.62065,
              35.639005
            ],
            [
              -96.62186,
              35.56398
            ],
            [
              -96.62169,
              35.551793
            ],
            [
              -96.62389,
              35.513696
            ],
            [
              -96.62399,
              35.491726
            ],
            [
              -96.62487,
              35.462726
            ],
            [
              -96.62376,
              35.43537
            ],
            [
              -96.6237,
              35.400956
            ],
            [
              -96.61733,
              35.395872
            ],
            [
              -96.61163,
              35.394386
            ],
            [
              -96.60405,
              35.399425
            ],
            [
              -96.59617,
              35.400412
            ],
            [
              -96.59005,
              35.41124
            ],
            [
              -96.58077,
              35.409113
            ],
            [
              -96.57663,
              35.402132
            ],
            [
              -96.56612,
              35.399386
            ],
            [
              -96.55661,
              35.40259
            ],
            [
              -96.55689,
              35.395083
            ],
            [
              -96.55058,
              35.39229
            ],
            [
              -96.5413,
              35.392655
            ],
            [
              -96.53708,
              35.390663
            ],
            [
              -96.53201,
              35.39952
            ],
            [
              -96.53752,
              35.403641
            ],
            [
              -96.537545,
              35.411308
            ],
            [
              -96.54669,
              35.412683
            ],
            [
              -96.547917,
              35.417879
            ],
            [
              -96.555158,
              35.422962
            ],
            [
              -96.56083,
              35.42239
            ],
            [
              -96.55602,
              35.434795
            ],
            [
              -96.56469,
              35.436032
            ],
            [
              -96.56931,
              35.438985
            ],
            [
              -96.561448,
              35.447477
            ],
            [
              -96.55384,
              35.448025
            ],
            [
              -96.5528,
              35.454021
            ],
            [
              -96.544999,
              35.452602
            ],
            [
              -96.53253,
              35.446167
            ],
            [
              -96.52213,
              35.43877
            ],
            [
              -96.51849,
              35.430987
            ],
            [
              -96.49755,
              35.428627
            ],
            [
              -96.48762,
              35.432522
            ],
            [
              -96.48307,
              35.442618
            ],
            [
              -96.48816,
              35.445958
            ],
            [
              -96.486765,
              35.449987
            ],
            [
              -96.48131,
              35.453605
            ],
            [
              -96.47407,
              35.463954
            ],
            [
              -96.46548,
              35.458096
            ],
            [
              -96.45921,
              35.461394
            ],
            [
              -96.45264,
              35.45819
            ],
            [
              -96.4464,
              35.458442
            ],
            [
              -96.44129,
              35.467673
            ],
            [
              -96.44137,
              35.402002
            ],
            [
              -96.44139,
              35.290095
            ],
            [
              -96.37032,
              35.290202
            ],
            [
              -96.2688,
              35.290015
            ],
            [
              -96.188632,
              35.290183
            ],
            [
              -96.11387,
              35.289812
            ],
            [
              -96.0169,
              35.289652
            ],
            [
              -95.98138,
              35.289899
            ],
            [
              -95.98159,
              35.333018
            ],
            [
              -95.98131,
              35.376828
            ],
            [
              -96.0499,
              35.377043
            ],
            [
              -96.05155,
              35.377066
            ],
            [
              -96.08737,
              35.376993
            ],
            [
              -96.08747,
              35.384178
            ],
            [
              -96.08748,
              35.384613
            ],
            [
              -96.08767,
              35.400007
            ],
            [
              -96.08777,
              35.404819
            ],
            [
              -96.0876,
              35.420473
            ],
            [
              -96.087576,
              35.426812
            ],
            [
              -96.08761,
              35.453083
            ],
            [
              -96.08764,
              35.464021
            ],
            [
              -96.08788,
              35.5001
            ],
            [
              -96.08779,
              35.552119
            ],
            [
              -96.08956,
              35.552121
            ],
            [
              -96.10394,
              35.552128
            ],
            [
              -96.12138,
              35.551911
            ],
            [
              -96.12528,
              35.552104
            ],
            [
              -96.15731,
              35.552079
            ],
            [
              -96.15888,
              35.552056
            ],
            [
              -96.19284,
              35.551902
            ],
            [
              -96.19274,
              35.570206
            ],
            [
              -96.19272,
              35.617774
            ],
            [
              -96.19273,
              35.618766
            ],
            [
              -96.19256,
              35.639087
            ],
            [
              -96.20939,
              35.639035
            ],
            [
              -96.21691,
              35.638974
            ],
            [
              -96.25661,
              35.638921
            ],
            [
              -96.265181,
              35.638939
            ],
            [
              -96.35414,
              35.63899
            ],
            [
              -96.35981,
              35.639014
            ],
            [
              -96.40695,
              35.639412
            ],
            [
              -96.42206,
              35.639414
            ],
            [
              -96.50029,
              35.638973
            ],
            [
              -96.58434,
              35.639009
            ],
            [
              -96.59181,
              35.63896
            ],
            [
              -96.61236,
              35.639053
            ],
            [
              -96.62065,
              35.639005
            ]
          ]
        ]
      },
      "properties": {
        "county": "40107",
        "name": "Okfuskee"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.14214,
              34.507042
            ],
            [
              -98.18118,
              34.50689
            ],
            [
              -98.21325,
              34.507207
            ],
            [
              -98.24402,
              34.506968
            ],
            [
              -98.24415,
              34.463765
            ],
            [
              -98.29582,
              34.463547
            ],
            [
              -98.29582,
              34.449072
            ],
            [
              -98.40023,
              34.448883
            ],
            [
              -98.50474,
              34.449333
            ],
            [
              -98.50482,
              34.420564
            ],
            [
              -98.60939,
              34.420638
            ],
            [
              -98.60938,
              34.406184
            ],
            [
              -98.662,
              34.406007
            ],
            [
              -98.661719,
              34.333467
            ],
            [
              -98.609502,
              34.33369
            ],
            [
              -98.60949,
              34.26078
            ],
            [
              -98.6098,
              34.173556
            ],
            [
              -98.610158,
              34.157098
            ],
            [
              -98.59979,
              34.160571
            ],
            [
              -98.58391,
              34.151298
            ],
            [
              -98.57736,
              34.1491
            ],
            [
              -98.5673,
              34.138242
            ],
            [
              -98.56019,
              34.133202
            ],
            [
              -98.55372,
              34.13366
            ],
            [
              -98.55184,
              34.127131
            ],
            [
              -98.55956,
              34.127704
            ],
            [
              -98.56098,
              34.123922
            ],
            [
              -98.550917,
              34.119334
            ],
            [
              -98.536257,
              34.107343
            ],
            [
              -98.5282,
              34.094961
            ],
            [
              -98.516923,
              34.086065
            ],
            [
              -98.50418,
              34.072371
            ],
            [
              -98.49449,
              34.069968
            ],
            [
              -98.48633,
              34.062598
            ],
            [
              -98.48204,
              34.06227
            ],
            [
              -98.47146,
              34.065665
            ],
            [
              -98.466,
              34.073081
            ],
            [
              -98.45466,
              34.072577
            ],
            [
              -98.44638,
              34.07543
            ],
            [
              -98.44281,
              34.083144
            ],
            [
              -98.43213,
              34.085622
            ],
            [
              -98.4188,
              34.082655
            ],
            [
              -98.410855,
              34.088926
            ],
            [
              -98.41151,
              34.098615
            ],
            [
              -98.40673,
              34.10114
            ],
            [
              -98.40216,
              34.098653
            ],
            [
              -98.398389,
              34.104566
            ],
            [
              -98.39844,
              34.128456
            ],
            [
              -98.3894,
              34.133217
            ],
            [
              -98.38378,
              34.129916
            ],
            [
              -98.380421,
              34.13429
            ],
            [
              -98.38708,
              34.140912
            ],
            [
              -98.38165,
              34.149202
            ],
            [
              -98.370495,
              34.152135
            ],
            [
              -98.36402,
              34.157109
            ],
            [
              -98.32258,
              34.14972
            ],
            [
              -98.31875,
              34.146421
            ],
            [
              -98.30021,
              34.134579
            ],
            [
              -98.28032,
              34.13075
            ],
            [
              -98.27299,
              34.132213
            ],
            [
              -98.2617,
              34.131568
            ],
            [
              -98.25647,
              34.129481
            ],
            [
              -98.24795,
              34.130717
            ],
            [
              -98.23914,
              34.134547
            ],
            [
              -98.23247,
              34.134641
            ],
            [
              -98.22556,
              34.129283
            ],
            [
              -98.2236,
              34.125093
            ],
            [
              -98.2171,
              34.122072
            ],
            [
              -98.20801,
              34.120539
            ],
            [
              -98.200075,
              34.116783
            ],
            [
              -98.16879,
              34.114262
            ],
            [
              -98.15741,
              34.120467
            ],
            [
              -98.15208,
              34.125093
            ],
            [
              -98.139072,
              34.14187
            ],
            [
              -98.13919,
              34.246419
            ],
            [
              -98.13895,
              34.28978
            ],
            [
              -98.13915,
              34.319395
            ],
            [
              -98.13888,
              34.40559
            ],
            [
              -98.13923,
              34.507018
            ],
            [
              -98.14214,
              34.507042
            ]
          ]
        ]
      },
      "properties": {
        "county": "40033",
        "name": "Cotton"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.35211,
              34.506788
            ],
            [
              -97.43548,
              34.506686
            ],
            [
              -97.56236,
              34.506925
            ],
            [
              -97.56236,
              34.463228
            ],
            [
              -97.562709,
              34.332575
            ],
            [
              -97.56258,
              34.289048
            ],
            [
              -97.56274,
              34.24571
            ],
            [
              -97.562416,
              34.216443
            ],
            [
              -97.56272,
              34.125094
            ],
            [
              -97.562388,
              34.071074
            ],
            [
              -97.56076,
              34.071089
            ],
            [
              -97.5003,
              34.071321
            ],
            [
              -97.35262,
              34.071126
            ],
            [
              -97.282607,
              34.071329
            ],
            [
              -97.23064,
              34.070873
            ],
            [
              -97.11683,
              34.070984
            ],
            [
              -97.097097,
              34.070822
            ],
            [
              -96.98273,
              34.070995
            ],
            [
              -96.970006,
              34.07083
            ],
            [
              -96.96827,
              34.076025
            ],
            [
              -96.96866,
              34.159773
            ],
            [
              -96.96841,
              34.172617
            ],
            [
              -96.93367,
              34.172553
            ],
            [
              -96.933732,
              34.23874
            ],
            [
              -96.933417,
              34.250093
            ],
            [
              -96.93346,
              34.332661
            ],
            [
              -97.00784,
              34.332332
            ],
            [
              -97.028704,
              34.332638
            ],
            [
              -97.03951,
              34.33754
            ],
            [
              -97.042611,
              34.344608
            ],
            [
              -97.031546,
              34.350524
            ],
            [
              -97.03521,
              34.35538
            ],
            [
              -97.034856,
              34.36061
            ],
            [
              -97.03884,
              34.36691
            ],
            [
              -97.03371,
              34.372951
            ],
            [
              -97.036488,
              34.375415
            ],
            [
              -97.11507,
              34.376093
            ],
            [
              -97.18357,
              34.376235
            ],
            [
              -97.27369,
              34.376156
            ],
            [
              -97.35216,
              34.376227
            ],
            [
              -97.35225,
              34.43126
            ],
            [
              -97.35211,
              34.506788
            ]
          ]
        ]
      },
      "properties": {
        "county": "40019",
        "name": "Carter"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.14194,
              35.101733
            ],
            [
              -97.14184,
              35.113821
            ],
            [
              -97.1418,
              35.116111
            ],
            [
              -97.1419,
              35.121435
            ],
            [
              -97.142303,
              35.137496
            ],
            [
              -97.14229,
              35.145208
            ],
            [
              -97.14219,
              35.166655
            ],
            [
              -97.14222,
              35.190231
            ],
            [
              -97.14221,
              35.192711
            ],
            [
              -97.1416,
              35.202966
            ],
            [
              -97.14182,
              35.226374
            ],
            [
              -97.14185,
              35.228195
            ],
            [
              -97.14208,
              35.278853
            ],
            [
              -97.14203,
              35.289604
            ],
            [
              -97.14196,
              35.292377
            ],
            [
              -97.14179,
              35.298932
            ],
            [
              -97.14195,
              35.3041
            ],
            [
              -97.14205,
              35.318596
            ],
            [
              -97.14203,
              35.333155
            ],
            [
              -97.14203,
              35.336088
            ],
            [
              -97.14203,
              35.338979
            ],
            [
              -97.14203,
              35.340531
            ],
            [
              -97.14203,
              35.340641
            ],
            [
              -97.14219,
              35.347715
            ],
            [
              -97.1421,
              35.362291
            ],
            [
              -97.14214,
              35.366867
            ],
            [
              -97.14182,
              35.376818
            ],
            [
              -97.15984,
              35.377138
            ],
            [
              -97.23907,
              35.377416
            ],
            [
              -97.24117,
              35.377428
            ],
            [
              -97.332177,
              35.377211
            ],
            [
              -97.459214,
              35.377329
            ],
            [
              -97.512415,
              35.377175
            ],
            [
              -97.516845,
              35.377189
            ],
            [
              -97.60092,
              35.377261
            ],
            [
              -97.63363,
              35.376988
            ],
            [
              -97.67122,
              35.37726
            ],
            [
              -97.67137,
              35.362684
            ],
            [
              -97.67152,
              35.350589
            ],
            [
              -97.67159,
              35.335934
            ],
            [
              -97.67158,
              35.334285
            ],
            [
              -97.671555,
              35.334212
            ],
            [
              -97.671213,
              35.333865
            ],
            [
              -97.670643,
              35.333233
            ],
            [
              -97.670192,
              35.332803
            ],
            [
              -97.667858,
              35.33071
            ],
            [
              -97.664871,
              35.329087
            ],
            [
              -97.652521,
              35.330194
            ],
            [
              -97.645209,
              35.328198
            ],
            [
              -97.634253,
              35.31035
            ],
            [
              -97.627955,
              35.307158
            ],
            [
              -97.620716,
              35.307992
            ],
            [
              -97.620074,
              35.303463
            ],
            [
              -97.599601,
              35.303068
            ],
            [
              -97.598762,
              35.303289
            ],
            [
              -97.598225,
              35.303466
            ],
            [
              -97.588568,
              35.302048
            ],
            [
              -97.577609,
              35.302318
            ],
            [
              -97.56881,
              35.297414
            ],
            [
              -97.567832,
              35.291033
            ],
            [
              -97.567775,
              35.290619
            ],
            [
              -97.556887,
              35.283834
            ],
            [
              -97.554355,
              35.279297
            ],
            [
              -97.559303,
              35.265388
            ],
            [
              -97.564422,
              35.258391
            ],
            [
              -97.563148,
              35.254523
            ],
            [
              -97.553272,
              35.250353
            ],
            [
              -97.566264,
              35.244173
            ],
            [
              -97.562792,
              35.238615
            ],
            [
              -97.554383,
              35.232964
            ],
            [
              -97.55984,
              35.230305
            ],
            [
              -97.550342,
              35.224481
            ],
            [
              -97.548033,
              35.218187
            ],
            [
              -97.547848,
              35.217708
            ],
            [
              -97.534573,
              35.215176
            ],
            [
              -97.53054,
              35.209462
            ],
            [
              -97.525354,
              35.210943
            ],
            [
              -97.520859,
              35.216258
            ],
            [
              -97.508615,
              35.205051
            ],
            [
              -97.495061,
              35.198774
            ],
            [
              -97.491547,
              35.202358
            ],
            [
              -97.485003,
              35.194819
            ],
            [
              -97.483899,
              35.19407
            ],
            [
              -97.478405,
              35.188023
            ],
            [
              -97.462841,
              35.180359
            ],
            [
              -97.457961,
              35.168266
            ],
            [
              -97.44997,
              35.161895
            ],
            [
              -97.449236,
              35.161479
            ],
            [
              -97.446567,
              35.160559
            ],
            [
              -97.445674,
              35.160405
            ],
            [
              -97.441633,
              35.158277
            ],
            [
              -97.438839,
              35.149764
            ],
            [
              -97.429628,
              35.142636
            ],
            [
              -97.414086,
              35.141432
            ],
            [
              -97.404994,
              35.135638
            ],
            [
              -97.405488,
              35.126618
            ],
            [
              -97.402932,
              35.117151
            ],
            [
              -97.402795,
              35.116398
            ],
            [
              -97.406757,
              35.100454
            ],
            [
              -97.403824,
              35.090605
            ],
            [
              -97.394736,
              35.086711
            ],
            [
              -97.386323,
              35.080911
            ],
            [
              -97.369137,
              35.08576
            ],
            [
              -97.362662,
              35.084628
            ],
            [
              -97.356327,
              35.079132
            ],
            [
              -97.353475,
              35.073403
            ],
            [
              -97.353129,
              35.072473
            ],
            [
              -97.352523,
              35.053245
            ],
            [
              -97.348016,
              35.038686
            ],
            [
              -97.354668,
              35.036062
            ],
            [
              -97.356135,
              35.032439
            ],
            [
              -97.351603,
              35.027052
            ],
            [
              -97.353297,
              35.019078
            ],
            [
              -97.347339,
              35.014498
            ],
            [
              -97.345802,
              35.008455
            ],
            [
              -97.352001,
              34.990049
            ],
            [
              -97.345012,
              34.980275
            ],
            [
              -97.347579,
              34.97449
            ],
            [
              -97.345772,
              34.970547
            ],
            [
              -97.33239,
              34.970821
            ],
            [
              -97.322518,
              34.968963
            ],
            [
              -97.319413,
              34.964498
            ],
            [
              -97.324964,
              34.955709
            ],
            [
              -97.322251,
              34.953184
            ],
            [
              -97.311214,
              34.953606
            ],
            [
              -97.305012,
              34.956771
            ],
            [
              -97.294488,
              34.959538
            ],
            [
              -97.283796,
              34.965551
            ],
            [
              -97.278509,
              34.96197
            ],
            [
              -97.282168,
              34.958331
            ],
            [
              -97.280692,
              34.954618
            ],
            [
              -97.26965,
              34.954441
            ],
            [
              -97.2593,
              34.95584
            ],
            [
              -97.251729,
              34.950287
            ],
            [
              -97.244561,
              34.949297
            ],
            [
              -97.240883,
              34.944438
            ],
            [
              -97.234035,
              34.944937
            ],
            [
              -97.228715,
              34.933806
            ],
            [
              -97.220852,
              34.943074
            ],
            [
              -97.21526,
              34.944967
            ],
            [
              -97.206092,
              34.942341
            ],
            [
              -97.19876,
              34.934067
            ],
            [
              -97.189531,
              34.92898
            ],
            [
              -97.174922,
              34.929022
            ],
            [
              -97.159505,
              34.931191
            ],
            [
              -97.149188,
              34.931403
            ],
            [
              -97.142257,
              34.928448
            ],
            [
              -97.142,
              34.943719
            ],
            [
              -97.142,
              34.956862
            ],
            [
              -97.142016,
              34.971379
            ],
            [
              -97.14197,
              34.975858
            ],
            [
              -97.14184,
              35.014801
            ],
            [
              -97.14194,
              35.027181
            ],
            [
              -97.14206,
              35.095917
            ],
            [
              -97.14222,
              35.098184
            ],
            [
              -97.14186,
              35.10029
            ],
            [
              -97.14194,
              35.101733
            ]
          ]
        ]
      },
      "properties": {
        "county": "40027",
        "name": "Cleveland"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.93263,
              34.854473
            ],
            [
              -96.9839,
              34.854856
            ],
            [
              -97.1253,
              34.854964
            ],
            [
              -97.18763,
              34.855161
            ],
            [
              -97.31574,
              34.855146
            ],
            [
              -97.34616,
              34.855318
            ],
            [
              -97.50783,
              34.855171
            ],
            [
              -97.668,
              34.855137
            ],
            [
              -97.667984,
              34.820511
            ],
            [
              -97.668431,
              34.681339
            ],
            [
              -97.562757,
              34.681147
            ],
            [
              -97.56304,
              34.638467
            ],
            [
              -97.56272,
              34.623124
            ],
            [
              -97.56275,
              34.550827
            ],
            [
              -97.56311,
              34.521581
            ],
            [
              -97.56236,
              34.506925
            ],
            [
              -97.43548,
              34.506686
            ],
            [
              -97.35211,
              34.506788
            ],
            [
              -97.2503,
              34.506855
            ],
            [
              -97.184064,
              34.506454
            ],
            [
              -97.14387,
              34.506533
            ],
            [
              -97.144687,
              34.510317
            ],
            [
              -97.15263,
              34.516175
            ],
            [
              -97.14981,
              34.521423
            ],
            [
              -97.158054,
              34.522714
            ],
            [
              -97.16306,
              34.547399
            ],
            [
              -97.15773,
              34.551495
            ],
            [
              -97.16444,
              34.558541
            ],
            [
              -97.16552,
              34.562969
            ],
            [
              -97.17317,
              34.565067
            ],
            [
              -97.17563,
              34.57143
            ],
            [
              -97.16796,
              34.576103
            ],
            [
              -97.17258,
              34.58056
            ],
            [
              -97.173519,
              34.586812
            ],
            [
              -97.167211,
              34.588441
            ],
            [
              -97.17143,
              34.593269
            ],
            [
              -97.19106,
              34.597177
            ],
            [
              -97.19846,
              34.613526
            ],
            [
              -97.19519,
              34.618175
            ],
            [
              -97.199431,
              34.622729
            ],
            [
              -97.14237,
              34.622584
            ],
            [
              -97.14267,
              34.637032
            ],
            [
              -97.07238,
              34.636975
            ],
            [
              -97.00667,
              34.637099
            ],
            [
              -97.0003,
              34.636665
            ],
            [
              -96.93245,
              34.636727
            ],
            [
              -96.93239,
              34.709352
            ],
            [
              -96.93264,
              34.767701
            ],
            [
              -96.93241,
              34.810927
            ],
            [
              -96.93263,
              34.854473
            ]
          ]
        ]
      },
      "properties": {
        "county": "40049",
        "name": "Garvin"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.059616,
              34.680736
            ],
            [
              -95.15674,
              34.680875
            ],
            [
              -95.25024,
              34.680492
            ],
            [
              -95.30499,
              34.680977
            ],
            [
              -95.35695,
              34.681082
            ],
            [
              -95.40768,
              34.680792
            ],
            [
              -95.484407,
              34.680759
            ],
            [
              -95.514514,
              34.681142
            ],
            [
              -95.51481,
              34.619219
            ],
            [
              -95.51431,
              34.594153
            ],
            [
              -95.57552,
              34.594158
            ],
            [
              -95.62587,
              34.593845
            ],
            [
              -95.67198,
              34.593852
            ],
            [
              -95.6717,
              34.506799
            ],
            [
              -95.75026,
              34.506808
            ],
            [
              -95.77942,
              34.506556
            ],
            [
              -95.779,
              34.500097
            ],
            [
              -95.77919,
              34.395498
            ],
            [
              -95.77923,
              34.258226
            ],
            [
              -95.77893,
              34.185918
            ],
            [
              -95.77938,
              34.156699
            ],
            [
              -95.73026,
              34.156454
            ],
            [
              -95.72645,
              34.156964
            ],
            [
              -95.677586,
              34.156599
            ],
            [
              -95.59215,
              34.156869
            ],
            [
              -95.47611,
              34.156718
            ],
            [
              -95.34333,
              34.15705
            ],
            [
              -95.27465,
              34.156911
            ],
            [
              -95.15644,
              34.157027
            ],
            [
              -95.15129,
              34.157024
            ],
            [
              -95.151233,
              34.243906
            ],
            [
              -95.04658,
              34.243671
            ],
            [
              -95.04635,
              34.301697
            ],
            [
              -95.04674,
              34.401531
            ],
            [
              -95.046746,
              34.507229
            ],
            [
              -94.94403,
              34.50709
            ],
            [
              -94.941103,
              34.506609
            ],
            [
              -94.939084,
              34.506815
            ],
            [
              -94.93792,
              34.506907
            ],
            [
              -94.9376,
              34.506887
            ],
            [
              -94.93753,
              34.534253
            ],
            [
              -94.93762,
              34.53805
            ],
            [
              -94.937757,
              34.538964
            ],
            [
              -94.93758,
              34.549635
            ],
            [
              -94.937565,
              34.550184
            ],
            [
              -94.9374,
              34.563388
            ],
            [
              -94.937416,
              34.571091
            ],
            [
              -94.937422,
              34.574061
            ],
            [
              -94.937478,
              34.592335
            ],
            [
              -94.937526,
              34.621189
            ],
            [
              -94.93762,
              34.653798
            ],
            [
              -94.93776,
              34.679924
            ],
            [
              -94.943864,
              34.680796
            ],
            [
              -94.94982,
              34.680756
            ],
            [
              -94.975705,
              34.680809
            ],
            [
              -94.98147,
              34.680876
            ],
            [
              -94.997102,
              34.680937
            ],
            [
              -95.00388,
              34.680964
            ],
            [
              -95.00439,
              34.680957
            ],
            [
              -95.012164,
              34.680904
            ],
            [
              -95.015764,
              34.68082
            ],
            [
              -95.01681,
              34.680786
            ],
            [
              -95.034521,
              34.680722
            ],
            [
              -95.059616,
              34.680736
            ]
          ]
        ]
      },
      "properties": {
        "county": "40127",
        "name": "Pushmataha"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.44012,
              36.075226
            ],
            [
              -95.43999,
              36.169266
            ],
            [
              -95.43998,
              36.176902
            ],
            [
              -95.43998,
              36.205969
            ],
            [
              -95.43998,
              36.220576
            ],
            [
              -95.43997,
              36.234593
            ],
            [
              -95.43997,
              36.235792
            ],
            [
              -95.43997,
              36.249336
            ],
            [
              -95.43561,
              36.249315
            ],
            [
              -95.43557,
              36.307439
            ],
            [
              -95.43549,
              36.318437
            ],
            [
              -95.43546,
              36.322047
            ],
            [
              -95.43541,
              36.327651
            ],
            [
              -95.435739,
              36.39074
            ],
            [
              -95.43563,
              36.408721
            ],
            [
              -95.43563,
              36.43365
            ],
            [
              -95.43563,
              36.43761
            ],
            [
              -95.43571,
              36.452211
            ],
            [
              -95.43569,
              36.464439
            ],
            [
              -95.43566,
              36.481275
            ],
            [
              -95.43554,
              36.495418
            ],
            [
              -95.43551,
              36.510154
            ],
            [
              -95.32803,
              36.510263
            ],
            [
              -95.32812,
              36.524727
            ],
            [
              -95.32829,
              36.541233
            ],
            [
              -95.32832,
              36.553655
            ],
            [
              -95.32842,
              36.597573
            ],
            [
              -95.36892,
              36.597743
            ],
            [
              -95.43151,
              36.597552
            ],
            [
              -95.51093,
              36.597465
            ],
            [
              -95.59267,
              36.597661
            ],
            [
              -95.66037,
              36.597526
            ],
            [
              -95.66444,
              36.597521
            ],
            [
              -95.80962,
              36.597476
            ],
            [
              -95.81245,
              36.597516
            ],
            [
              -95.81269,
              36.561467
            ],
            [
              -95.81214,
              36.541718
            ],
            [
              -95.81245,
              36.51823
            ],
            [
              -95.812423,
              36.423602
            ],
            [
              -95.809162,
              36.423574
            ],
            [
              -95.808791,
              36.423568
            ],
            [
              -95.797812,
              36.42364
            ],
            [
              -95.794389,
              36.417034
            ],
            [
              -95.794399,
              36.416311
            ],
            [
              -95.794349,
              36.408997
            ],
            [
              -95.794307,
              36.40362
            ],
            [
              -95.794284,
              36.394538
            ],
            [
              -95.812252,
              36.39459
            ],
            [
              -95.812218,
              36.385636
            ],
            [
              -95.812215,
              36.384813
            ],
            [
              -95.812189,
              36.381396
            ],
            [
              -95.812197,
              36.38013
            ],
            [
              -95.812205,
              36.3676
            ],
            [
              -95.812211,
              36.365555
            ],
            [
              -95.812264,
              36.353288
            ],
            [
              -95.812269,
              36.351011
            ],
            [
              -95.812274,
              36.340805
            ],
            [
              -95.812291,
              36.337921
            ],
            [
              -95.812292,
              36.337491
            ],
            [
              -95.812256,
              36.336518
            ],
            [
              -95.812229,
              36.320801
            ],
            [
              -95.812211,
              36.319333
            ],
            [
              -95.812202,
              36.318449
            ],
            [
              -95.812187,
              36.317241
            ],
            [
              -95.812156,
              36.314798
            ],
            [
              -95.812176,
              36.312591
            ],
            [
              -95.812176,
              36.312032
            ],
            [
              -95.812206,
              36.311206
            ],
            [
              -95.812204,
              36.310684
            ],
            [
              -95.812215,
              36.304032
            ],
            [
              -95.812218,
              36.30301
            ],
            [
              -95.812214,
              36.298655
            ],
            [
              -95.812211,
              36.297618
            ],
            [
              -95.812188,
              36.290748
            ],
            [
              -95.812195,
              36.290064
            ],
            [
              -95.812195,
              36.289843
            ],
            [
              -95.812192,
              36.288841
            ],
            [
              -95.812198,
              36.288074
            ],
            [
              -95.812193,
              36.286566
            ],
            [
              -95.812179,
              36.28379
            ],
            [
              -95.812189,
              36.283034
            ],
            [
              -95.812194,
              36.281739
            ],
            [
              -95.812208,
              36.278543
            ],
            [
              -95.812025,
              36.249526
            ],
            [
              -95.815351,
              36.249532
            ],
            [
              -95.815348,
              36.247665
            ],
            [
              -95.815343,
              36.24751
            ],
            [
              -95.815307,
              36.239617
            ],
            [
              -95.815293,
              36.235525
            ],
            [
              -95.815288,
              36.235079
            ],
            [
              -95.81527,
              36.227332
            ],
            [
              -95.815274,
              36.226295
            ],
            [
              -95.81538,
              36.206144
            ],
            [
              -95.815341,
              36.20544
            ],
            [
              -95.815325,
              36.204631
            ],
            [
              -95.815337,
              36.200931
            ],
            [
              -95.815313,
              36.191537
            ],
            [
              -95.815376,
              36.179605
            ],
            [
              -95.815378,
              36.178968
            ],
            [
              -95.815377,
              36.177079
            ],
            [
              -95.81537,
              36.176188
            ],
            [
              -95.815365,
              36.174218
            ],
            [
              -95.815365,
              36.170051
            ],
            [
              -95.815357,
              36.162555
            ],
            [
              -95.810774,
              36.162536
            ],
            [
              -95.803059,
              36.162531
            ],
            [
              -95.799889,
              36.162547
            ],
            [
              -95.794456,
              36.162528
            ],
            [
              -95.790415,
              36.162508
            ],
            [
              -95.786589,
              36.162517
            ],
            [
              -95.784416,
              36.162514
            ],
            [
              -95.775963,
              36.162503
            ],
            [
              -95.772815,
              36.162489
            ],
            [
              -95.770369,
              36.162498
            ],
            [
              -95.765101,
              36.162587
            ],
            [
              -95.761683,
              36.162672
            ],
            [
              -95.761683,
              36.162503
            ],
            [
              -95.758751,
              36.162501
            ],
            [
              -95.75726,
              36.162498
            ],
            [
              -95.74398,
              36.162498
            ],
            [
              -95.738956,
              36.162498
            ],
            [
              -95.690729,
              36.162398
            ],
            [
              -95.690459,
              36.162398
            ],
            [
              -95.682856,
              36.162361
            ],
            [
              -95.679244,
              36.162344
            ],
            [
              -95.675684,
              36.162326
            ],
            [
              -95.672721,
              36.162326
            ],
            [
              -95.66845,
              36.162309
            ],
            [
              -95.653725,
              36.162303
            ],
            [
              -95.65332,
              36.162306
            ],
            [
              -95.65227,
              36.162312
            ],
            [
              -95.61853,
              36.162696
            ],
            [
              -95.61794,
              36.150344
            ],
            [
              -95.61059,
              36.142194
            ],
            [
              -95.6047,
              36.13346
            ],
            [
              -95.596233,
              36.12976
            ],
            [
              -95.59351,
              36.135706
            ],
            [
              -95.576191,
              36.133565
            ],
            [
              -95.56784,
              36.129378
            ],
            [
              -95.57056,
              36.113764
            ],
            [
              -95.56815,
              36.107431
            ],
            [
              -95.56129,
              36.099279
            ],
            [
              -95.55259,
              36.091486
            ],
            [
              -95.55639,
              36.082913
            ],
            [
              -95.56268,
              36.084263
            ],
            [
              -95.57097,
              36.082242
            ],
            [
              -95.57844,
              36.084091
            ],
            [
              -95.579377,
              36.080316
            ],
            [
              -95.57152,
              36.075282
            ],
            [
              -95.44012,
              36.075226
            ]
          ]
        ]
      },
      "properties": {
        "county": "40131",
        "name": "Rogers"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.19256,
              35.639087
            ],
            [
              -96.19271,
              35.67136
            ],
            [
              -96.19238,
              35.769608
            ],
            [
              -96.192482,
              35.857021
            ],
            [
              -96.12528,
              35.857341
            ],
            [
              -96.05136,
              35.856933
            ],
            [
              -96.0403,
              35.85684
            ],
            [
              -96.033121,
              35.856822
            ],
            [
              -96.033248,
              35.875104
            ],
            [
              -96.033395,
              35.901097
            ],
            [
              -96.029571,
              35.903135
            ],
            [
              -96.029558,
              35.912047
            ],
            [
              -96.029553,
              35.914579
            ],
            [
              -96.029559,
              35.915626
            ],
            [
              -96.029554,
              35.918811
            ],
            [
              -96.029544,
              35.923681
            ],
            [
              -96.029507,
              35.940956
            ],
            [
              -96.029506,
              35.94485
            ],
            [
              -96.029487,
              35.951831
            ],
            [
              -96.029475,
              35.959207
            ],
            [
              -96.029512,
              35.980977
            ],
            [
              -96.029545,
              35.987602
            ],
            [
              -96.029566,
              35.988375
            ],
            [
              -96.029534,
              35.993598
            ],
            [
              -96.029622,
              35.994123
            ],
            [
              -96.029743,
              35.99458
            ],
            [
              -96.029755,
              35.994755
            ],
            [
              -96.029658,
              35.995412
            ],
            [
              -96.029555,
              35.999258
            ],
            [
              -96.029755,
              36.000206
            ],
            [
              -96.029804,
              36.000463
            ],
            [
              -96.029789,
              36.001559
            ],
            [
              -96.029582,
              36.00881
            ],
            [
              -96.029532,
              36.014167
            ],
            [
              -96.029515,
              36.017443
            ],
            [
              -96.029512,
              36.024728
            ],
            [
              -96.029503,
              36.03127
            ],
            [
              -96.029569,
              36.075367
            ],
            [
              -96.030376,
              36.075373
            ],
            [
              -96.045401,
              36.075441
            ],
            [
              -96.049715,
              36.075459
            ],
            [
              -96.052331,
              36.07548
            ],
            [
              -96.053778,
              36.075475
            ],
            [
              -96.055374,
              36.075472
            ],
            [
              -96.059861,
              36.075491
            ],
            [
              -96.062079,
              36.075506
            ],
            [
              -96.063166,
              36.075492
            ],
            [
              -96.065434,
              36.07551
            ],
            [
              -96.072002,
              36.075508
            ],
            [
              -96.079994,
              36.07559
            ],
            [
              -96.081317,
              36.07559
            ],
            [
              -96.081677,
              36.07559
            ],
            [
              -96.083241,
              36.075566
            ],
            [
              -96.089381,
              36.075524
            ],
            [
              -96.092149,
              36.075539
            ],
            [
              -96.101085,
              36.075563
            ],
            [
              -96.11903,
              36.075643
            ],
            [
              -96.134176,
              36.075654
            ],
            [
              -96.136981,
              36.075667
            ],
            [
              -96.154844,
              36.075727
            ],
            [
              -96.163708,
              36.075705
            ],
            [
              -96.168178,
              36.075704
            ],
            [
              -96.169262,
              36.075706
            ],
            [
              -96.170683,
              36.075723
            ],
            [
              -96.174486,
              36.075685
            ],
            [
              -96.176091,
              36.075702
            ],
            [
              -96.182741,
              36.075668
            ],
            [
              -96.199186,
              36.075796
            ],
            [
              -96.201446,
              36.075802
            ],
            [
              -96.206682,
              36.075784
            ],
            [
              -96.217086,
              36.075698
            ],
            [
              -96.22044,
              36.075679
            ],
            [
              -96.225223,
              36.075704
            ],
            [
              -96.288819,
              36.07563
            ],
            [
              -96.297793,
              36.07575
            ],
            [
              -96.297852,
              36.091284
            ],
            [
              -96.297874,
              36.104871
            ],
            [
              -96.297883,
              36.162276
            ],
            [
              -96.39192,
              36.163162
            ],
            [
              -96.499633,
              36.163747
            ],
            [
              -96.62133,
              36.163553
            ],
            [
              -96.62144,
              36.159929
            ],
            [
              -96.62246,
              36.118448
            ],
            [
              -96.622537,
              36.112351
            ],
            [
              -96.62273,
              36.065702
            ],
            [
              -96.62278,
              36.058655
            ],
            [
              -96.62285,
              36.04696
            ],
            [
              -96.62276,
              36.033731
            ],
            [
              -96.62211,
              36.000592
            ],
            [
              -96.62177,
              35.995657
            ],
            [
              -96.62137,
              35.984263
            ],
            [
              -96.62126,
              35.978233
            ],
            [
              -96.62096,
              35.971766
            ],
            [
              -96.62115,
              35.962094
            ],
            [
              -96.6211,
              35.941519
            ],
            [
              -96.61946,
              35.915531
            ],
            [
              -96.61954,
              35.88675
            ],
            [
              -96.61923,
              35.876587
            ],
            [
              -96.61959,
              35.822293
            ],
            [
              -96.61959,
              35.819719
            ],
            [
              -96.619659,
              35.768571
            ],
            [
              -96.61974,
              35.754802
            ],
            [
              -96.61987,
              35.752158
            ],
            [
              -96.61996,
              35.750069
            ],
            [
              -96.61993,
              35.748629
            ],
            [
              -96.61991,
              35.745452
            ],
            [
              -96.62019,
              35.724425
            ],
            [
              -96.62026,
              35.709776
            ],
            [
              -96.62,
              35.694944
            ],
            [
              -96.62067,
              35.670107
            ],
            [
              -96.62063,
              35.662444
            ],
            [
              -96.62064,
              35.639126
            ],
            [
              -96.61236,
              35.639053
            ],
            [
              -96.59181,
              35.63896
            ],
            [
              -96.58434,
              35.639009
            ],
            [
              -96.50029,
              35.638973
            ],
            [
              -96.42206,
              35.639414
            ],
            [
              -96.40695,
              35.639412
            ],
            [
              -96.35981,
              35.639014
            ],
            [
              -96.35414,
              35.63899
            ],
            [
              -96.265181,
              35.638939
            ],
            [
              -96.25661,
              35.638921
            ],
            [
              -96.21691,
              35.638974
            ],
            [
              -96.20939,
              35.639035
            ],
            [
              -96.19256,
              35.639087
            ]
          ]
        ]
      },
      "properties": {
        "county": "40037",
        "name": "Creek"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.45768,
              36.332664
            ],
            [
              -96.46599,
              36.334088
            ],
            [
              -96.47752,
              36.33295
            ],
            [
              -96.48803,
              36.32798
            ],
            [
              -96.49638,
              36.319084
            ],
            [
              -96.50223,
              36.307487
            ],
            [
              -96.51523,
              36.298332
            ],
            [
              -96.52528,
              36.296405
            ],
            [
              -96.53641,
              36.29642
            ],
            [
              -96.55246,
              36.299957
            ],
            [
              -96.56389,
              36.306107
            ],
            [
              -96.57348,
              36.315709
            ],
            [
              -96.571696,
              36.333549
            ],
            [
              -96.56129,
              36.346103
            ],
            [
              -96.55397,
              36.351278
            ],
            [
              -96.545913,
              36.352274
            ],
            [
              -96.53393,
              36.356089
            ],
            [
              -96.52068,
              36.367363
            ],
            [
              -96.51858,
              36.377025
            ],
            [
              -96.525926,
              36.393559
            ],
            [
              -96.53499,
              36.399295
            ],
            [
              -96.54072,
              36.400402
            ],
            [
              -96.54851,
              36.396358
            ],
            [
              -96.57408,
              36.374799
            ],
            [
              -96.58313,
              36.373511
            ],
            [
              -96.59431,
              36.376428
            ],
            [
              -96.60188,
              36.382258
            ],
            [
              -96.60424,
              36.398256
            ],
            [
              -96.606139,
              36.402845
            ],
            [
              -96.62065,
              36.410515
            ],
            [
              -96.62332,
              36.417687
            ],
            [
              -96.63082,
              36.423488
            ],
            [
              -96.6376,
              36.425996
            ],
            [
              -96.64541,
              36.424214
            ],
            [
              -96.66437,
              36.422356
            ],
            [
              -96.67493,
              36.420428
            ],
            [
              -96.68943,
              36.423896
            ],
            [
              -96.70263,
              36.431863
            ],
            [
              -96.70367,
              36.434511
            ],
            [
              -96.71368,
              36.440749
            ],
            [
              -96.71721,
              36.445583
            ],
            [
              -96.71774,
              36.455311
            ],
            [
              -96.70619,
              36.477564
            ],
            [
              -96.7079,
              36.489996
            ],
            [
              -96.71698,
              36.494254
            ],
            [
              -96.724852,
              36.503204
            ],
            [
              -96.72315,
              36.508937
            ],
            [
              -96.72349,
              36.520178
            ],
            [
              -96.72695,
              36.526125
            ],
            [
              -96.73267,
              36.543233
            ],
            [
              -96.73724,
              36.550088
            ],
            [
              -96.75355,
              36.562601
            ],
            [
              -96.76947,
              36.565403
            ],
            [
              -96.783215,
              36.560515
            ],
            [
              -96.79088,
              36.555562
            ],
            [
              -96.79815,
              36.553559
            ],
            [
              -96.82105,
              36.538784
            ],
            [
              -96.82637,
              36.529507
            ],
            [
              -96.83771,
              36.520767
            ],
            [
              -96.83791,
              36.511749
            ],
            [
              -96.84267,
              36.506003
            ],
            [
              -96.85474,
              36.487963
            ],
            [
              -96.86643,
              36.480191
            ],
            [
              -96.875314,
              36.47092
            ],
            [
              -96.89045,
              36.472022
            ],
            [
              -96.89773,
              36.468521
            ],
            [
              -96.912476,
              36.467841
            ],
            [
              -96.91754,
              36.463933
            ],
            [
              -96.92563,
              36.462855
            ],
            [
              -96.93382,
              36.45628
            ],
            [
              -96.94023,
              36.455526
            ],
            [
              -96.95436,
              36.460063
            ],
            [
              -96.96725,
              36.460119
            ],
            [
              -96.98196,
              36.466059
            ],
            [
              -96.98434,
              36.471116
            ],
            [
              -96.9938,
              36.47855
            ],
            [
              -97.00076,
              36.481208
            ],
            [
              -97.00696,
              36.489211
            ],
            [
              -97.009785,
              36.506935
            ],
            [
              -97.01061,
              36.506944
            ],
            [
              -97.01276,
              36.50697
            ],
            [
              -97.0149,
              36.50695
            ],
            [
              -97.0322,
              36.507023
            ],
            [
              -97.03208,
              36.494941
            ],
            [
              -97.032,
              36.487911
            ],
            [
              -97.03202,
              36.482861
            ],
            [
              -97.03204,
              36.469542
            ],
            [
              -97.03203,
              36.457441
            ],
            [
              -97.03207,
              36.434544
            ],
            [
              -97.03209,
              36.420353
            ],
            [
              -97.03231,
              36.3585
            ],
            [
              -97.03209,
              36.333366
            ],
            [
              -96.94296,
              36.333258
            ],
            [
              -96.9336,
              36.333258
            ],
            [
              -96.92494,
              36.333258
            ],
            [
              -96.92506,
              36.326254
            ],
            [
              -96.92501,
              36.289928
            ],
            [
              -96.92506,
              36.275462
            ],
            [
              -96.92512,
              36.246533
            ],
            [
              -96.90853,
              36.246462
            ],
            [
              -96.908104,
              36.246475
            ],
            [
              -96.90733,
              36.246437
            ],
            [
              -96.89994,
              36.246429
            ],
            [
              -96.89127,
              36.24642
            ],
            [
              -96.88985,
              36.246419
            ],
            [
              -96.87011,
              36.246477
            ],
            [
              -96.86736,
              36.246497
            ],
            [
              -96.818968,
              36.246513
            ],
            [
              -96.81859,
              36.235512
            ],
            [
              -96.81852,
              36.231613
            ],
            [
              -96.818996,
              36.224883
            ],
            [
              -96.81888,
              36.223052
            ],
            [
              -96.81874,
              36.222247
            ],
            [
              -96.81882,
              36.20236
            ],
            [
              -96.81899,
              36.187849
            ],
            [
              -96.81881,
              36.183724
            ],
            [
              -96.818795,
              36.183592
            ],
            [
              -96.81897,
              36.181982
            ],
            [
              -96.81908,
              36.158917
            ],
            [
              -96.80648,
              36.159078
            ],
            [
              -96.80482,
              36.159078
            ],
            [
              -96.79229,
              36.159305
            ],
            [
              -96.78393,
              36.159258
            ],
            [
              -96.76638,
              36.159436
            ],
            [
              -96.74006,
              36.159472
            ],
            [
              -96.7358,
              36.159479
            ],
            [
              -96.72235,
              36.159537
            ],
            [
              -96.71183,
              36.159584
            ],
            [
              -96.66142,
              36.159676
            ],
            [
              -96.659808,
              36.159768
            ],
            [
              -96.64188,
              36.159831
            ],
            [
              -96.6253,
              36.159915
            ],
            [
              -96.6242,
              36.159935
            ],
            [
              -96.62144,
              36.159929
            ],
            [
              -96.62133,
              36.163553
            ],
            [
              -96.499633,
              36.163747
            ],
            [
              -96.39192,
              36.163162
            ],
            [
              -96.297883,
              36.162276
            ],
            [
              -96.268368,
              36.162059
            ],
            [
              -96.27021,
              36.167624
            ],
            [
              -96.26879,
              36.17418
            ],
            [
              -96.26351,
              36.180292
            ],
            [
              -96.24756,
              36.191549
            ],
            [
              -96.24397,
              36.196965
            ],
            [
              -96.24282,
              36.204729
            ],
            [
              -96.24634,
              36.214681
            ],
            [
              -96.25662,
              36.225676
            ],
            [
              -96.26733,
              36.227448
            ],
            [
              -96.29047,
              36.226871
            ],
            [
              -96.30147,
              36.228222
            ],
            [
              -96.32674,
              36.226553
            ],
            [
              -96.34,
              36.230024
            ],
            [
              -96.35148,
              36.23748
            ],
            [
              -96.36289,
              36.250075
            ],
            [
              -96.38679,
              36.267137
            ],
            [
              -96.40131,
              36.273467
            ],
            [
              -96.42243,
              36.277456
            ],
            [
              -96.43381,
              36.28589
            ],
            [
              -96.43791,
              36.293881
            ],
            [
              -96.43917,
              36.305482
            ],
            [
              -96.44138,
              36.312288
            ],
            [
              -96.44907,
              36.324301
            ],
            [
              -96.45608,
              36.331851
            ],
            [
              -96.45768,
              36.332664
            ]
          ]
        ]
      },
      "properties": {
        "county": "40117",
        "name": "Pawnee"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.761625,
              35.973807
            ],
            [
              -95.761647,
              35.975892
            ],
            [
              -95.761672,
              35.982276
            ],
            [
              -95.761672,
              35.987293
            ],
            [
              -95.761678,
              35.990402
            ],
            [
              -95.761651,
              35.992836
            ],
            [
              -95.761646,
              35.994129
            ],
            [
              -95.761659,
              35.995198
            ],
            [
              -95.761641,
              36.000183
            ],
            [
              -95.761653,
              36.006535
            ],
            [
              -95.761673,
              36.017458
            ],
            [
              -95.76166,
              36.02196
            ],
            [
              -95.761663,
              36.022851
            ],
            [
              -95.761658,
              36.023338
            ],
            [
              -95.761664,
              36.023774
            ],
            [
              -95.761662,
              36.025741
            ],
            [
              -95.761642,
              36.026439
            ],
            [
              -95.761636,
              36.027096
            ],
            [
              -95.761644,
              36.027321
            ],
            [
              -95.761635,
              36.028529
            ],
            [
              -95.761631,
              36.029053
            ],
            [
              -95.761614,
              36.02955
            ],
            [
              -95.761615,
              36.02972
            ],
            [
              -95.761684,
              36.036066
            ],
            [
              -95.761662,
              36.046443
            ],
            [
              -95.761679,
              36.050494
            ],
            [
              -95.761684,
              36.053705
            ],
            [
              -95.76168,
              36.055348
            ],
            [
              -95.761676,
              36.057206
            ],
            [
              -95.761693,
              36.06094
            ],
            [
              -95.761673,
              36.068647
            ],
            [
              -95.76169,
              36.071798
            ],
            [
              -95.761689,
              36.072501
            ],
            [
              -95.761663,
              36.075467
            ],
            [
              -95.761763,
              36.085538
            ],
            [
              -95.761681,
              36.087936
            ],
            [
              -95.761683,
              36.089989
            ],
            [
              -95.761706,
              36.104464
            ],
            [
              -95.761659,
              36.118984
            ],
            [
              -95.761693,
              36.133483
            ],
            [
              -95.761685,
              36.137356
            ],
            [
              -95.761666,
              36.139106
            ],
            [
              -95.761697,
              36.148007
            ],
            [
              -95.761672,
              36.152905
            ],
            [
              -95.761684,
              36.156903
            ],
            [
              -95.761667,
              36.160562
            ],
            [
              -95.761684,
              36.161989
            ],
            [
              -95.761683,
              36.162672
            ],
            [
              -95.765101,
              36.162587
            ],
            [
              -95.770369,
              36.162498
            ],
            [
              -95.772815,
              36.162489
            ],
            [
              -95.775963,
              36.162503
            ],
            [
              -95.784416,
              36.162514
            ],
            [
              -95.786589,
              36.162517
            ],
            [
              -95.790415,
              36.162508
            ],
            [
              -95.794456,
              36.162528
            ],
            [
              -95.799889,
              36.162547
            ],
            [
              -95.803059,
              36.162531
            ],
            [
              -95.810774,
              36.162536
            ],
            [
              -95.815357,
              36.162555
            ],
            [
              -95.815365,
              36.170051
            ],
            [
              -95.815365,
              36.174218
            ],
            [
              -95.81537,
              36.176188
            ],
            [
              -95.815377,
              36.177079
            ],
            [
              -95.815378,
              36.178968
            ],
            [
              -95.815376,
              36.179605
            ],
            [
              -95.815313,
              36.191537
            ],
            [
              -95.815337,
              36.200931
            ],
            [
              -95.815325,
              36.204631
            ],
            [
              -95.815341,
              36.20544
            ],
            [
              -95.81538,
              36.206144
            ],
            [
              -95.815274,
              36.226295
            ],
            [
              -95.81527,
              36.227332
            ],
            [
              -95.815288,
              36.235079
            ],
            [
              -95.815293,
              36.235525
            ],
            [
              -95.815307,
              36.239617
            ],
            [
              -95.815343,
              36.24751
            ],
            [
              -95.815348,
              36.247665
            ],
            [
              -95.815351,
              36.249532
            ],
            [
              -95.812025,
              36.249526
            ],
            [
              -95.812208,
              36.278543
            ],
            [
              -95.812194,
              36.281739
            ],
            [
              -95.812189,
              36.283034
            ],
            [
              -95.812179,
              36.28379
            ],
            [
              -95.812193,
              36.286566
            ],
            [
              -95.812198,
              36.288074
            ],
            [
              -95.812192,
              36.288841
            ],
            [
              -95.812195,
              36.289843
            ],
            [
              -95.812195,
              36.290064
            ],
            [
              -95.812188,
              36.290748
            ],
            [
              -95.812211,
              36.297618
            ],
            [
              -95.812214,
              36.298655
            ],
            [
              -95.812218,
              36.30301
            ],
            [
              -95.812215,
              36.304032
            ],
            [
              -95.812204,
              36.310684
            ],
            [
              -95.812206,
              36.311206
            ],
            [
              -95.812176,
              36.312032
            ],
            [
              -95.812176,
              36.312591
            ],
            [
              -95.812156,
              36.314798
            ],
            [
              -95.812187,
              36.317241
            ],
            [
              -95.812202,
              36.318449
            ],
            [
              -95.812211,
              36.319333
            ],
            [
              -95.812229,
              36.320801
            ],
            [
              -95.812256,
              36.336518
            ],
            [
              -95.812292,
              36.337491
            ],
            [
              -95.812291,
              36.337921
            ],
            [
              -95.812274,
              36.340805
            ],
            [
              -95.812269,
              36.351011
            ],
            [
              -95.812264,
              36.353288
            ],
            [
              -95.812211,
              36.365555
            ],
            [
              -95.812205,
              36.3676
            ],
            [
              -95.812197,
              36.38013
            ],
            [
              -95.812189,
              36.381396
            ],
            [
              -95.812215,
              36.384813
            ],
            [
              -95.812218,
              36.385636
            ],
            [
              -95.812252,
              36.39459
            ],
            [
              -95.794284,
              36.394538
            ],
            [
              -95.794307,
              36.40362
            ],
            [
              -95.794349,
              36.408997
            ],
            [
              -95.794399,
              36.416311
            ],
            [
              -95.794389,
              36.417034
            ],
            [
              -95.797812,
              36.42364
            ],
            [
              -95.808791,
              36.423568
            ],
            [
              -95.809162,
              36.423574
            ],
            [
              -95.812423,
              36.423602
            ],
            [
              -95.829827,
              36.42365
            ],
            [
              -95.867904,
              36.423733
            ],
            [
              -95.884201,
              36.423718
            ],
            [
              -95.894142,
              36.423703
            ],
            [
              -95.90235,
              36.423716
            ],
            [
              -95.907095,
              36.423723
            ],
            [
              -95.90769,
              36.423724
            ],
            [
              -95.920484,
              36.423713
            ],
            [
              -95.920943,
              36.42372
            ],
            [
              -95.938012,
              36.423702
            ],
            [
              -95.939646,
              36.423715
            ],
            [
              -95.955975,
              36.423695
            ],
            [
              -95.962716,
              36.423671
            ],
            [
              -95.970574,
              36.423668
            ],
            [
              -95.973467,
              36.423668
            ],
            [
              -95.977228,
              36.423674
            ],
            [
              -95.986104,
              36.423717
            ],
            [
              -96.000668,
              36.423687
            ],
            [
              -96.001181,
              36.423682
            ],
            [
              -96.001146,
              36.383723
            ],
            [
              -96.001195,
              36.372388
            ],
            [
              -96.001287,
              36.370554
            ],
            [
              -96.00131,
              36.368557
            ],
            [
              -96.00131,
              36.367527
            ],
            [
              -96.00129,
              36.365612
            ],
            [
              -96.001263,
              36.363383
            ],
            [
              -96.001261,
              36.361593
            ],
            [
              -96.001278,
              36.360711
            ],
            [
              -96.00131,
              36.351077
            ],
            [
              -96.001459,
              36.312369
            ],
            [
              -96.001463,
              36.308648
            ],
            [
              -96.00145,
              36.307457
            ],
            [
              -96.0015,
              36.300239
            ],
            [
              -96.001523,
              36.292961
            ],
            [
              -96.001444,
              36.291572
            ],
            [
              -96.001419,
              36.288686
            ],
            [
              -96.001457,
              36.285874
            ],
            [
              -96.001493,
              36.28549
            ],
            [
              -96.001498,
              36.279681
            ],
            [
              -96.001391,
              36.250065
            ],
            [
              -96.001406,
              36.238524
            ],
            [
              -96.001389,
              36.234932
            ],
            [
              -96.001444,
              36.225775
            ],
            [
              -96.00143,
              36.223832
            ],
            [
              -96.001211,
              36.165505
            ],
            [
              -96.003727,
              36.161334
            ],
            [
              -96.010708,
              36.161332
            ],
            [
              -96.012673,
              36.161306
            ],
            [
              -96.029226,
              36.161208
            ],
            [
              -96.034889,
              36.161168
            ],
            [
              -96.035948,
              36.161168
            ],
            [
              -96.038211,
              36.161151
            ],
            [
              -96.047195,
              36.161112
            ],
            [
              -96.056175,
              36.161081
            ],
            [
              -96.062533,
              36.161044
            ],
            [
              -96.076978,
              36.161081
            ],
            [
              -96.078563,
              36.161077
            ],
            [
              -96.154199,
              36.161031
            ],
            [
              -96.174957,
              36.161076
            ],
            [
              -96.268368,
              36.162059
            ],
            [
              -96.297883,
              36.162276
            ],
            [
              -96.297874,
              36.104871
            ],
            [
              -96.297852,
              36.091284
            ],
            [
              -96.297793,
              36.07575
            ],
            [
              -96.288819,
              36.07563
            ],
            [
              -96.225223,
              36.075704
            ],
            [
              -96.22044,
              36.075679
            ],
            [
              -96.217086,
              36.075698
            ],
            [
              -96.206682,
              36.075784
            ],
            [
              -96.201446,
              36.075802
            ],
            [
              -96.199186,
              36.075796
            ],
            [
              -96.182741,
              36.075668
            ],
            [
              -96.176091,
              36.075702
            ],
            [
              -96.174486,
              36.075685
            ],
            [
              -96.170683,
              36.075723
            ],
            [
              -96.169262,
              36.075706
            ],
            [
              -96.168178,
              36.075704
            ],
            [
              -96.163708,
              36.075705
            ],
            [
              -96.154844,
              36.075727
            ],
            [
              -96.136981,
              36.075667
            ],
            [
              -96.134176,
              36.075654
            ],
            [
              -96.11903,
              36.075643
            ],
            [
              -96.101085,
              36.075563
            ],
            [
              -96.092149,
              36.075539
            ],
            [
              -96.089381,
              36.075524
            ],
            [
              -96.083241,
              36.075566
            ],
            [
              -96.081677,
              36.07559
            ],
            [
              -96.081317,
              36.07559
            ],
            [
              -96.079994,
              36.07559
            ],
            [
              -96.072002,
              36.075508
            ],
            [
              -96.065434,
              36.07551
            ],
            [
              -96.063166,
              36.075492
            ],
            [
              -96.062079,
              36.075506
            ],
            [
              -96.059861,
              36.075491
            ],
            [
              -96.055374,
              36.075472
            ],
            [
              -96.053778,
              36.075475
            ],
            [
              -96.052331,
              36.07548
            ],
            [
              -96.049715,
              36.075459
            ],
            [
              -96.045401,
              36.075441
            ],
            [
              -96.030376,
              36.075373
            ],
            [
              -96.029569,
              36.075367
            ],
            [
              -96.029503,
              36.03127
            ],
            [
              -96.029512,
              36.024728
            ],
            [
              -96.029515,
              36.017443
            ],
            [
              -96.029532,
              36.014167
            ],
            [
              -96.029582,
              36.00881
            ],
            [
              -96.029789,
              36.001559
            ],
            [
              -96.029804,
              36.000463
            ],
            [
              -96.029755,
              36.000206
            ],
            [
              -96.029555,
              35.999258
            ],
            [
              -96.029658,
              35.995412
            ],
            [
              -96.029755,
              35.994755
            ],
            [
              -96.029743,
              35.99458
            ],
            [
              -96.029622,
              35.994123
            ],
            [
              -96.029534,
              35.993598
            ],
            [
              -96.029566,
              35.988375
            ],
            [
              -96.029545,
              35.987602
            ],
            [
              -96.029512,
              35.980977
            ],
            [
              -96.029475,
              35.959207
            ],
            [
              -96.029487,
              35.951831
            ],
            [
              -96.029506,
              35.94485
            ],
            [
              -96.029507,
              35.940956
            ],
            [
              -96.029544,
              35.923681
            ],
            [
              -96.029554,
              35.918811
            ],
            [
              -96.029559,
              35.915626
            ],
            [
              -96.029553,
              35.914579
            ],
            [
              -96.029558,
              35.912047
            ],
            [
              -96.029571,
              35.903135
            ],
            [
              -96.033395,
              35.901097
            ],
            [
              -96.033248,
              35.875104
            ],
            [
              -96.033121,
              35.856822
            ],
            [
              -96.006428,
              35.856903
            ],
            [
              -95.997911,
              35.856875
            ],
            [
              -95.99601,
              35.856862
            ],
            [
              -95.979772,
              35.856888
            ],
            [
              -95.971456,
              35.856785
            ],
            [
              -95.9686,
              35.856749
            ],
            [
              -95.961856,
              35.856698
            ],
            [
              -95.92619,
              35.856514
            ],
            [
              -95.923198,
              35.856498
            ],
            [
              -95.921388,
              35.856497
            ],
            [
              -95.917955,
              35.856481
            ],
            [
              -95.913496,
              35.85644
            ],
            [
              -95.912278,
              35.856428
            ],
            [
              -95.908397,
              35.856387
            ],
            [
              -95.901855,
              35.856387
            ],
            [
              -95.900468,
              35.856371
            ],
            [
              -95.890569,
              35.856349
            ],
            [
              -95.876274,
              35.856283
            ],
            [
              -95.872774,
              35.856295
            ],
            [
              -95.855014,
              35.856163
            ],
            [
              -95.822777,
              35.856141
            ],
            [
              -95.81941,
              35.856206
            ],
            [
              -95.819409,
              35.870746
            ],
            [
              -95.819354,
              35.877784
            ],
            [
              -95.819378,
              35.885009
            ],
            [
              -95.819455,
              35.901074
            ],
            [
              -95.806621,
              35.901118
            ],
            [
              -95.797313,
              35.901101
            ],
            [
              -95.792448,
              35.901089
            ],
            [
              -95.761663,
              35.900999
            ],
            [
              -95.761562,
              35.909191
            ],
            [
              -95.761567,
              35.917577
            ],
            [
              -95.761577,
              35.933198
            ],
            [
              -95.761584,
              35.937403
            ],
            [
              -95.761588,
              35.959265
            ],
            [
              -95.761625,
              35.973807
            ]
          ]
        ]
      },
      "properties": {
        "county": "40143",
        "name": "Tulsa"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.001177,
              36.424125
            ],
            [
              -96.00102,
              36.500091
            ],
            [
              -96.00067,
              36.599331
            ],
            [
              -96.00105,
              36.644121
            ],
            [
              -96.00064,
              36.673403
            ],
            [
              -96.00096,
              36.736455
            ],
            [
              -96.00065,
              36.750089
            ],
            [
              -96.00057,
              36.81493
            ],
            [
              -96.001,
              36.888774
            ],
            [
              -96.00081,
              36.99886
            ],
            [
              -96.11294,
              36.999205
            ],
            [
              -96.14121,
              36.998973
            ],
            [
              -96.21851,
              36.999047
            ],
            [
              -96.29848,
              36.999414
            ],
            [
              -96.45126,
              36.999103
            ],
            [
              -96.50029,
              36.998643
            ],
            [
              -96.62449,
              36.998985
            ],
            [
              -96.73659,
              36.999286
            ],
            [
              -96.74984,
              36.998988
            ],
            [
              -96.74989,
              36.981488
            ],
            [
              -96.75,
              36.947808
            ],
            [
              -96.75031,
              36.941272
            ],
            [
              -96.75215,
              36.941262
            ],
            [
              -96.75242,
              36.875034
            ],
            [
              -96.75208,
              36.861587
            ],
            [
              -96.7521,
              36.858901
            ],
            [
              -96.75283,
              36.850995
            ],
            [
              -96.75246,
              36.782051
            ],
            [
              -96.78866,
              36.781972
            ],
            [
              -96.78869,
              36.767554
            ],
            [
              -96.81224,
              36.767556
            ],
            [
              -96.81579,
              36.767558
            ],
            [
              -96.818827,
              36.763661
            ],
            [
              -96.81806,
              36.758987
            ],
            [
              -96.82167,
              36.750036
            ],
            [
              -96.82664,
              36.745342
            ],
            [
              -96.8341,
              36.743438
            ],
            [
              -96.83897,
              36.743711
            ],
            [
              -96.85363,
              36.746111
            ],
            [
              -96.86637,
              36.752943
            ],
            [
              -96.87181,
              36.753648
            ],
            [
              -96.87531,
              36.752855
            ],
            [
              -96.88761,
              36.752107
            ],
            [
              -96.89082,
              36.750036
            ],
            [
              -96.89844,
              36.743296
            ],
            [
              -96.90743,
              36.735842
            ],
            [
              -96.90974,
              36.727097
            ],
            [
              -96.92091,
              36.717102
            ],
            [
              -96.9226,
              36.702869
            ],
            [
              -96.9259,
              36.698952
            ],
            [
              -96.92679,
              36.697813
            ],
            [
              -96.92809,
              36.69559
            ],
            [
              -96.927262,
              36.688797
            ],
            [
              -96.93194,
              36.686098
            ],
            [
              -96.94194,
              36.684432
            ],
            [
              -96.943726,
              36.683885
            ],
            [
              -96.95709,
              36.685539
            ],
            [
              -96.96007,
              36.686615
            ],
            [
              -96.96527,
              36.687809
            ],
            [
              -96.96709,
              36.688536
            ],
            [
              -96.9729,
              36.688273
            ],
            [
              -96.97805,
              36.688618
            ],
            [
              -96.98097,
              36.688369
            ],
            [
              -96.98976,
              36.688245
            ],
            [
              -96.99106,
              36.688101
            ],
            [
              -96.99432,
              36.687853
            ],
            [
              -96.99568,
              36.688208
            ],
            [
              -97.00031,
              36.689914
            ],
            [
              -97.01225,
              36.694069
            ],
            [
              -97.01925,
              36.693066
            ],
            [
              -97.02419,
              36.693405
            ],
            [
              -97.02756,
              36.699158
            ],
            [
              -97.03252,
              36.701959
            ],
            [
              -97.03739,
              36.700041
            ],
            [
              -97.04306,
              36.697025
            ],
            [
              -97.05324,
              36.69221
            ],
            [
              -97.06228,
              36.686002
            ],
            [
              -97.06441,
              36.681831
            ],
            [
              -97.06445,
              36.66603
            ],
            [
              -97.06344,
              36.664227
            ],
            [
              -97.06307,
              36.65853
            ],
            [
              -97.06319,
              36.657378
            ],
            [
              -97.06144,
              36.651114
            ],
            [
              -97.05301,
              36.643934
            ],
            [
              -97.0511,
              36.636605
            ],
            [
              -97.05096,
              36.6344
            ],
            [
              -97.05099,
              36.632591
            ],
            [
              -97.0512,
              36.630524
            ],
            [
              -97.04856,
              36.623233
            ],
            [
              -97.04962,
              36.620184
            ],
            [
              -97.05171,
              36.61111
            ],
            [
              -97.04468,
              36.602721
            ],
            [
              -97.044416,
              36.5993
            ],
            [
              -97.04597,
              36.597968
            ],
            [
              -97.0571,
              36.597833
            ],
            [
              -97.05766,
              36.594115
            ],
            [
              -97.05704,
              36.593359
            ],
            [
              -97.045909,
              36.589414
            ],
            [
              -97.0419,
              36.588354
            ],
            [
              -97.02912,
              36.585208
            ],
            [
              -97.02529,
              36.584925
            ],
            [
              -97.01002,
              36.583194
            ],
            [
              -97.006738,
              36.582799
            ],
            [
              -97.00435,
              36.582604
            ],
            [
              -97.00168,
              36.582711
            ],
            [
              -96.98278,
              36.585684
            ],
            [
              -96.978595,
              36.585671
            ],
            [
              -96.971,
              36.586058
            ],
            [
              -96.96537,
              36.586892
            ],
            [
              -96.95559,
              36.589029
            ],
            [
              -96.9486,
              36.589981
            ],
            [
              -96.94157,
              36.594029
            ],
            [
              -96.93386,
              36.595472
            ],
            [
              -96.926431,
              36.599591
            ],
            [
              -96.92048,
              36.600664
            ],
            [
              -96.91277,
              36.598977
            ],
            [
              -96.90871,
              36.595792
            ],
            [
              -96.90645,
              36.592659
            ],
            [
              -96.90446,
              36.588944
            ],
            [
              -96.8883,
              36.57559
            ],
            [
              -96.88821,
              36.573407
            ],
            [
              -96.89037,
              36.563605
            ],
            [
              -96.89908,
              36.553224
            ],
            [
              -96.90679,
              36.552002
            ],
            [
              -96.91615,
              36.552997
            ],
            [
              -96.92621,
              36.552083
            ],
            [
              -96.930465,
              36.550369
            ],
            [
              -96.94398,
              36.543469
            ],
            [
              -96.949923,
              36.537302
            ],
            [
              -96.95852,
              36.534306
            ],
            [
              -96.97148,
              36.535956
            ],
            [
              -96.98815,
              36.532378
            ],
            [
              -97.000316,
              36.526465
            ],
            [
              -97.0083,
              36.516949
            ],
            [
              -97.00917,
              36.514292
            ],
            [
              -97.009785,
              36.506935
            ],
            [
              -97.00696,
              36.489211
            ],
            [
              -97.00076,
              36.481208
            ],
            [
              -96.9938,
              36.47855
            ],
            [
              -96.98434,
              36.471116
            ],
            [
              -96.98196,
              36.466059
            ],
            [
              -96.96725,
              36.460119
            ],
            [
              -96.95436,
              36.460063
            ],
            [
              -96.94023,
              36.455526
            ],
            [
              -96.93382,
              36.45628
            ],
            [
              -96.92563,
              36.462855
            ],
            [
              -96.91754,
              36.463933
            ],
            [
              -96.912476,
              36.467841
            ],
            [
              -96.89773,
              36.468521
            ],
            [
              -96.89045,
              36.472022
            ],
            [
              -96.875314,
              36.47092
            ],
            [
              -96.86643,
              36.480191
            ],
            [
              -96.85474,
              36.487963
            ],
            [
              -96.84267,
              36.506003
            ],
            [
              -96.83791,
              36.511749
            ],
            [
              -96.83771,
              36.520767
            ],
            [
              -96.82637,
              36.529507
            ],
            [
              -96.82105,
              36.538784
            ],
            [
              -96.79815,
              36.553559
            ],
            [
              -96.79088,
              36.555562
            ],
            [
              -96.783215,
              36.560515
            ],
            [
              -96.76947,
              36.565403
            ],
            [
              -96.75355,
              36.562601
            ],
            [
              -96.73724,
              36.550088
            ],
            [
              -96.73267,
              36.543233
            ],
            [
              -96.72695,
              36.526125
            ],
            [
              -96.72349,
              36.520178
            ],
            [
              -96.72315,
              36.508937
            ],
            [
              -96.724852,
              36.503204
            ],
            [
              -96.71698,
              36.494254
            ],
            [
              -96.7079,
              36.489996
            ],
            [
              -96.70619,
              36.477564
            ],
            [
              -96.71774,
              36.455311
            ],
            [
              -96.71721,
              36.445583
            ],
            [
              -96.71368,
              36.440749
            ],
            [
              -96.70367,
              36.434511
            ],
            [
              -96.70263,
              36.431863
            ],
            [
              -96.68943,
              36.423896
            ],
            [
              -96.67493,
              36.420428
            ],
            [
              -96.66437,
              36.422356
            ],
            [
              -96.64541,
              36.424214
            ],
            [
              -96.6376,
              36.425996
            ],
            [
              -96.63082,
              36.423488
            ],
            [
              -96.62332,
              36.417687
            ],
            [
              -96.62065,
              36.410515
            ],
            [
              -96.606139,
              36.402845
            ],
            [
              -96.60424,
              36.398256
            ],
            [
              -96.60188,
              36.382258
            ],
            [
              -96.59431,
              36.376428
            ],
            [
              -96.58313,
              36.373511
            ],
            [
              -96.57408,
              36.374799
            ],
            [
              -96.54851,
              36.396358
            ],
            [
              -96.54072,
              36.400402
            ],
            [
              -96.53499,
              36.399295
            ],
            [
              -96.525926,
              36.393559
            ],
            [
              -96.51858,
              36.377025
            ],
            [
              -96.52068,
              36.367363
            ],
            [
              -96.53393,
              36.356089
            ],
            [
              -96.545913,
              36.352274
            ],
            [
              -96.55397,
              36.351278
            ],
            [
              -96.56129,
              36.346103
            ],
            [
              -96.571696,
              36.333549
            ],
            [
              -96.57348,
              36.315709
            ],
            [
              -96.56389,
              36.306107
            ],
            [
              -96.55246,
              36.299957
            ],
            [
              -96.53641,
              36.29642
            ],
            [
              -96.52528,
              36.296405
            ],
            [
              -96.51523,
              36.298332
            ],
            [
              -96.50223,
              36.307487
            ],
            [
              -96.49638,
              36.319084
            ],
            [
              -96.48803,
              36.32798
            ],
            [
              -96.47752,
              36.33295
            ],
            [
              -96.46599,
              36.334088
            ],
            [
              -96.45768,
              36.332664
            ],
            [
              -96.45608,
              36.331851
            ],
            [
              -96.44907,
              36.324301
            ],
            [
              -96.44138,
              36.312288
            ],
            [
              -96.43917,
              36.305482
            ],
            [
              -96.43791,
              36.293881
            ],
            [
              -96.43381,
              36.28589
            ],
            [
              -96.42243,
              36.277456
            ],
            [
              -96.40131,
              36.273467
            ],
            [
              -96.38679,
              36.267137
            ],
            [
              -96.36289,
              36.250075
            ],
            [
              -96.35148,
              36.23748
            ],
            [
              -96.34,
              36.230024
            ],
            [
              -96.32674,
              36.226553
            ],
            [
              -96.30147,
              36.228222
            ],
            [
              -96.29047,
              36.226871
            ],
            [
              -96.26733,
              36.227448
            ],
            [
              -96.25662,
              36.225676
            ],
            [
              -96.24634,
              36.214681
            ],
            [
              -96.24282,
              36.204729
            ],
            [
              -96.24397,
              36.196965
            ],
            [
              -96.24756,
              36.191549
            ],
            [
              -96.26351,
              36.180292
            ],
            [
              -96.26879,
              36.17418
            ],
            [
              -96.270207,
              36.167624
            ],
            [
              -96.268368,
              36.162059
            ],
            [
              -96.174957,
              36.161076
            ],
            [
              -96.154199,
              36.161031
            ],
            [
              -96.078563,
              36.161077
            ],
            [
              -96.076978,
              36.161081
            ],
            [
              -96.062533,
              36.161044
            ],
            [
              -96.056175,
              36.161081
            ],
            [
              -96.047195,
              36.161112
            ],
            [
              -96.038211,
              36.161151
            ],
            [
              -96.035948,
              36.161168
            ],
            [
              -96.034889,
              36.161168
            ],
            [
              -96.029226,
              36.161208
            ],
            [
              -96.012673,
              36.161306
            ],
            [
              -96.010708,
              36.161332
            ],
            [
              -96.003727,
              36.161334
            ],
            [
              -96.001211,
              36.165505
            ],
            [
              -96.00143,
              36.223832
            ],
            [
              -96.001444,
              36.225775
            ],
            [
              -96.001389,
              36.234932
            ],
            [
              -96.001406,
              36.238524
            ],
            [
              -96.001391,
              36.250065
            ],
            [
              -96.001498,
              36.279681
            ],
            [
              -96.001493,
              36.28549
            ],
            [
              -96.001457,
              36.285874
            ],
            [
              -96.001419,
              36.288686
            ],
            [
              -96.001444,
              36.291572
            ],
            [
              -96.001523,
              36.292961
            ],
            [
              -96.0015,
              36.300239
            ],
            [
              -96.00145,
              36.307457
            ],
            [
              -96.001463,
              36.308648
            ],
            [
              -96.001459,
              36.312369
            ],
            [
              -96.00131,
              36.351077
            ],
            [
              -96.001278,
              36.360711
            ],
            [
              -96.001261,
              36.361593
            ],
            [
              -96.001263,
              36.363383
            ],
            [
              -96.00129,
              36.365612
            ],
            [
              -96.00131,
              36.367527
            ],
            [
              -96.00131,
              36.368557
            ],
            [
              -96.001287,
              36.370554
            ],
            [
              -96.001195,
              36.372388
            ],
            [
              -96.001146,
              36.383723
            ],
            [
              -96.001181,
              36.423682
            ],
            [
              -96.001177,
              36.424125
            ]
          ]
        ]
      },
      "properties": {
        "county": "40113",
        "name": "Osage"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.12736,
              35.683043
            ],
            [
              -95.1275,
              35.716626
            ],
            [
              -95.12753,
              35.750096
            ],
            [
              -95.1276,
              35.764504
            ],
            [
              -95.1277,
              35.768532
            ],
            [
              -95.12767,
              35.776211
            ],
            [
              -95.12765,
              35.783916
            ],
            [
              -95.12764,
              35.784968
            ],
            [
              -95.12757,
              35.792709
            ],
            [
              -95.12755,
              35.797857
            ],
            [
              -95.12753,
              35.805744
            ],
            [
              -95.12751,
              35.812805
            ],
            [
              -95.13171,
              35.812814
            ],
            [
              -95.13624,
              35.812826
            ],
            [
              -95.15452,
              35.812896
            ],
            [
              -95.16332,
              35.812931
            ],
            [
              -95.17208,
              35.812979
            ],
            [
              -95.18089,
              35.813003
            ],
            [
              -95.18577,
              35.813008
            ],
            [
              -95.18894,
              35.813012
            ],
            [
              -95.19889,
              35.813025
            ],
            [
              -95.20679,
              35.813054
            ],
            [
              -95.21401,
              35.81308
            ],
            [
              -95.21668,
              35.813091
            ],
            [
              -95.21852,
              35.813092
            ],
            [
              -95.22239,
              35.813096
            ],
            [
              -95.22935,
              35.813103
            ],
            [
              -95.23194,
              35.813106
            ],
            [
              -95.23552,
              35.813105
            ],
            [
              -95.23605,
              35.813103
            ],
            [
              -95.23883,
              35.813096
            ],
            [
              -95.24011,
              35.813093
            ],
            [
              -95.24535,
              35.81308
            ],
            [
              -95.25024,
              35.813268
            ],
            [
              -95.25221,
              35.813269
            ],
            [
              -95.2543,
              35.813271
            ],
            [
              -95.26568,
              35.813266
            ],
            [
              -95.3246,
              35.81349
            ],
            [
              -95.32571,
              35.813508
            ],
            [
              -95.34446,
              35.813667
            ],
            [
              -95.34658,
              35.816053
            ],
            [
              -95.36143,
              35.820659
            ],
            [
              -95.37525,
              35.814749
            ],
            [
              -95.38105,
              35.813799
            ],
            [
              -95.39765,
              35.808299
            ],
            [
              -95.42025,
              35.799599
            ],
            [
              -95.42695,
              35.798299
            ],
            [
              -95.44615,
              35.799899
            ],
            [
              -95.46205,
              35.803499
            ],
            [
              -95.47165,
              35.804499
            ],
            [
              -95.48385,
              35.802999
            ],
            [
              -95.5204,
              35.792059
            ],
            [
              -95.5446,
              35.788262
            ],
            [
              -95.54788,
              35.789014
            ],
            [
              -95.57363,
              35.776852
            ],
            [
              -95.57729,
              35.77155
            ],
            [
              -95.58566,
              35.764686
            ],
            [
              -95.58862,
              35.764434
            ],
            [
              -95.6057,
              35.775146
            ],
            [
              -95.61182,
              35.777359
            ],
            [
              -95.62152,
              35.777641
            ],
            [
              -95.6316,
              35.782445
            ],
            [
              -95.63842,
              35.787539
            ],
            [
              -95.639,
              35.80908
            ],
            [
              -95.64159,
              35.815464
            ],
            [
              -95.63902,
              35.834441
            ],
            [
              -95.6423,
              35.837795
            ],
            [
              -95.64651,
              35.847336
            ],
            [
              -95.65119,
              35.853928
            ],
            [
              -95.65042,
              35.856756
            ],
            [
              -95.731044,
              35.856503
            ],
            [
              -95.74113,
              35.856586
            ],
            [
              -95.74881,
              35.8566
            ],
            [
              -95.766168,
              35.856457
            ],
            [
              -95.766003,
              35.848985
            ],
            [
              -95.76612,
              35.82753
            ],
            [
              -95.76603,
              35.783889
            ],
            [
              -95.76621,
              35.725713
            ],
            [
              -95.71308,
              35.725877
            ],
            [
              -95.71315,
              35.69258
            ],
            [
              -95.71264,
              35.653251
            ],
            [
              -95.71308,
              35.637335
            ],
            [
              -95.71334,
              35.58566
            ],
            [
              -95.712957,
              35.551802
            ],
            [
              -95.70715,
              35.551773
            ],
            [
              -95.663091,
              35.551836
            ],
            [
              -95.66001,
              35.551881
            ],
            [
              -95.65144,
              35.551856
            ],
            [
              -95.649,
              35.551833
            ],
            [
              -95.64225,
              35.551853
            ],
            [
              -95.631479,
              35.551884
            ],
            [
              -95.6203,
              35.551814
            ],
            [
              -95.61336,
              35.551806
            ],
            [
              -95.57113,
              35.55195
            ],
            [
              -95.54461,
              35.551851
            ],
            [
              -95.49097,
              35.551902
            ],
            [
              -95.48217,
              35.55194
            ],
            [
              -95.48107,
              35.551798
            ],
            [
              -95.47779,
              35.551763
            ],
            [
              -95.45126,
              35.551828
            ],
            [
              -95.36955,
              35.551974
            ],
            [
              -95.36409,
              35.552004
            ],
            [
              -95.34503,
              35.552241
            ],
            [
              -95.34504,
              35.550638
            ],
            [
              -95.34465,
              35.500097
            ],
            [
              -95.34463,
              35.491378
            ],
            [
              -95.34464,
              35.487643
            ],
            [
              -95.34465,
              35.483737
            ],
            [
              -95.34466,
              35.480586
            ],
            [
              -95.34471,
              35.420761
            ],
            [
              -95.34476,
              35.418792
            ],
            [
              -95.34482,
              35.410162
            ],
            [
              -95.34458,
              35.365417
            ],
            [
              -95.34466,
              35.360699
            ],
            [
              -95.34491,
              35.333811
            ],
            [
              -95.34491,
              35.333267
            ],
            [
              -95.344775,
              35.303337
            ],
            [
              -95.34469,
              35.296966
            ],
            [
              -95.34465,
              35.293097
            ],
            [
              -95.34085,
              35.294897
            ],
            [
              -95.34025,
              35.295297
            ],
            [
              -95.33965,
              35.295697
            ],
            [
              -95.33845,
              35.296297
            ],
            [
              -95.33195,
              35.298797
            ],
            [
              -95.31667,
              35.30209
            ],
            [
              -95.30755,
              35.302497
            ],
            [
              -95.30545,
              35.302297
            ],
            [
              -95.29855,
              35.300397
            ],
            [
              -95.29735,
              35.299597
            ],
            [
              -95.28965,
              35.295797
            ],
            [
              -95.28905,
              35.295497
            ],
            [
              -95.27495,
              35.284097
            ],
            [
              -95.27381,
              35.283057
            ],
            [
              -95.26645,
              35.274297
            ],
            [
              -95.26565,
              35.273297
            ],
            [
              -95.26485,
              35.272497
            ],
            [
              -95.25698,
              35.265766
            ],
            [
              -95.243809,
              35.261636
            ],
            [
              -95.23134,
              35.265927
            ],
            [
              -95.22609,
              35.2692
            ],
            [
              -95.2226,
              35.271722
            ],
            [
              -95.22103,
              35.273254
            ],
            [
              -95.21987,
              35.274452
            ],
            [
              -95.20941,
              35.28382
            ],
            [
              -95.20538,
              35.289418
            ],
            [
              -95.2028,
              35.299384
            ],
            [
              -95.19919,
              35.303592
            ],
            [
              -95.18794,
              35.304949
            ],
            [
              -95.17859,
              35.30101
            ],
            [
              -95.171763,
              35.305553
            ],
            [
              -95.17118,
              35.315426
            ],
            [
              -95.17604,
              35.326019
            ],
            [
              -95.17679,
              35.327538
            ],
            [
              -95.18255,
              35.336857
            ],
            [
              -95.18185,
              35.341878
            ],
            [
              -95.17496,
              35.350554
            ],
            [
              -95.17038,
              35.352726
            ],
            [
              -95.15783,
              35.350936
            ],
            [
              -95.1505,
              35.345871
            ],
            [
              -95.146059,
              35.346757
            ],
            [
              -95.14423,
              35.348627
            ],
            [
              -95.14167,
              35.354887
            ],
            [
              -95.1413,
              35.355565
            ],
            [
              -95.14746,
              35.361163
            ],
            [
              -95.14891,
              35.361699
            ],
            [
              -95.15343,
              35.362326
            ],
            [
              -95.15479,
              35.362536
            ],
            [
              -95.159611,
              35.365224
            ],
            [
              -95.16077,
              35.369358
            ],
            [
              -95.140239,
              35.379596
            ],
            [
              -95.13814,
              35.380196
            ],
            [
              -95.13274,
              35.379996
            ],
            [
              -95.12478,
              35.373605
            ],
            [
              -95.12328,
              35.372324
            ],
            [
              -95.11834,
              35.375096
            ],
            [
              -95.11804,
              35.375396
            ],
            [
              -95.11574,
              35.377596
            ],
            [
              -95.11491,
              35.378607
            ],
            [
              -95.11284,
              35.381396
            ],
            [
              -95.11061,
              35.385556
            ],
            [
              -95.10994,
              35.386696
            ],
            [
              -95.10864,
              35.388396
            ],
            [
              -95.10484,
              35.394396
            ],
            [
              -95.10334,
              35.396096
            ],
            [
              -95.10264,
              35.396896
            ],
            [
              -95.10184,
              35.397596
            ],
            [
              -95.08694,
              35.404996
            ],
            [
              -95.08524,
              35.407196
            ],
            [
              -95.08374,
              35.410496
            ],
            [
              -95.08128,
              35.421516
            ],
            [
              -95.08103,
              35.423096
            ],
            [
              -95.08043,
              35.431896
            ],
            [
              -95.07933,
              35.433896
            ],
            [
              -95.07803,
              35.435696
            ],
            [
              -95.07653,
              35.437996
            ],
            [
              -95.07053,
              35.447096
            ],
            [
              -95.06951,
              35.448137
            ],
            [
              -95.06813,
              35.449472
            ],
            [
              -95.06586,
              35.450973
            ],
            [
              -95.06453,
              35.451795
            ],
            [
              -95.06211,
              35.453299
            ],
            [
              -95.056433,
              35.456157
            ],
            [
              -95.05533,
              35.456595
            ],
            [
              -95.05423,
              35.457095
            ],
            [
              -95.04993,
              35.458894
            ],
            [
              -95.061234,
              35.465095
            ],
            [
              -95.06553,
              35.464795
            ],
            [
              -95.075135,
              35.459495
            ],
            [
              -95.07963,
              35.458796
            ],
            [
              -95.08233,
              35.459596
            ],
            [
              -95.08563,
              35.461396
            ],
            [
              -95.08833,
              35.464796
            ],
            [
              -95.09103,
              35.475896
            ],
            [
              -95.09163,
              35.477196
            ],
            [
              -95.09204,
              35.478496
            ],
            [
              -95.09244,
              35.479696
            ],
            [
              -95.097336,
              35.486896
            ],
            [
              -95.102336,
              35.489895
            ],
            [
              -95.106036,
              35.491895
            ],
            [
              -95.106736,
              35.492395
            ],
            [
              -95.115235,
              35.500396
            ],
            [
              -95.123736,
              35.510296
            ],
            [
              -95.125237,
              35.515996
            ],
            [
              -95.13244,
              35.526196
            ],
            [
              -95.132509,
              35.539824
            ],
            [
              -95.132526,
              35.544024
            ],
            [
              -95.13244,
              35.551696
            ],
            [
              -95.12752,
              35.55676
            ],
            [
              -95.127494,
              35.597006
            ],
            [
              -95.12752,
              35.601968
            ],
            [
              -95.127573,
              35.612727
            ],
            [
              -95.12735,
              35.625096
            ],
            [
              -95.12744,
              35.635807
            ],
            [
              -95.12746,
              35.638894
            ],
            [
              -95.12781,
              35.654767
            ],
            [
              -95.12753,
              35.673105
            ],
            [
              -95.12736,
              35.683043
            ]
          ]
        ]
      },
      "properties": {
        "county": "40101",
        "name": "Muskogee"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.761673,
              36.017458
            ],
            [
              -95.761653,
              36.006535
            ],
            [
              -95.761641,
              36.000183
            ],
            [
              -95.761659,
              35.995198
            ],
            [
              -95.761646,
              35.994129
            ],
            [
              -95.761651,
              35.992836
            ],
            [
              -95.761678,
              35.990402
            ],
            [
              -95.761672,
              35.987293
            ],
            [
              -95.761672,
              35.982276
            ],
            [
              -95.761647,
              35.975892
            ],
            [
              -95.761625,
              35.973807
            ],
            [
              -95.761588,
              35.959265
            ],
            [
              -95.761584,
              35.937403
            ],
            [
              -95.761577,
              35.933198
            ],
            [
              -95.761567,
              35.917577
            ],
            [
              -95.761562,
              35.909191
            ],
            [
              -95.761663,
              35.900999
            ],
            [
              -95.792448,
              35.901089
            ],
            [
              -95.797313,
              35.901101
            ],
            [
              -95.806621,
              35.901118
            ],
            [
              -95.819455,
              35.901074
            ],
            [
              -95.819378,
              35.885009
            ],
            [
              -95.819354,
              35.877784
            ],
            [
              -95.819409,
              35.870746
            ],
            [
              -95.81941,
              35.856206
            ],
            [
              -95.801771,
              35.856298
            ],
            [
              -95.794133,
              35.856316
            ],
            [
              -95.771722,
              35.85641
            ],
            [
              -95.74881,
              35.8566
            ],
            [
              -95.74113,
              35.856586
            ],
            [
              -95.731044,
              35.856503
            ],
            [
              -95.65042,
              35.856756
            ],
            [
              -95.65119,
              35.853928
            ],
            [
              -95.64651,
              35.847336
            ],
            [
              -95.6423,
              35.837795
            ],
            [
              -95.63902,
              35.834441
            ],
            [
              -95.64159,
              35.815464
            ],
            [
              -95.639,
              35.80908
            ],
            [
              -95.63842,
              35.787539
            ],
            [
              -95.6316,
              35.782445
            ],
            [
              -95.62152,
              35.777641
            ],
            [
              -95.61182,
              35.777359
            ],
            [
              -95.6057,
              35.775146
            ],
            [
              -95.58862,
              35.764434
            ],
            [
              -95.58566,
              35.764686
            ],
            [
              -95.57729,
              35.77155
            ],
            [
              -95.57363,
              35.776852
            ],
            [
              -95.54788,
              35.789014
            ],
            [
              -95.5446,
              35.788262
            ],
            [
              -95.5204,
              35.792059
            ],
            [
              -95.48385,
              35.802999
            ],
            [
              -95.47165,
              35.804499
            ],
            [
              -95.46205,
              35.803499
            ],
            [
              -95.44615,
              35.799899
            ],
            [
              -95.42695,
              35.798299
            ],
            [
              -95.42025,
              35.799599
            ],
            [
              -95.39765,
              35.808299
            ],
            [
              -95.38105,
              35.813799
            ],
            [
              -95.37525,
              35.814749
            ],
            [
              -95.36143,
              35.820659
            ],
            [
              -95.34658,
              35.816053
            ],
            [
              -95.34446,
              35.813667
            ],
            [
              -95.32571,
              35.813508
            ],
            [
              -95.3246,
              35.81349
            ],
            [
              -95.26568,
              35.813266
            ],
            [
              -95.2665,
              35.820442
            ],
            [
              -95.25568,
              35.82468
            ],
            [
              -95.25248,
              35.828405
            ],
            [
              -95.25317,
              35.832486
            ],
            [
              -95.23723,
              35.847884
            ],
            [
              -95.23146,
              35.851195
            ],
            [
              -95.2275,
              35.862166
            ],
            [
              -95.22934,
              35.869053
            ],
            [
              -95.23652,
              35.873958
            ],
            [
              -95.25024,
              35.875692
            ],
            [
              -95.25089,
              35.875636
            ],
            [
              -95.2577,
              35.877297
            ],
            [
              -95.26499,
              35.884004
            ],
            [
              -95.26863,
              35.890479
            ],
            [
              -95.27101,
              35.892704
            ],
            [
              -95.28156,
              35.904081
            ],
            [
              -95.28313,
              35.910039
            ],
            [
              -95.28292,
              35.912575
            ],
            [
              -95.27874,
              35.921233
            ],
            [
              -95.27662,
              35.923537
            ],
            [
              -95.27136,
              35.927617
            ],
            [
              -95.27001,
              35.92864
            ],
            [
              -95.26885,
              35.938353
            ],
            [
              -95.26898,
              35.939508
            ],
            [
              -95.26918,
              35.940946
            ],
            [
              -95.26936,
              35.943053
            ],
            [
              -95.26942,
              35.944111
            ],
            [
              -95.269691,
              35.946381
            ],
            [
              -95.27363,
              35.956198
            ],
            [
              -95.27856,
              35.961479
            ],
            [
              -95.27888,
              35.96233
            ],
            [
              -95.27761,
              35.966476
            ],
            [
              -95.27113,
              35.974524
            ],
            [
              -95.25778,
              35.982856
            ],
            [
              -95.25498,
              35.984933
            ],
            [
              -95.25219,
              35.987845
            ],
            [
              -95.23844,
              35.987999
            ],
            [
              -95.23444,
              35.991299
            ],
            [
              -95.23427,
              36.002282
            ],
            [
              -95.2303,
              36.002315
            ],
            [
              -95.23025,
              36.009261
            ],
            [
              -95.22547,
              36.0092
            ],
            [
              -95.22534,
              36.039841
            ],
            [
              -95.20797,
              36.039879
            ],
            [
              -95.20792,
              36.049953
            ],
            [
              -95.20792,
              36.060322
            ],
            [
              -95.20795,
              36.074578
            ],
            [
              -95.217259,
              36.074763
            ],
            [
              -95.25908,
              36.074846
            ],
            [
              -95.27529,
              36.07499
            ],
            [
              -95.28638,
              36.075014
            ],
            [
              -95.29027,
              36.074996
            ],
            [
              -95.3146,
              36.07502
            ],
            [
              -95.32323,
              36.075035
            ],
            [
              -95.32458,
              36.075037
            ],
            [
              -95.32934,
              36.075048
            ],
            [
              -95.37043,
              36.075152
            ],
            [
              -95.37688,
              36.075235
            ],
            [
              -95.38187,
              36.07526
            ],
            [
              -95.39877,
              36.075271
            ],
            [
              -95.41494,
              36.075316
            ],
            [
              -95.44012,
              36.075226
            ],
            [
              -95.57152,
              36.075282
            ],
            [
              -95.579377,
              36.080316
            ],
            [
              -95.57844,
              36.084091
            ],
            [
              -95.57097,
              36.082242
            ],
            [
              -95.56268,
              36.084263
            ],
            [
              -95.55639,
              36.082913
            ],
            [
              -95.55259,
              36.091486
            ],
            [
              -95.56129,
              36.099279
            ],
            [
              -95.56815,
              36.107431
            ],
            [
              -95.57056,
              36.113764
            ],
            [
              -95.56784,
              36.129378
            ],
            [
              -95.576191,
              36.133565
            ],
            [
              -95.59351,
              36.135706
            ],
            [
              -95.596233,
              36.12976
            ],
            [
              -95.6047,
              36.13346
            ],
            [
              -95.61059,
              36.142194
            ],
            [
              -95.61794,
              36.150344
            ],
            [
              -95.61853,
              36.162696
            ],
            [
              -95.65227,
              36.162312
            ],
            [
              -95.65332,
              36.162306
            ],
            [
              -95.653725,
              36.162303
            ],
            [
              -95.66845,
              36.162309
            ],
            [
              -95.672721,
              36.162326
            ],
            [
              -95.675684,
              36.162326
            ],
            [
              -95.679244,
              36.162344
            ],
            [
              -95.682856,
              36.162361
            ],
            [
              -95.690459,
              36.162398
            ],
            [
              -95.690729,
              36.162398
            ],
            [
              -95.738956,
              36.162498
            ],
            [
              -95.74398,
              36.162498
            ],
            [
              -95.75726,
              36.162498
            ],
            [
              -95.758751,
              36.162501
            ],
            [
              -95.761683,
              36.162503
            ],
            [
              -95.761684,
              36.161989
            ],
            [
              -95.761667,
              36.160562
            ],
            [
              -95.761684,
              36.156903
            ],
            [
              -95.761672,
              36.152905
            ],
            [
              -95.761697,
              36.148007
            ],
            [
              -95.761666,
              36.139106
            ],
            [
              -95.761685,
              36.137356
            ],
            [
              -95.761693,
              36.133483
            ],
            [
              -95.761659,
              36.118984
            ],
            [
              -95.761706,
              36.104464
            ],
            [
              -95.761683,
              36.089989
            ],
            [
              -95.761681,
              36.087936
            ],
            [
              -95.761763,
              36.085538
            ],
            [
              -95.761663,
              36.075467
            ],
            [
              -95.761689,
              36.072501
            ],
            [
              -95.76169,
              36.071798
            ],
            [
              -95.761673,
              36.068647
            ],
            [
              -95.761693,
              36.06094
            ],
            [
              -95.761676,
              36.057206
            ],
            [
              -95.76168,
              36.055348
            ],
            [
              -95.761684,
              36.053705
            ],
            [
              -95.761679,
              36.050494
            ],
            [
              -95.761662,
              36.046443
            ],
            [
              -95.761684,
              36.036066
            ],
            [
              -95.761615,
              36.02972
            ],
            [
              -95.761614,
              36.02955
            ],
            [
              -95.761631,
              36.029053
            ],
            [
              -95.761635,
              36.028529
            ],
            [
              -95.761644,
              36.027321
            ],
            [
              -95.761636,
              36.027096
            ],
            [
              -95.761642,
              36.026439
            ],
            [
              -95.761662,
              36.025741
            ],
            [
              -95.761664,
              36.023774
            ],
            [
              -95.761658,
              36.023338
            ],
            [
              -95.761663,
              36.022851
            ],
            [
              -95.76166,
              36.02196
            ],
            [
              -95.761673,
              36.017458
            ]
          ]
        ]
      },
      "properties": {
        "county": "40145",
        "name": "Wagoner"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.36008,
              35.116684
            ],
            [
              -99.40927,
              35.116493
            ],
            [
              -99.40929,
              35.114509
            ],
            [
              -99.40559,
              35.10739
            ],
            [
              -99.39798,
              35.102692
            ],
            [
              -99.40085,
              35.098639
            ],
            [
              -99.39857,
              35.094791
            ],
            [
              -99.39083,
              35.090482
            ],
            [
              -99.38592,
              35.093251
            ],
            [
              -99.37648,
              35.091758
            ],
            [
              -99.37581,
              35.088002
            ],
            [
              -99.36814,
              35.086699
            ],
            [
              -99.369971,
              35.079227
            ],
            [
              -99.3652,
              35.065422
            ],
            [
              -99.372808,
              35.060015
            ],
            [
              -99.369926,
              35.052653
            ],
            [
              -99.36256,
              35.050935
            ],
            [
              -99.35215,
              35.052813
            ],
            [
              -99.3502,
              35.043704
            ],
            [
              -99.34246,
              35.041048
            ],
            [
              -99.327788,
              35.041697
            ],
            [
              -99.32359,
              35.038493
            ],
            [
              -99.32477,
              35.030681
            ],
            [
              -99.33593,
              35.025519
            ],
            [
              -99.32676,
              35.018912
            ],
            [
              -99.3288,
              35.011835
            ],
            [
              -99.33249,
              35.010282
            ],
            [
              -99.33641,
              34.997625
            ],
            [
              -99.33505,
              34.988453
            ],
            [
              -99.34809,
              34.983285
            ],
            [
              -99.34361,
              34.971079
            ],
            [
              -99.33433,
              34.972769
            ],
            [
              -99.32891,
              34.952033
            ],
            [
              -99.33082,
              34.94476
            ],
            [
              -99.32078,
              34.941668
            ],
            [
              -99.31019,
              34.932653
            ],
            [
              -99.31538,
              34.927756
            ],
            [
              -99.31295,
              34.925259
            ],
            [
              -99.29839,
              34.924067
            ],
            [
              -99.297273,
              34.917331
            ],
            [
              -99.289412,
              34.902574
            ],
            [
              -99.29622,
              34.901154
            ],
            [
              -99.29282,
              34.895656
            ],
            [
              -99.29247,
              34.886054
            ],
            [
              -99.30644,
              34.889109
            ],
            [
              -99.31586,
              34.885628
            ],
            [
              -99.31817,
              34.877931
            ],
            [
              -99.31728,
              34.871489
            ],
            [
              -99.3113,
              34.866359
            ],
            [
              -99.30622,
              34.857632
            ],
            [
              -99.29644,
              34.851424
            ],
            [
              -99.28791,
              34.852132
            ],
            [
              -99.282244,
              34.84897
            ],
            [
              -99.27794,
              34.839373
            ],
            [
              -99.27013,
              34.841088
            ],
            [
              -99.25644,
              34.836593
            ],
            [
              -99.24972,
              34.828986
            ],
            [
              -99.246462,
              34.822114
            ],
            [
              -99.238656,
              34.816073
            ],
            [
              -99.23349,
              34.816419
            ],
            [
              -99.23083,
              34.825421
            ],
            [
              -99.22072,
              34.829547
            ],
            [
              -99.21305,
              34.82616
            ],
            [
              -99.21333,
              34.838459
            ],
            [
              -99.20917,
              34.839788
            ],
            [
              -99.201499,
              34.837453
            ],
            [
              -99.19322,
              34.843753
            ],
            [
              -99.19186,
              34.847738
            ],
            [
              -99.19316,
              34.856533
            ],
            [
              -99.183079,
              34.859488
            ],
            [
              -99.17313,
              34.855296
            ],
            [
              -99.171299,
              34.848905
            ],
            [
              -99.15649,
              34.847734
            ],
            [
              -99.14726,
              34.850389
            ],
            [
              -99.14432,
              34.847112
            ],
            [
              -99.15046,
              34.843266
            ],
            [
              -99.15341,
              34.835708
            ],
            [
              -99.15205,
              34.831951
            ],
            [
              -99.14516,
              34.830162
            ],
            [
              -99.14625,
              34.826064
            ],
            [
              -99.15366,
              34.827669
            ],
            [
              -99.15192,
              34.817499
            ],
            [
              -99.15373,
              34.805039
            ],
            [
              -99.14898,
              34.798212
            ],
            [
              -99.15368,
              34.792006
            ],
            [
              -99.16259,
              34.793108
            ],
            [
              -99.16543,
              34.788413
            ],
            [
              -99.165569,
              34.773684
            ],
            [
              -99.16263,
              34.767569
            ],
            [
              -99.15175,
              34.763833
            ],
            [
              -99.16438,
              34.758705
            ],
            [
              -99.16097,
              34.754306
            ],
            [
              -99.16391,
              34.751123
            ],
            [
              -99.17304,
              34.755293
            ],
            [
              -99.172458,
              34.746609
            ],
            [
              -99.16855,
              34.742647
            ],
            [
              -99.1623,
              34.742348
            ],
            [
              -99.16103,
              34.731513
            ],
            [
              -99.15468,
              34.724022
            ],
            [
              -99.15454,
              34.718594
            ],
            [
              -99.159372,
              34.713487
            ],
            [
              -99.15873,
              34.710326
            ],
            [
              -99.14911,
              34.702352
            ],
            [
              -99.14068,
              34.700952
            ],
            [
              -99.12959,
              34.702001
            ],
            [
              -99.11422,
              34.69866
            ],
            [
              -99.10573,
              34.698663
            ],
            [
              -99.09858,
              34.69523
            ],
            [
              -99.06169,
              34.701488
            ],
            [
              -99.05251,
              34.701557
            ],
            [
              -99.04575,
              34.692279
            ],
            [
              -99.03962,
              34.691659
            ],
            [
              -99.03795,
              34.68623
            ],
            [
              -99.04314,
              34.68385
            ],
            [
              -99.044,
              34.676955
            ],
            [
              -99.05612,
              34.675147
            ],
            [
              -99.06857,
              34.675285
            ],
            [
              -99.07824,
              34.673337
            ],
            [
              -99.08645,
              34.675626
            ],
            [
              -99.09532,
              34.668912
            ],
            [
              -99.09559,
              34.652719
            ],
            [
              -99.09745,
              34.644907
            ],
            [
              -99.10315,
              34.637989
            ],
            [
              -99.00103,
              34.637819
            ],
            [
              -99.00089,
              34.594345
            ],
            [
              -98.92802,
              34.594475
            ],
            [
              -98.8262,
              34.594222
            ],
            [
              -98.82633,
              34.695944
            ],
            [
              -98.82613,
              34.742681
            ],
            [
              -98.82629,
              34.855411
            ],
            [
              -98.7872,
              34.855752
            ],
            [
              -98.74016,
              34.855062
            ],
            [
              -98.672588,
              34.85548
            ],
            [
              -98.61982,
              34.854953
            ],
            [
              -98.620039,
              35.000537
            ],
            [
              -98.620644,
              35.029121
            ],
            [
              -98.62105,
              35.097352
            ],
            [
              -98.62534,
              35.102378
            ],
            [
              -98.62591,
              35.109191
            ],
            [
              -98.62934,
              35.110361
            ],
            [
              -98.62997,
              35.116385
            ],
            [
              -98.63892,
              35.123169
            ],
            [
              -98.64121,
              35.113275
            ],
            [
              -98.64564,
              35.111605
            ],
            [
              -98.65043,
              35.114836
            ],
            [
              -98.64845,
              35.122234
            ],
            [
              -98.65924,
              35.12187
            ],
            [
              -98.66261,
              35.118115
            ],
            [
              -98.67223,
              35.119009
            ],
            [
              -98.67499,
              35.108955
            ],
            [
              -98.683215,
              35.107856
            ],
            [
              -98.6918,
              35.10884
            ],
            [
              -98.696315,
              35.111909
            ],
            [
              -98.70351,
              35.110511
            ],
            [
              -98.71245,
              35.104761
            ],
            [
              -98.71691,
              35.108906
            ],
            [
              -98.716775,
              35.113349
            ],
            [
              -98.733107,
              35.110893
            ],
            [
              -98.73837,
              35.10686
            ],
            [
              -98.750344,
              35.116343
            ],
            [
              -98.92023,
              35.116373
            ],
            [
              -99.09588,
              35.116483
            ],
            [
              -99.19234,
              35.11651
            ],
            [
              -99.36008,
              35.116684
            ]
          ]
        ]
      },
      "properties": {
        "county": "40075",
        "name": "Kiowa"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.40929,
              35.114509
            ],
            [
              -99.41587,
              35.111766
            ],
            [
              -99.42394,
              35.114057
            ],
            [
              -99.42817,
              35.109294
            ],
            [
              -99.44,
              35.109104
            ],
            [
              -99.443827,
              35.112848
            ],
            [
              -99.44066,
              35.116538
            ],
            [
              -99.49414,
              35.116839
            ],
            [
              -99.54626,
              35.116713
            ],
            [
              -99.636435,
              35.116956
            ],
            [
              -99.676893,
              35.116598
            ],
            [
              -99.78283,
              35.116777
            ],
            [
              -99.78295,
              35.030111
            ],
            [
              -99.866944,
              35.029872
            ],
            [
              -99.88857,
              35.030262
            ],
            [
              -99.88818,
              34.980275
            ],
            [
              -99.888425,
              34.943946
            ],
            [
              -99.81677,
              34.944374
            ],
            [
              -99.73124,
              34.944115
            ],
            [
              -99.73107,
              34.85699
            ],
            [
              -99.72,
              34.857033
            ],
            [
              -99.72045,
              34.81193
            ],
            [
              -99.72007,
              34.768298
            ],
            [
              -99.68501,
              34.768281
            ],
            [
              -99.68493,
              34.753645
            ],
            [
              -99.66736,
              34.753712
            ],
            [
              -99.6669,
              34.724638
            ],
            [
              -99.63475,
              34.724904
            ],
            [
              -99.59713,
              34.724728
            ],
            [
              -99.56132,
              34.725076
            ],
            [
              -99.42319,
              34.725031
            ],
            [
              -99.43187,
              34.730277
            ],
            [
              -99.43981,
              34.726567
            ],
            [
              -99.44261,
              34.730231
            ],
            [
              -99.43704,
              34.736464
            ],
            [
              -99.43967,
              34.741244
            ],
            [
              -99.43851,
              34.748108
            ],
            [
              -99.44066,
              34.761469
            ],
            [
              -99.43732,
              34.769133
            ],
            [
              -99.405695,
              34.76901
            ],
            [
              -99.40579,
              34.813032
            ],
            [
              -99.31708,
              34.812602
            ],
            [
              -99.250361,
              34.812735
            ],
            [
              -99.24642,
              34.811991
            ],
            [
              -99.246462,
              34.822114
            ],
            [
              -99.24972,
              34.828986
            ],
            [
              -99.25644,
              34.836593
            ],
            [
              -99.27013,
              34.841088
            ],
            [
              -99.27794,
              34.839373
            ],
            [
              -99.282244,
              34.84897
            ],
            [
              -99.28791,
              34.852132
            ],
            [
              -99.29644,
              34.851424
            ],
            [
              -99.30622,
              34.857632
            ],
            [
              -99.3113,
              34.866359
            ],
            [
              -99.31728,
              34.871489
            ],
            [
              -99.31817,
              34.877931
            ],
            [
              -99.31586,
              34.885628
            ],
            [
              -99.30644,
              34.889109
            ],
            [
              -99.29247,
              34.886054
            ],
            [
              -99.29282,
              34.895656
            ],
            [
              -99.29622,
              34.901154
            ],
            [
              -99.289412,
              34.902574
            ],
            [
              -99.297273,
              34.917331
            ],
            [
              -99.29839,
              34.924067
            ],
            [
              -99.31295,
              34.925259
            ],
            [
              -99.31538,
              34.927756
            ],
            [
              -99.31019,
              34.932653
            ],
            [
              -99.32078,
              34.941668
            ],
            [
              -99.33082,
              34.94476
            ],
            [
              -99.32891,
              34.952033
            ],
            [
              -99.33433,
              34.972769
            ],
            [
              -99.34361,
              34.971079
            ],
            [
              -99.34809,
              34.983285
            ],
            [
              -99.33505,
              34.988453
            ],
            [
              -99.33641,
              34.997625
            ],
            [
              -99.33249,
              35.010282
            ],
            [
              -99.3288,
              35.011835
            ],
            [
              -99.32676,
              35.018912
            ],
            [
              -99.33593,
              35.025519
            ],
            [
              -99.32477,
              35.030681
            ],
            [
              -99.32359,
              35.038493
            ],
            [
              -99.327788,
              35.041697
            ],
            [
              -99.34246,
              35.041048
            ],
            [
              -99.3502,
              35.043704
            ],
            [
              -99.35215,
              35.052813
            ],
            [
              -99.36256,
              35.050935
            ],
            [
              -99.369926,
              35.052653
            ],
            [
              -99.372808,
              35.060015
            ],
            [
              -99.3652,
              35.065422
            ],
            [
              -99.369971,
              35.079227
            ],
            [
              -99.36814,
              35.086699
            ],
            [
              -99.37581,
              35.088002
            ],
            [
              -99.37648,
              35.091758
            ],
            [
              -99.38592,
              35.093251
            ],
            [
              -99.39083,
              35.090482
            ],
            [
              -99.39857,
              35.094791
            ],
            [
              -99.40085,
              35.098639
            ],
            [
              -99.39798,
              35.102692
            ],
            [
              -99.40559,
              35.10739
            ],
            [
              -99.40929,
              35.114509
            ]
          ]
        ]
      },
      "properties": {
        "county": "40055",
        "name": "Greer"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -100.00256,
              37.001706
            ],
            [
              -100.00262,
              36.944011
            ],
            [
              -100.00324,
              36.90596
            ],
            [
              -100.00405,
              36.775763
            ],
            [
              -100.00368,
              36.746446
            ],
            [
              -100.003385,
              36.644239
            ],
            [
              -100.003,
              36.593195
            ],
            [
              -99.944082,
              36.593443
            ],
            [
              -99.91528,
              36.593152
            ],
            [
              -99.83647,
              36.593299
            ],
            [
              -99.78448,
              36.593116
            ],
            [
              -99.67736,
              36.592981
            ],
            [
              -99.62539,
              36.593113
            ],
            [
              -99.605565,
              36.592753
            ],
            [
              -99.50039,
              36.593288
            ],
            [
              -99.47239,
              36.59409
            ],
            [
              -99.44016,
              36.593876
            ],
            [
              -99.389784,
              36.59405
            ],
            [
              -99.29526,
              36.595123
            ],
            [
              -99.29537,
              36.681777
            ],
            [
              -99.29518,
              36.754248
            ],
            [
              -99.29492,
              36.768697
            ],
            [
              -99.29519,
              36.819566
            ],
            [
              -99.299082,
              36.823909
            ],
            [
              -99.30843,
              36.828882
            ],
            [
              -99.31075,
              36.834717
            ],
            [
              -99.31742,
              36.842331
            ],
            [
              -99.31825,
              36.85002
            ],
            [
              -99.31429,
              36.856191
            ],
            [
              -99.32211,
              36.857214
            ],
            [
              -99.33025,
              36.862972
            ],
            [
              -99.35641,
              36.872015
            ],
            [
              -99.36531,
              36.877569
            ],
            [
              -99.373,
              36.87861
            ],
            [
              -99.37771,
              36.885947
            ],
            [
              -99.38368,
              36.891094
            ],
            [
              -99.38831,
              36.901579
            ],
            [
              -99.38698,
              36.905874
            ],
            [
              -99.393,
              36.912726
            ],
            [
              -99.398092,
              36.921539
            ],
            [
              -99.4049,
              36.925144
            ],
            [
              -99.41399,
              36.935457
            ],
            [
              -99.420519,
              36.941137
            ],
            [
              -99.42822,
              36.955332
            ],
            [
              -99.42722,
              36.959951
            ],
            [
              -99.43405,
              36.970064
            ],
            [
              -99.43919,
              36.980377
            ],
            [
              -99.439949,
              36.990734
            ],
            [
              -99.44341,
              36.995491
            ],
            [
              -99.45288,
              36.995549
            ],
            [
              -99.4562,
              36.999471
            ],
            [
              -99.52562,
              36.999747
            ],
            [
              -99.648652,
              36.999604
            ],
            [
              -99.65766,
              37.000197
            ],
            [
              -99.7225,
              37.00051
            ],
            [
              -99.875409,
              37.001659
            ],
            [
              -100.00256,
              37.001706
            ]
          ]
        ]
      },
      "properties": {
        "county": "40059",
        "name": "Harper"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.98131,
              35.376828
            ],
            [
              -95.98159,
              35.333018
            ],
            [
              -95.98138,
              35.289899
            ],
            [
              -95.98107,
              35.2176
            ],
            [
              -95.98159,
              35.202677
            ],
            [
              -95.98336,
              35.198495
            ],
            [
              -95.98371,
              35.151557
            ],
            [
              -95.96768,
              35.152596
            ],
            [
              -95.94658,
              35.149996
            ],
            [
              -95.928475,
              35.143596
            ],
            [
              -95.91777,
              35.142496
            ],
            [
              -95.90797,
              35.143496
            ],
            [
              -95.89997,
              35.146896
            ],
            [
              -95.888374,
              35.155696
            ],
            [
              -95.88357,
              35.162597
            ],
            [
              -95.87451,
              35.180272
            ],
            [
              -95.87066,
              35.185986
            ],
            [
              -95.85677,
              35.186597
            ],
            [
              -95.84947,
              35.188297
            ],
            [
              -95.839673,
              35.184397
            ],
            [
              -95.82427,
              35.187497
            ],
            [
              -95.81327,
              35.193497
            ],
            [
              -95.80417,
              35.196298
            ],
            [
              -95.79327,
              35.197298
            ],
            [
              -95.78247,
              35.193898
            ],
            [
              -95.76847,
              35.178998
            ],
            [
              -95.75597,
              35.177198
            ],
            [
              -95.74957,
              35.183709
            ],
            [
              -95.74582,
              35.190472
            ],
            [
              -95.74229,
              35.192509
            ],
            [
              -95.72977,
              35.192045
            ],
            [
              -95.71616,
              35.189352
            ],
            [
              -95.71238,
              35.19713
            ],
            [
              -95.70715,
              35.202301
            ],
            [
              -95.68682,
              35.204993
            ],
            [
              -95.67998,
              35.203459
            ],
            [
              -95.67527,
              35.210162
            ],
            [
              -95.682767,
              35.216398
            ],
            [
              -95.68097,
              35.220998
            ],
            [
              -95.67207,
              35.227298
            ],
            [
              -95.65747,
              35.231398
            ],
            [
              -95.63496,
              35.241698
            ],
            [
              -95.62806,
              35.246798
            ],
            [
              -95.61566,
              35.249698
            ],
            [
              -95.606063,
              35.247098
            ],
            [
              -95.603463,
              35.239398
            ],
            [
              -95.60676,
              35.235098
            ],
            [
              -95.61986,
              35.230398
            ],
            [
              -95.62246,
              35.224698
            ],
            [
              -95.616864,
              35.221398
            ],
            [
              -95.60842,
              35.22041
            ],
            [
              -95.59938,
              35.221651
            ],
            [
              -95.594263,
              35.224898
            ],
            [
              -95.586262,
              35.234098
            ],
            [
              -95.572662,
              35.244298
            ],
            [
              -95.56296,
              35.246397
            ],
            [
              -95.55696,
              35.249397
            ],
            [
              -95.54326,
              35.251897
            ],
            [
              -95.52166,
              35.262397
            ],
            [
              -95.51596,
              35.262697
            ],
            [
              -95.51296,
              35.266097
            ],
            [
              -95.51906,
              35.279497
            ],
            [
              -95.51666,
              35.284997
            ],
            [
              -95.51196,
              35.289097
            ],
            [
              -95.50756,
              35.296897
            ],
            [
              -95.50036,
              35.300897
            ],
            [
              -95.49206,
              35.300897
            ],
            [
              -95.48006,
              35.298497
            ],
            [
              -95.461656,
              35.292997
            ],
            [
              -95.45125,
              35.296019
            ],
            [
              -95.43265,
              35.301797
            ],
            [
              -95.427054,
              35.305497
            ],
            [
              -95.41685,
              35.318297
            ],
            [
              -95.411153,
              35.323397
            ],
            [
              -95.39375,
              35.327597
            ],
            [
              -95.38575,
              35.326097
            ],
            [
              -95.37105,
              35.313797
            ],
            [
              -95.35735,
              35.306097
            ],
            [
              -95.35325,
              35.301697
            ],
            [
              -95.35265,
              35.292197
            ],
            [
              -95.34465,
              35.293097
            ],
            [
              -95.34469,
              35.296966
            ],
            [
              -95.344775,
              35.303337
            ],
            [
              -95.34491,
              35.333267
            ],
            [
              -95.34491,
              35.333811
            ],
            [
              -95.34466,
              35.360699
            ],
            [
              -95.34458,
              35.365417
            ],
            [
              -95.34482,
              35.410162
            ],
            [
              -95.34476,
              35.418792
            ],
            [
              -95.34471,
              35.420761
            ],
            [
              -95.34466,
              35.480586
            ],
            [
              -95.34465,
              35.483737
            ],
            [
              -95.34464,
              35.487643
            ],
            [
              -95.34463,
              35.491378
            ],
            [
              -95.34465,
              35.500097
            ],
            [
              -95.34504,
              35.550638
            ],
            [
              -95.34503,
              35.552241
            ],
            [
              -95.36409,
              35.552004
            ],
            [
              -95.36955,
              35.551974
            ],
            [
              -95.45126,
              35.551828
            ],
            [
              -95.47779,
              35.551763
            ],
            [
              -95.48107,
              35.551798
            ],
            [
              -95.48217,
              35.55194
            ],
            [
              -95.49097,
              35.551902
            ],
            [
              -95.54461,
              35.551851
            ],
            [
              -95.57113,
              35.55195
            ],
            [
              -95.61336,
              35.551806
            ],
            [
              -95.6203,
              35.551814
            ],
            [
              -95.631479,
              35.551884
            ],
            [
              -95.64225,
              35.551853
            ],
            [
              -95.649,
              35.551833
            ],
            [
              -95.65144,
              35.551856
            ],
            [
              -95.66001,
              35.551881
            ],
            [
              -95.663091,
              35.551836
            ],
            [
              -95.70715,
              35.551773
            ],
            [
              -95.73103,
              35.551875
            ],
            [
              -95.73111,
              35.551716
            ],
            [
              -95.73856,
              35.551765
            ],
            [
              -95.75027,
              35.551952
            ],
            [
              -95.7715,
              35.551708
            ],
            [
              -95.822317,
              35.551726
            ],
            [
              -95.82242,
              35.514518
            ],
            [
              -95.82248,
              35.507307
            ],
            [
              -95.8234,
              35.463969
            ],
            [
              -95.84032,
              35.463793
            ],
            [
              -95.85224,
              35.463731
            ],
            [
              -95.86083,
              35.463755
            ],
            [
              -95.87442,
              35.463653
            ],
            [
              -95.87527,
              35.463577
            ],
            [
              -95.87559,
              35.453464
            ],
            [
              -95.87559,
              35.445554
            ],
            [
              -95.87568,
              35.432181
            ],
            [
              -95.87566,
              35.431324
            ],
            [
              -95.87563,
              35.412862
            ],
            [
              -95.875627,
              35.408489
            ],
            [
              -95.87564,
              35.391629
            ],
            [
              -95.87565,
              35.389828
            ],
            [
              -95.87563,
              35.37669
            ],
            [
              -95.89396,
              35.376688
            ],
            [
              -95.89535,
              35.376682
            ],
            [
              -95.92855,
              35.376679
            ],
            [
              -95.93744,
              35.376636
            ],
            [
              -95.94147,
              35.376616
            ],
            [
              -95.94362,
              35.376616
            ],
            [
              -95.95037,
              35.37661
            ],
            [
              -95.95665,
              35.37668
            ],
            [
              -95.98131,
              35.376828
            ]
          ]
        ]
      },
      "properties": {
        "county": "40091",
        "name": "Mcintosh"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.77938,
              34.156699
            ],
            [
              -95.82865,
              34.156816
            ],
            [
              -95.87526,
              34.156562
            ],
            [
              -95.99158,
              34.156816
            ],
            [
              -95.9847,
              34.154301
            ],
            [
              -95.973105,
              34.154008
            ],
            [
              -95.96482,
              34.150256
            ],
            [
              -95.95345,
              34.148336
            ],
            [
              -95.95278,
              34.140051
            ],
            [
              -95.94841,
              34.134147
            ],
            [
              -95.95039,
              34.130622
            ],
            [
              -95.943954,
              34.124088
            ],
            [
              -95.93815,
              34.125096
            ],
            [
              -95.93836,
              34.049178
            ],
            [
              -95.93793,
              33.985691
            ],
            [
              -95.93795,
              33.948257
            ],
            [
              -95.9352,
              33.941391
            ],
            [
              -95.92891,
              33.939857
            ],
            [
              -95.92636,
              33.9337
            ],
            [
              -95.91754,
              33.924178
            ],
            [
              -95.90983,
              33.921751
            ],
            [
              -95.89646,
              33.921542
            ],
            [
              -95.88361,
              33.916639
            ],
            [
              -95.87878,
              33.916019
            ],
            [
              -95.87292,
              33.910749
            ],
            [
              -95.865477,
              33.899743
            ],
            [
              -95.86292,
              33.889421
            ],
            [
              -95.85474,
              33.885305
            ],
            [
              -95.8513,
              33.881278
            ],
            [
              -95.84266,
              33.877709
            ],
            [
              -95.8406,
              33.874163
            ],
            [
              -95.83088,
              33.875488
            ],
            [
              -95.81431,
              33.870551
            ],
            [
              -95.80509,
              33.870048
            ],
            [
              -95.79678,
              33.873642
            ],
            [
              -95.78591,
              33.872359
            ],
            [
              -95.78111,
              33.868421
            ],
            [
              -95.77477,
              33.874417
            ],
            [
              -95.76588,
              33.870958
            ],
            [
              -95.76205,
              33.872932
            ],
            [
              -95.76192,
              33.883402
            ],
            [
              -95.75746,
              33.891824
            ],
            [
              -95.750245,
              33.894944
            ],
            [
              -95.74119,
              33.896194
            ],
            [
              -95.72845,
              33.893704
            ],
            [
              -95.715379,
              33.88597
            ],
            [
              -95.710878,
              33.884552
            ],
            [
              -95.69696,
              33.885218
            ],
            [
              -95.68483,
              33.890232
            ],
            [
              -95.67692,
              33.897237
            ],
            [
              -95.66998,
              33.905844
            ],
            [
              -95.65982,
              33.909092
            ],
            [
              -95.647273,
              33.905976
            ],
            [
              -95.63698,
              33.906613
            ],
            [
              -95.62673,
              33.915102
            ],
            [
              -95.62331,
              33.919585
            ],
            [
              -95.6072,
              33.924469
            ],
            [
              -95.603657,
              33.927195
            ],
            [
              -95.59556,
              33.941643
            ],
            [
              -95.58688,
              33.934983
            ],
            [
              -95.58163,
              33.933565
            ],
            [
              -95.56189,
              33.931873
            ],
            [
              -95.55691,
              33.92702
            ],
            [
              -95.54914,
              33.90795
            ],
            [
              -95.55239,
              33.889521
            ],
            [
              -95.54624,
              33.880821
            ],
            [
              -95.53773,
              33.880064
            ],
            [
              -95.53153,
              33.881894
            ],
            [
              -95.51957,
              33.890171
            ],
            [
              -95.51025,
              33.893738
            ],
            [
              -95.505463,
              33.889868
            ],
            [
              -95.50608,
              33.87639
            ],
            [
              -95.5023,
              33.874742
            ],
            [
              -95.49203,
              33.874822
            ],
            [
              -95.47857,
              33.879301
            ],
            [
              -95.46532,
              33.88773
            ],
            [
              -95.46008,
              33.8842
            ],
            [
              -95.46433,
              33.874373
            ],
            [
              -95.44874,
              33.869079
            ],
            [
              -95.43905,
              33.870065
            ],
            [
              -95.42308,
              33.867546
            ],
            [
              -95.40549,
              33.866308
            ],
            [
              -95.39182,
              33.867473
            ],
            [
              -95.38386,
              33.869508
            ],
            [
              -95.353,
              33.867902
            ],
            [
              -95.33912,
              33.868873
            ],
            [
              -95.33447,
              33.878456
            ],
            [
              -95.33452,
              33.885788
            ],
            [
              -95.32557,
              33.885704
            ],
            [
              -95.30987,
              33.879489
            ],
            [
              -95.29536,
              33.872633
            ],
            [
              -95.28218,
              33.875844
            ],
            [
              -95.27951,
              33.879713
            ],
            [
              -95.28039,
              33.886949
            ],
            [
              -95.285301,
              33.898101
            ],
            [
              -95.28362,
              33.9049
            ],
            [
              -95.27709,
              33.910921
            ],
            [
              -95.27143,
              33.912568
            ],
            [
              -95.26781,
              33.908033
            ],
            [
              -95.26729,
              33.896722
            ],
            [
              -95.26911,
              33.8899
            ],
            [
              -95.26183,
              33.887081
            ],
            [
              -95.25353,
              33.894198
            ],
            [
              -95.249922,
              33.902024
            ],
            [
              -95.24831,
              33.915487
            ],
            [
              -95.25302,
              33.927237
            ],
            [
              -95.25167,
              33.935548
            ],
            [
              -95.24479,
              33.941591
            ],
            [
              -95.23304,
              33.948783
            ],
            [
              -95.23166,
              33.959683
            ],
            [
              -95.22639,
              33.961954
            ],
            [
              -95.21936,
              33.961567
            ],
            [
              -95.21051,
              33.957609
            ],
            [
              -95.18638,
              33.951177
            ],
            [
              -95.18023,
              33.948476
            ],
            [
              -95.166686,
              33.939728
            ],
            [
              -95.15589,
              33.936831
            ],
            [
              -95.15659,
              33.997268
            ],
            [
              -95.156352,
              34.069925
            ],
            [
              -95.15644,
              34.157027
            ],
            [
              -95.27465,
              34.156911
            ],
            [
              -95.34333,
              34.15705
            ],
            [
              -95.47611,
              34.156718
            ],
            [
              -95.59215,
              34.156869
            ],
            [
              -95.677586,
              34.156599
            ],
            [
              -95.72645,
              34.156964
            ],
            [
              -95.73026,
              34.156454
            ],
            [
              -95.77938,
              34.156699
            ]
          ]
        ]
      },
      "properties": {
        "county": "40023",
        "name": "Choctaw"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.970006,
              34.07083
            ],
            [
              -96.98273,
              34.070995
            ],
            [
              -97.097097,
              34.070822
            ],
            [
              -97.11683,
              34.070984
            ],
            [
              -97.23064,
              34.070873
            ],
            [
              -97.282607,
              34.071329
            ],
            [
              -97.35262,
              34.071126
            ],
            [
              -97.5003,
              34.071321
            ],
            [
              -97.56076,
              34.071089
            ],
            [
              -97.56087,
              34.002978
            ],
            [
              -97.55642,
              34.001988
            ],
            [
              -97.55133,
              33.997095
            ],
            [
              -97.54515,
              33.98759
            ],
            [
              -97.53682,
              33.983877
            ],
            [
              -97.560927,
              33.983973
            ],
            [
              -97.56086,
              33.899645
            ],
            [
              -97.55827,
              33.897099
            ],
            [
              -97.55154,
              33.897947
            ],
            [
              -97.54325,
              33.901289
            ],
            [
              -97.5241,
              33.911705
            ],
            [
              -97.50096,
              33.919643
            ],
            [
              -97.486505,
              33.916994
            ],
            [
              -97.47054,
              33.908984
            ],
            [
              -97.45834,
              33.901887
            ],
            [
              -97.451063,
              33.891673
            ],
            [
              -97.45218,
              33.86896
            ],
            [
              -97.45572,
              33.858104
            ],
            [
              -97.46061,
              33.851713
            ],
            [
              -97.46286,
              33.841772
            ],
            [
              -97.45953,
              33.835245
            ],
            [
              -97.45306,
              33.828536
            ],
            [
              -97.444193,
              33.823773
            ],
            [
              -97.42649,
              33.819398
            ],
            [
              -97.41785,
              33.819855
            ],
            [
              -97.40336,
              33.81882
            ],
            [
              -97.39513,
              33.819963
            ],
            [
              -97.37294,
              33.819454
            ],
            [
              -97.36551,
              33.823763
            ],
            [
              -97.35733,
              33.831369
            ],
            [
              -97.354318,
              33.837965
            ],
            [
              -97.34675,
              33.846945
            ],
            [
              -97.34005,
              33.859841
            ],
            [
              -97.337244,
              33.875101
            ],
            [
              -97.33188,
              33.884483
            ],
            [
              -97.32581,
              33.883888
            ],
            [
              -97.32422,
              33.876628
            ],
            [
              -97.33338,
              33.864148
            ],
            [
              -97.33462,
              33.857231
            ],
            [
              -97.326,
              33.856911
            ],
            [
              -97.31441,
              33.866989
            ],
            [
              -97.3095,
              33.877751
            ],
            [
              -97.3112,
              33.887095
            ],
            [
              -97.30763,
              33.888011
            ],
            [
              -97.28973,
              33.87168
            ],
            [
              -97.28281,
              33.866503
            ],
            [
              -97.27153,
              33.86256
            ],
            [
              -97.25564,
              33.863698
            ],
            [
              -97.24921,
              33.875101
            ],
            [
              -97.24618,
              33.900344
            ],
            [
              -97.24209,
              33.906277
            ],
            [
              -97.231546,
              33.910174
            ],
            [
              -97.22718,
              33.914344
            ],
            [
              -97.210316,
              33.915927
            ],
            [
              -97.20037,
              33.908761
            ],
            [
              -97.18546,
              33.9007
            ],
            [
              -97.17961,
              33.89225
            ],
            [
              -97.176975,
              33.876699
            ],
            [
              -97.16868,
              33.856037
            ],
            [
              -97.16663,
              33.847311
            ],
            [
              -97.166824,
              33.840395
            ],
            [
              -97.17163,
              33.835335
            ],
            [
              -97.179943,
              33.831673
            ],
            [
              -97.19468,
              33.831192
            ],
            [
              -97.19748,
              33.829795
            ],
            [
              -97.20505,
              33.818046
            ],
            [
              -97.2057,
              33.802908
            ],
            [
              -97.20049,
              33.793198
            ],
            [
              -97.1904,
              33.781153
            ],
            [
              -97.18779,
              33.769702
            ],
            [
              -97.19339,
              33.760587
            ],
            [
              -97.19053,
              33.757816
            ],
            [
              -97.18014,
              33.754495
            ],
            [
              -97.17463,
              33.745035
            ],
            [
              -97.17219,
              33.737545
            ],
            [
              -97.16315,
              33.729322
            ],
            [
              -97.15126,
              33.722608
            ],
            [
              -97.13753,
              33.718664
            ],
            [
              -97.1261,
              33.716941
            ],
            [
              -97.11132,
              33.719377
            ],
            [
              -97.09715,
              33.727809
            ],
            [
              -97.08874,
              33.738711
            ],
            [
              -97.08619,
              33.743933
            ],
            [
              -97.08461,
              33.759993
            ],
            [
              -97.08656,
              33.770527
            ],
            [
              -97.09392,
              33.789052
            ],
            [
              -97.094771,
              33.798532
            ],
            [
              -97.088,
              33.808747
            ],
            [
              -97.07415,
              33.813901
            ],
            [
              -97.04797,
              33.817931
            ],
            [
              -97.048245,
              33.82693
            ],
            [
              -97.05313,
              33.833503
            ],
            [
              -97.059988,
              33.837214
            ],
            [
              -97.06959,
              33.839412
            ],
            [
              -97.08726,
              33.839799
            ],
            [
              -97.09072,
              33.846738
            ],
            [
              -97.08716,
              33.85402
            ],
            [
              -97.07099,
              33.860342
            ],
            [
              -97.06333,
              33.859655
            ],
            [
              -97.05727,
              33.85693
            ],
            [
              -97.04819,
              33.842753
            ],
            [
              -97.04124,
              33.837761
            ],
            [
              -97.02346,
              33.844465
            ],
            [
              -97.015522,
              33.85369
            ],
            [
              -97.00437,
              33.864058
            ],
            [
              -96.99549,
              33.87629
            ],
            [
              -96.98557,
              33.886522
            ],
            [
              -96.98397,
              33.892083
            ],
            [
              -96.98494,
              33.904866
            ],
            [
              -96.98785,
              33.916985
            ],
            [
              -96.994,
              33.928979
            ],
            [
              -96.99625,
              33.942664
            ],
            [
              -96.99429,
              33.949206
            ],
            [
              -96.98849,
              33.954413
            ],
            [
              -96.979347,
              33.95513
            ],
            [
              -96.98096,
              33.948289
            ],
            [
              -96.97982,
              33.941588
            ],
            [
              -96.97287,
              33.935698
            ],
            [
              -96.96601,
              33.939707
            ],
            [
              -96.95361,
              33.94417
            ],
            [
              -96.93484,
              33.954453
            ],
            [
              -96.93479,
              34.012942
            ],
            [
              -96.96972,
              34.013008
            ],
            [
              -96.970006,
              34.07083
            ]
          ]
        ]
      },
      "properties": {
        "county": "40085",
        "name": "Love"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.62487,
              35.462726
            ],
            [
              -96.7008,
              35.462766
            ],
            [
              -96.84162,
              35.463565
            ],
            [
              -97.001017,
              35.463527
            ],
            [
              -97.12061,
              35.463591
            ],
            [
              -97.14123,
              35.464064
            ],
            [
              -97.14125,
              35.462424
            ],
            [
              -97.1413,
              35.461153
            ],
            [
              -97.14143,
              35.452001
            ],
            [
              -97.14136,
              35.449361
            ],
            [
              -97.14133,
              35.448897
            ],
            [
              -97.14138,
              35.448009
            ],
            [
              -97.14156,
              35.438719
            ],
            [
              -97.14149,
              35.437281
            ],
            [
              -97.14148,
              35.434786
            ],
            [
              -97.14178,
              35.429221
            ],
            [
              -97.14167,
              35.425809
            ],
            [
              -97.14167,
              35.423686
            ],
            [
              -97.14178,
              35.422016
            ],
            [
              -97.14173,
              35.42094
            ],
            [
              -97.14175,
              35.418786
            ],
            [
              -97.14181,
              35.417874
            ],
            [
              -97.14171,
              35.416626
            ],
            [
              -97.14178,
              35.415202
            ],
            [
              -97.14173,
              35.412546
            ],
            [
              -97.14171,
              35.41173
            ],
            [
              -97.14184,
              35.40989
            ],
            [
              -97.14181,
              35.407826
            ],
            [
              -97.141753,
              35.405974
            ],
            [
              -97.14184,
              35.399634
            ],
            [
              -97.14176,
              35.397762
            ],
            [
              -97.14176,
              35.397678
            ],
            [
              -97.14184,
              35.396002
            ],
            [
              -97.14181,
              35.38309
            ],
            [
              -97.141937,
              35.381666
            ],
            [
              -97.14206,
              35.379554
            ],
            [
              -97.14182,
              35.376818
            ],
            [
              -97.14214,
              35.366867
            ],
            [
              -97.1421,
              35.362291
            ],
            [
              -97.14219,
              35.347715
            ],
            [
              -97.14203,
              35.340641
            ],
            [
              -97.14203,
              35.340531
            ],
            [
              -97.14203,
              35.338979
            ],
            [
              -97.14203,
              35.336088
            ],
            [
              -97.14203,
              35.333155
            ],
            [
              -97.14205,
              35.318596
            ],
            [
              -97.14195,
              35.3041
            ],
            [
              -97.14179,
              35.298932
            ],
            [
              -97.14196,
              35.292377
            ],
            [
              -97.14203,
              35.289604
            ],
            [
              -97.14208,
              35.278853
            ],
            [
              -97.14185,
              35.228195
            ],
            [
              -97.14182,
              35.226374
            ],
            [
              -97.1416,
              35.202966
            ],
            [
              -97.14221,
              35.192711
            ],
            [
              -97.14222,
              35.190231
            ],
            [
              -97.14219,
              35.166655
            ],
            [
              -97.14229,
              35.145208
            ],
            [
              -97.142303,
              35.137496
            ],
            [
              -97.1419,
              35.121435
            ],
            [
              -97.1418,
              35.116111
            ],
            [
              -97.14184,
              35.113821
            ],
            [
              -97.14194,
              35.101733
            ],
            [
              -97.14186,
              35.10029
            ],
            [
              -97.14222,
              35.098184
            ],
            [
              -97.14206,
              35.095917
            ],
            [
              -97.14194,
              35.027181
            ],
            [
              -97.14184,
              35.014801
            ],
            [
              -97.14197,
              34.975858
            ],
            [
              -97.142016,
              34.971379
            ],
            [
              -97.142,
              34.956862
            ],
            [
              -97.142,
              34.943719
            ],
            [
              -97.142257,
              34.928448
            ],
            [
              -97.135225,
              34.926571
            ],
            [
              -97.125955,
              34.935584
            ],
            [
              -97.121687,
              34.933889
            ],
            [
              -97.120527,
              34.925533
            ],
            [
              -97.11366,
              34.921816
            ],
            [
              -97.107924,
              34.927581
            ],
            [
              -97.098241,
              34.925613
            ],
            [
              -97.088814,
              34.93164
            ],
            [
              -97.07345,
              34.927445
            ],
            [
              -97.064288,
              34.926509
            ],
            [
              -97.03914,
              34.913884
            ],
            [
              -97.018012,
              34.909076
            ],
            [
              -97.0097,
              34.909018
            ],
            [
              -96.997821,
              34.914301
            ],
            [
              -96.98757,
              34.926843
            ],
            [
              -96.97858,
              34.929535
            ],
            [
              -96.975797,
              34.932993
            ],
            [
              -96.965698,
              34.936435
            ],
            [
              -96.957636,
              34.948713
            ],
            [
              -96.944912,
              34.961573
            ],
            [
              -96.933751,
              34.965742
            ],
            [
              -96.92977,
              34.96513
            ],
            [
              -96.92129,
              34.963986
            ],
            [
              -96.91061,
              34.958659
            ],
            [
              -96.90316,
              34.946092
            ],
            [
              -96.89684,
              34.94219
            ],
            [
              -96.89053,
              34.932617
            ],
            [
              -96.88891,
              34.92748
            ],
            [
              -96.87632,
              34.926029
            ],
            [
              -96.868097,
              34.929415
            ],
            [
              -96.85237,
              34.92877
            ],
            [
              -96.84137,
              34.933797
            ],
            [
              -96.834995,
              34.939427
            ],
            [
              -96.82149,
              34.946112
            ],
            [
              -96.81177,
              34.943504
            ],
            [
              -96.79821,
              34.929992
            ],
            [
              -96.7994,
              34.919352
            ],
            [
              -96.79908,
              34.9064
            ],
            [
              -96.79059,
              34.900834
            ],
            [
              -96.78507,
              34.899145
            ],
            [
              -96.77568,
              34.899958
            ],
            [
              -96.77578,
              34.956661
            ],
            [
              -96.77528,
              35.028913
            ],
            [
              -96.7756,
              35.130355
            ],
            [
              -96.77692,
              35.173724
            ],
            [
              -96.77682,
              35.268149
            ],
            [
              -96.777117,
              35.289668
            ],
            [
              -96.77662,
              35.354476
            ],
            [
              -96.7767,
              35.411374
            ],
            [
              -96.77056,
              35.407146
            ],
            [
              -96.7677,
              35.40951
            ],
            [
              -96.767483,
              35.408955
            ],
            [
              -96.74296,
              35.40681
            ],
            [
              -96.740055,
              35.409215
            ],
            [
              -96.74162,
              35.414525
            ],
            [
              -96.73637,
              35.415237
            ],
            [
              -96.73735,
              35.420135
            ],
            [
              -96.73201,
              35.423227
            ],
            [
              -96.72166,
              35.424604
            ],
            [
              -96.71674,
              35.418127
            ],
            [
              -96.711341,
              35.415702
            ],
            [
              -96.70208,
              35.415657
            ],
            [
              -96.70052,
              35.409523
            ],
            [
              -96.69302,
              35.408974
            ],
            [
              -96.69003,
              35.403823
            ],
            [
              -96.682988,
              35.405952
            ],
            [
              -96.67454,
              35.400457
            ],
            [
              -96.66535,
              35.399015
            ],
            [
              -96.66152,
              35.395512
            ],
            [
              -96.65442,
              35.395579
            ],
            [
              -96.65227,
              35.391755
            ],
            [
              -96.64301,
              35.393881
            ],
            [
              -96.637727,
              35.397793
            ],
            [
              -96.62996,
              35.393143
            ],
            [
              -96.6237,
              35.400956
            ],
            [
              -96.62376,
              35.43537
            ],
            [
              -96.62487,
              35.462726
            ]
          ]
        ]
      },
      "properties": {
        "county": "40125",
        "name": "Pottawatomie"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.10315,
              34.637989
            ],
            [
              -99.09745,
              34.644907
            ],
            [
              -99.09559,
              34.652719
            ],
            [
              -99.09532,
              34.668912
            ],
            [
              -99.08645,
              34.675626
            ],
            [
              -99.07824,
              34.673337
            ],
            [
              -99.06857,
              34.675285
            ],
            [
              -99.05612,
              34.675147
            ],
            [
              -99.044,
              34.676955
            ],
            [
              -99.04314,
              34.68385
            ],
            [
              -99.03795,
              34.68623
            ],
            [
              -99.03962,
              34.691659
            ],
            [
              -99.04575,
              34.692279
            ],
            [
              -99.05251,
              34.701557
            ],
            [
              -99.06169,
              34.701488
            ],
            [
              -99.09858,
              34.69523
            ],
            [
              -99.10573,
              34.698663
            ],
            [
              -99.11422,
              34.69866
            ],
            [
              -99.12959,
              34.702001
            ],
            [
              -99.14068,
              34.700952
            ],
            [
              -99.14911,
              34.702352
            ],
            [
              -99.15873,
              34.710326
            ],
            [
              -99.159372,
              34.713487
            ],
            [
              -99.15454,
              34.718594
            ],
            [
              -99.15468,
              34.724022
            ],
            [
              -99.16103,
              34.731513
            ],
            [
              -99.1623,
              34.742348
            ],
            [
              -99.16855,
              34.742647
            ],
            [
              -99.172458,
              34.746609
            ],
            [
              -99.17304,
              34.755293
            ],
            [
              -99.16391,
              34.751123
            ],
            [
              -99.16097,
              34.754306
            ],
            [
              -99.16438,
              34.758705
            ],
            [
              -99.15175,
              34.763833
            ],
            [
              -99.16263,
              34.767569
            ],
            [
              -99.165569,
              34.773684
            ],
            [
              -99.16543,
              34.788413
            ],
            [
              -99.16259,
              34.793108
            ],
            [
              -99.15368,
              34.792006
            ],
            [
              -99.14898,
              34.798212
            ],
            [
              -99.15373,
              34.805039
            ],
            [
              -99.15192,
              34.817499
            ],
            [
              -99.15366,
              34.827669
            ],
            [
              -99.14625,
              34.826064
            ],
            [
              -99.14516,
              34.830162
            ],
            [
              -99.15205,
              34.831951
            ],
            [
              -99.15341,
              34.835708
            ],
            [
              -99.15046,
              34.843266
            ],
            [
              -99.14432,
              34.847112
            ],
            [
              -99.14726,
              34.850389
            ],
            [
              -99.15649,
              34.847734
            ],
            [
              -99.171299,
              34.848905
            ],
            [
              -99.17313,
              34.855296
            ],
            [
              -99.183079,
              34.859488
            ],
            [
              -99.19316,
              34.856533
            ],
            [
              -99.19186,
              34.847738
            ],
            [
              -99.19322,
              34.843753
            ],
            [
              -99.201499,
              34.837453
            ],
            [
              -99.20917,
              34.839788
            ],
            [
              -99.21333,
              34.838459
            ],
            [
              -99.21305,
              34.82616
            ],
            [
              -99.22072,
              34.829547
            ],
            [
              -99.23083,
              34.825421
            ],
            [
              -99.23349,
              34.816419
            ],
            [
              -99.238656,
              34.816073
            ],
            [
              -99.246462,
              34.822114
            ],
            [
              -99.24642,
              34.811991
            ],
            [
              -99.250361,
              34.812735
            ],
            [
              -99.31708,
              34.812602
            ],
            [
              -99.40579,
              34.813032
            ],
            [
              -99.405695,
              34.76901
            ],
            [
              -99.43732,
              34.769133
            ],
            [
              -99.44066,
              34.761469
            ],
            [
              -99.43851,
              34.748108
            ],
            [
              -99.43967,
              34.741244
            ],
            [
              -99.43704,
              34.736464
            ],
            [
              -99.44261,
              34.730231
            ],
            [
              -99.43981,
              34.726567
            ],
            [
              -99.43187,
              34.730277
            ],
            [
              -99.42319,
              34.725031
            ],
            [
              -99.56132,
              34.725076
            ],
            [
              -99.59713,
              34.724728
            ],
            [
              -99.63475,
              34.724904
            ],
            [
              -99.6669,
              34.724638
            ],
            [
              -99.66668,
              34.710003
            ],
            [
              -99.6666,
              34.608484
            ],
            [
              -99.66656,
              34.507131
            ],
            [
              -99.77162,
              34.507171
            ],
            [
              -99.84458,
              34.506915
            ],
            [
              -99.82604,
              34.497779
            ],
            [
              -99.82184,
              34.497848
            ],
            [
              -99.81672,
              34.489718
            ],
            [
              -99.81857,
              34.484495
            ],
            [
              -99.81431,
              34.476204
            ],
            [
              -99.80286,
              34.465668
            ],
            [
              -99.79368,
              34.453894
            ],
            [
              -99.78608,
              34.451099
            ],
            [
              -99.78376,
              34.445005
            ],
            [
              -99.77574,
              34.444225
            ],
            [
              -99.7656,
              34.437488
            ],
            [
              -99.76723,
              34.430502
            ],
            [
              -99.75961,
              34.426674
            ],
            [
              -99.75345,
              34.420853
            ],
            [
              -99.74091,
              34.414763
            ],
            [
              -99.72703,
              34.410554
            ],
            [
              -99.72078,
              34.40657
            ],
            [
              -99.71459,
              34.399563
            ],
            [
              -99.71484,
              34.394524
            ],
            [
              -99.706658,
              34.385981
            ],
            [
              -99.70119,
              34.385203
            ],
            [
              -99.694528,
              34.378218
            ],
            [
              -99.67828,
              34.379799
            ],
            [
              -99.66395,
              34.37368
            ],
            [
              -99.652674,
              34.377412
            ],
            [
              -99.64814,
              34.382312
            ],
            [
              -99.63242,
              34.378093
            ],
            [
              -99.6242,
              34.373577
            ],
            [
              -99.60585,
              34.376676
            ],
            [
              -99.60003,
              34.374688
            ],
            [
              -99.59298,
              34.382407
            ],
            [
              -99.587596,
              34.385867
            ],
            [
              -99.58453,
              34.391205
            ],
            [
              -99.58437,
              34.408154
            ],
            [
              -99.57976,
              34.416928
            ],
            [
              -99.5697,
              34.418418
            ],
            [
              -99.5622,
              34.417319
            ],
            [
              -99.550514,
              34.412944
            ],
            [
              -99.54153,
              34.413241
            ],
            [
              -99.52979,
              34.411452
            ],
            [
              -99.51762,
              34.414494
            ],
            [
              -99.50762,
              34.409887
            ],
            [
              -99.50037,
              34.409677
            ],
            [
              -99.48722,
              34.397955
            ],
            [
              -99.47348,
              34.39544
            ],
            [
              -99.46608,
              34.395991
            ],
            [
              -99.46215,
              34.391229
            ],
            [
              -99.460741,
              34.38076
            ],
            [
              -99.45602,
              34.380486
            ],
            [
              -99.45265,
              34.388252
            ],
            [
              -99.43798,
              34.371238
            ],
            [
              -99.43076,
              34.371183
            ],
            [
              -99.42996,
              34.379801
            ],
            [
              -99.4272,
              34.385229
            ],
            [
              -99.42339,
              34.385755
            ],
            [
              -99.42043,
              34.380464
            ],
            [
              -99.41281,
              34.377061
            ],
            [
              -99.408848,
              34.372776
            ],
            [
              -99.398635,
              34.375832
            ],
            [
              -99.39601,
              34.382566
            ],
            [
              -99.39647,
              34.392736
            ],
            [
              -99.39149,
              34.405631
            ],
            [
              -99.38693,
              34.410943
            ],
            [
              -99.39649,
              34.417291
            ],
            [
              -99.39701,
              34.424003
            ],
            [
              -99.39278,
              34.431492
            ],
            [
              -99.39587,
              34.435044
            ],
            [
              -99.39496,
              34.442099
            ],
            [
              -99.38901,
              34.446929
            ],
            [
              -99.381814,
              34.456157
            ],
            [
              -99.37536,
              34.458845
            ],
            [
              -99.35879,
              34.455863
            ],
            [
              -99.35467,
              34.451857
            ],
            [
              -99.35671,
              34.442144
            ],
            [
              -99.34001,
              34.430145
            ],
            [
              -99.33404,
              34.427536
            ],
            [
              -99.32867,
              34.422383
            ],
            [
              -99.32008,
              34.409258
            ],
            [
              -99.30927,
              34.409694
            ],
            [
              -99.29465,
              34.415373
            ],
            [
              -99.28793,
              34.414021
            ],
            [
              -99.28288,
              34.407469
            ],
            [
              -99.28321,
              34.402933
            ],
            [
              -99.27531,
              34.400091
            ],
            [
              -99.26732,
              34.405288
            ],
            [
              -99.26132,
              34.403499
            ],
            [
              -99.26166,
              34.394497
            ],
            [
              -99.26451,
              34.388085
            ],
            [
              -99.27316,
              34.387835
            ],
            [
              -99.27448,
              34.384331
            ],
            [
              -99.26987,
              34.380825
            ],
            [
              -99.25929,
              34.376989
            ],
            [
              -99.25472,
              34.372405
            ],
            [
              -99.24897,
              34.375984
            ],
            [
              -99.242945,
              34.372668
            ],
            [
              -99.24822,
              34.367421
            ],
            [
              -99.24456,
              34.363691
            ],
            [
              -99.23766,
              34.366695
            ],
            [
              -99.23425,
              34.353459
            ],
            [
              -99.2281,
              34.349463
            ],
            [
              -99.23327,
              34.344101
            ],
            [
              -99.229994,
              34.340538
            ],
            [
              -99.21313,
              34.340369
            ],
            [
              -99.21095,
              34.336838
            ],
            [
              -99.19828,
              34.339622
            ],
            [
              -99.19232,
              34.346718
            ],
            [
              -99.19275,
              34.354861
            ],
            [
              -99.20272,
              34.365146
            ],
            [
              -99.20267,
              34.369109
            ],
            [
              -99.20764,
              34.374238
            ],
            [
              -99.21974,
              34.374304
            ],
            [
              -99.21927,
              34.379179
            ],
            [
              -99.20916,
              34.388619
            ],
            [
              -99.20955,
              34.392811
            ],
            [
              -99.21497,
              34.394024
            ],
            [
              -99.22312,
              34.387173
            ],
            [
              -99.22886,
              34.387698
            ],
            [
              -99.22663,
              34.401281
            ],
            [
              -99.23514,
              34.401072
            ],
            [
              -99.23528,
              34.408677
            ],
            [
              -99.23806,
              34.425009
            ],
            [
              -99.23403,
              34.428514
            ],
            [
              -99.22802,
              34.419561
            ],
            [
              -99.22354,
              34.421486
            ],
            [
              -99.22164,
              34.426893
            ],
            [
              -99.22297,
              34.432847
            ],
            [
              -99.22789,
              34.4339
            ],
            [
              -99.23077,
              34.441366
            ],
            [
              -99.228038,
              34.451836
            ],
            [
              -99.21338,
              34.456169
            ],
            [
              -99.21444,
              34.460498
            ],
            [
              -99.22116,
              34.464184
            ],
            [
              -99.21726,
              34.471057
            ],
            [
              -99.21486,
              34.481022
            ],
            [
              -99.2215,
              34.478248
            ],
            [
              -99.22071,
              34.494484
            ],
            [
              -99.21011,
              34.501658
            ],
            [
              -99.20784,
              34.505347
            ],
            [
              -99.2087,
              34.513066
            ],
            [
              -99.20125,
              34.527933
            ],
            [
              -99.1984,
              34.530751
            ],
            [
              -99.1968,
              34.542386
            ],
            [
              -99.19331,
              34.54454
            ],
            [
              -99.18861,
              34.540624
            ],
            [
              -99.17798,
              34.540097
            ],
            [
              -99.17623,
              34.544791
            ],
            [
              -99.17989,
              34.554733
            ],
            [
              -99.18451,
              34.562315
            ],
            [
              -99.17775,
              34.566483
            ],
            [
              -99.1711,
              34.578233
            ],
            [
              -99.16332,
              34.588036
            ],
            [
              -99.15637,
              34.587966
            ],
            [
              -99.14099,
              34.592541
            ],
            [
              -99.13221,
              34.59208
            ],
            [
              -99.12995,
              34.584887
            ],
            [
              -99.12459,
              34.582983
            ],
            [
              -99.1218,
              34.587887
            ],
            [
              -99.11155,
              34.592221
            ],
            [
              -99.09967,
              34.594126
            ],
            [
              -99.09396,
              34.587095
            ],
            [
              -99.08288,
              34.590854
            ],
            [
              -99.08255,
              34.596054
            ],
            [
              -99.088457,
              34.615248
            ],
            [
              -99.08183,
              34.613806
            ],
            [
              -99.0792,
              34.618113
            ],
            [
              -99.08272,
              34.624319
            ],
            [
              -99.09001,
              34.625562
            ],
            [
              -99.09606,
              34.634074
            ],
            [
              -99.10315,
              34.637989
            ]
          ]
        ]
      },
      "properties": {
        "county": "40065",
        "name": "Jackson"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.78676,
              36.99931
            ],
            [
              -95.78672,
              36.985595
            ],
            [
              -95.78687,
              36.974568
            ],
            [
              -95.786819,
              36.941919
            ],
            [
              -95.79189,
              36.941874
            ],
            [
              -95.80651,
              36.941921
            ],
            [
              -95.809992,
              36.941875
            ],
            [
              -95.81002,
              36.918607
            ],
            [
              -95.80997,
              36.916746
            ],
            [
              -95.80993,
              36.910622
            ],
            [
              -95.81008,
              36.909707
            ],
            [
              -95.80983,
              36.858543
            ],
            [
              -95.80992,
              36.742783
            ],
            [
              -95.80983,
              36.742243
            ],
            [
              -95.80979,
              36.73567
            ],
            [
              -95.80975,
              36.727853
            ],
            [
              -95.80965,
              36.716293
            ],
            [
              -95.809692,
              36.713392
            ],
            [
              -95.80972,
              36.698954
            ],
            [
              -95.809705,
              36.691764
            ],
            [
              -95.80969,
              36.684448
            ],
            [
              -95.8096,
              36.669878
            ],
            [
              -95.80964,
              36.62509
            ],
            [
              -95.80959,
              36.623081
            ],
            [
              -95.80957,
              36.621811
            ],
            [
              -95.80955,
              36.611961
            ],
            [
              -95.80962,
              36.597476
            ],
            [
              -95.66444,
              36.597521
            ],
            [
              -95.66037,
              36.597526
            ],
            [
              -95.59267,
              36.597661
            ],
            [
              -95.51093,
              36.597465
            ],
            [
              -95.43151,
              36.597552
            ],
            [
              -95.43193,
              36.657237
            ],
            [
              -95.43172,
              36.674687
            ],
            [
              -95.43177,
              36.786078
            ],
            [
              -95.43237,
              36.800655
            ],
            [
              -95.43175,
              36.825962
            ],
            [
              -95.43203,
              36.856309
            ],
            [
              -95.431733,
              36.942778
            ],
            [
              -95.40784,
              36.942649
            ],
            [
              -95.40768,
              36.999241
            ],
            [
              -95.49807,
              36.999205
            ],
            [
              -95.64702,
              36.999417
            ],
            [
              -95.69666,
              36.999215
            ],
            [
              -95.78676,
              36.99931
            ]
          ]
        ]
      },
      "properties": {
        "county": "40105",
        "name": "Nowata"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -102.02821,
              36.993125
            ],
            [
              -102.07298,
              36.993109
            ],
            [
              -102.20832,
              36.99373
            ],
            [
              -102.26493,
              36.994386
            ],
            [
              -102.28501,
              36.994152
            ],
            [
              -102.37546,
              36.994581
            ],
            [
              -102.52461,
              36.994861
            ],
            [
              -102.570896,
              36.995136
            ],
            [
              -102.69814,
              36.995149
            ],
            [
              -102.74206,
              36.997689
            ],
            [
              -102.75986,
              37.000019
            ],
            [
              -102.77857,
              36.999242
            ],
            [
              -102.81462,
              37.000783
            ],
            [
              -102.84199,
              36.999598
            ],
            [
              -102.87548,
              36.999628
            ],
            [
              -102.986976,
              36.998524
            ],
            [
              -103.00223,
              36.999649
            ],
            [
              -103.00233,
              36.93367
            ],
            [
              -103.0021,
              36.823936
            ],
            [
              -103.002193,
              36.689514
            ],
            [
              -103.00223,
              36.6035
            ],
            [
              -103.00265,
              36.5681
            ],
            [
              -103.00245,
              36.500511
            ],
            [
              -102.87548,
              36.500238
            ],
            [
              -102.82122,
              36.500632
            ],
            [
              -102.75047,
              36.5004
            ],
            [
              -102.62547,
              36.500364
            ],
            [
              -102.50046,
              36.500437
            ],
            [
              -102.37546,
              36.500552
            ],
            [
              -102.366462,
              36.500395
            ],
            [
              -102.22058,
              36.500333
            ],
            [
              -102.12545,
              36.500324
            ],
            [
              -102.122066,
              36.500684
            ],
            [
              -102.03234,
              36.500575
            ],
            [
              -102.03231,
              36.581297
            ],
            [
              -102.031737,
              36.73313
            ],
            [
              -102.03174,
              36.798509
            ],
            [
              -102.03217,
              36.849184
            ],
            [
              -102.02832,
              36.849144
            ],
            [
              -102.02809,
              36.893058
            ],
            [
              -102.02821,
              36.993125
            ]
          ]
        ]
      },
      "properties": {
        "county": "40025",
        "name": "Cimarron"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.15589,
              33.936831
            ],
            [
              -95.12957,
              33.936718
            ],
            [
              -95.12118,
              33.931307
            ],
            [
              -95.12173,
              33.925762
            ],
            [
              -95.13164,
              33.916027
            ],
            [
              -95.12575,
              33.906582
            ],
            [
              -95.11759,
              33.904613
            ],
            [
              -95.10642,
              33.909632
            ],
            [
              -95.09491,
              33.918681
            ],
            [
              -95.090109,
              33.920949
            ],
            [
              -95.07962,
              33.919534
            ],
            [
              -95.076782,
              33.913584
            ],
            [
              -95.08035,
              33.907784
            ],
            [
              -95.08963,
              33.901302
            ],
            [
              -95.0985,
              33.898873
            ],
            [
              -95.10026,
              33.892668
            ],
            [
              -95.09006,
              33.881058
            ],
            [
              -95.08241,
              33.879882
            ],
            [
              -95.08009,
              33.885704
            ],
            [
              -95.0787,
              33.90504
            ],
            [
              -95.07499,
              33.908805
            ],
            [
              -95.073966,
              33.915636
            ],
            [
              -95.06948,
              33.917586
            ],
            [
              -95.06346,
              33.91404
            ],
            [
              -95.06913,
              33.903419
            ],
            [
              -95.0601,
              33.901873
            ],
            [
              -95.05845,
              33.886248
            ],
            [
              -95.05106,
              33.87881
            ],
            [
              -95.0507,
              33.868179
            ],
            [
              -95.04902,
              33.86409
            ],
            [
              -95.03721,
              33.86025
            ],
            [
              -95.02232,
              33.859813
            ],
            [
              -95.008376,
              33.866089
            ],
            [
              -95.000223,
              33.862505
            ],
            [
              -94.992163,
              33.852034
            ],
            [
              -94.98165,
              33.852284
            ],
            [
              -94.97621,
              33.859847
            ],
            [
              -94.96889,
              33.860916
            ],
            [
              -94.9658,
              33.848696
            ],
            [
              -94.9644,
              33.837021
            ],
            [
              -94.9523,
              33.834949
            ],
            [
              -94.94389,
              33.830226
            ],
            [
              -94.94484,
              33.82584
            ],
            [
              -94.95352,
              33.816475
            ],
            [
              -94.947874,
              33.808356
            ],
            [
              -94.94222,
              33.80578
            ],
            [
              -94.92329,
              33.808742
            ],
            [
              -94.9231,
              33.815456
            ],
            [
              -94.92657,
              33.826339
            ],
            [
              -94.91865,
              33.827372
            ],
            [
              -94.91216,
              33.819443
            ],
            [
              -94.91104,
              33.815023
            ],
            [
              -94.91675,
              33.808969
            ],
            [
              -94.922354,
              33.793535
            ],
            [
              -94.92153,
              33.790472
            ],
            [
              -94.91143,
              33.778383
            ],
            [
              -94.906245,
              33.778192
            ],
            [
              -94.89417,
              33.771191
            ],
            [
              -94.87939,
              33.760188
            ],
            [
              -94.87383,
              33.758059
            ],
            [
              -94.87492,
              33.76743
            ],
            [
              -94.86964,
              33.770082
            ],
            [
              -94.86618,
              33.764565
            ],
            [
              -94.86725,
              33.761335
            ],
            [
              -94.87612,
              33.755499
            ],
            [
              -94.87708,
              33.75222
            ],
            [
              -94.8698,
              33.746053
            ],
            [
              -94.8493,
              33.739585
            ],
            [
              -94.82793,
              33.741053
            ],
            [
              -94.82848,
              33.735384
            ],
            [
              -94.82293,
              33.732724
            ],
            [
              -94.82038,
              33.737582
            ],
            [
              -94.823,
              33.747274
            ],
            [
              -94.83084,
              33.758079
            ],
            [
              -94.829499,
              33.764104
            ],
            [
              -94.82338,
              33.769179
            ],
            [
              -94.81639,
              33.763963
            ],
            [
              -94.81683,
              33.754216
            ],
            [
              -94.812129,
              33.750701
            ],
            [
              -94.81342,
              33.744582
            ],
            [
              -94.81702,
              33.740007
            ],
            [
              -94.81202,
              33.735262
            ],
            [
              -94.80225,
              33.732788
            ],
            [
              -94.79726,
              33.736925
            ],
            [
              -94.78154,
              33.743322
            ],
            [
              -94.77578,
              33.757311
            ],
            [
              -94.76994,
              33.761065
            ],
            [
              -94.763276,
              33.759896
            ],
            [
              -94.75799,
              33.756504
            ],
            [
              -94.75781,
              33.750108
            ],
            [
              -94.762226,
              33.746609
            ],
            [
              -94.77584,
              33.746712
            ],
            [
              -94.788637,
              33.735669
            ],
            [
              -94.7825,
              33.730125
            ],
            [
              -94.77313,
              33.727187
            ],
            [
              -94.7606,
              33.727054
            ],
            [
              -94.75371,
              33.73411
            ],
            [
              -94.74777,
              33.72508
            ],
            [
              -94.75774,
              33.717817
            ],
            [
              -94.75137,
              33.71354
            ],
            [
              -94.74545,
              33.716804
            ],
            [
              -94.74523,
              33.722189
            ],
            [
              -94.74209,
              33.726692
            ],
            [
              -94.73674,
              33.727187
            ],
            [
              -94.73237,
              33.721939
            ],
            [
              -94.73613,
              33.71608
            ],
            [
              -94.74124,
              33.713358
            ],
            [
              -94.75307,
              33.710753
            ],
            [
              -94.75194,
              33.704862
            ],
            [
              -94.74092,
              33.700555
            ],
            [
              -94.736805,
              33.692321
            ],
            [
              -94.71953,
              33.688857
            ],
            [
              -94.71604,
              33.694587
            ],
            [
              -94.71963,
              33.703921
            ],
            [
              -94.72848,
              33.705794
            ],
            [
              -94.73252,
              33.709217
            ],
            [
              -94.73494,
              33.715226
            ],
            [
              -94.72529,
              33.714672
            ],
            [
              -94.70602,
              33.706293
            ],
            [
              -94.70112,
              33.702071
            ],
            [
              -94.7044,
              33.697141
            ],
            [
              -94.71486,
              33.696559
            ],
            [
              -94.71834,
              33.688666
            ],
            [
              -94.70258,
              33.687772
            ],
            [
              -94.68479,
              33.684353
            ],
            [
              -94.677386,
              33.688343
            ],
            [
              -94.67073,
              33.693971
            ],
            [
              -94.66491,
              33.694253
            ],
            [
              -94.658618,
              33.691759
            ],
            [
              -94.651402,
              33.685843
            ],
            [
              -94.64709,
              33.690345
            ],
            [
              -94.64862,
              33.697011
            ],
            [
              -94.64588,
              33.701778
            ],
            [
              -94.63901,
              33.6977
            ],
            [
              -94.64508,
              33.686391
            ],
            [
              -94.6504,
              33.68444
            ],
            [
              -94.64534,
              33.673644
            ],
            [
              -94.6507,
              33.67061
            ],
            [
              -94.65952,
              33.675129
            ],
            [
              -94.67018,
              33.670343
            ],
            [
              -94.66865,
              33.663846
            ],
            [
              -94.66096,
              33.660322
            ],
            [
              -94.65553,
              33.659956
            ],
            [
              -94.64894,
              33.662604
            ],
            [
              -94.6392,
              33.663737
            ],
            [
              -94.630919,
              33.673442
            ],
            [
              -94.62761,
              33.681687
            ],
            [
              -94.62145,
              33.682594
            ],
            [
              -94.61506,
              33.678777
            ],
            [
              -94.61154,
              33.670075
            ],
            [
              -94.603705,
              33.663197
            ],
            [
              -94.59329,
              33.665255
            ],
            [
              -94.59034,
              33.677688
            ],
            [
              -94.59283,
              33.682299
            ],
            [
              -94.58818,
              33.686267
            ],
            [
              -94.58034,
              33.678879
            ],
            [
              -94.57788,
              33.665682
            ],
            [
              -94.56367,
              33.669272
            ],
            [
              -94.56114,
              33.664911
            ],
            [
              -94.5648,
              33.661804
            ],
            [
              -94.57557,
              33.659409
            ],
            [
              -94.58698,
              33.65019
            ],
            [
              -94.588649,
              33.644191
            ],
            [
              -94.580069,
              33.64449
            ],
            [
              -94.57056,
              33.65223
            ],
            [
              -94.56248,
              33.656677
            ],
            [
              -94.55036,
              33.660653
            ],
            [
              -94.54461,
              33.653271
            ],
            [
              -94.55131,
              33.64457
            ],
            [
              -94.56485,
              33.639965
            ],
            [
              -94.568543,
              33.636979
            ],
            [
              -94.57038,
              33.630536
            ],
            [
              -94.56408,
              33.626264
            ],
            [
              -94.55337,
              33.627584
            ],
            [
              -94.54644,
              33.631505
            ],
            [
              -94.54186,
              33.636299
            ],
            [
              -94.52812,
              33.64125
            ],
            [
              -94.52184,
              33.640729
            ],
            [
              -94.52055,
              33.635351
            ],
            [
              -94.53505,
              33.625414
            ],
            [
              -94.53536,
              33.621333
            ],
            [
              -94.529119,
              33.61627
            ],
            [
              -94.52036,
              33.617458
            ],
            [
              -94.51844,
              33.621352
            ],
            [
              -94.52024,
              33.629805
            ],
            [
              -94.517468,
              33.633056
            ],
            [
              -94.509488,
              33.621555
            ],
            [
              -94.50292,
              33.621231
            ],
            [
              -94.48836,
              33.627406
            ],
            [
              -94.48587,
              33.637867
            ],
            [
              -94.48553,
              33.663388
            ],
            [
              -94.48452,
              33.687909
            ],
            [
              -94.48186,
              33.78845
            ],
            [
              -94.47733,
              33.939179
            ],
            [
              -94.47625,
              33.985082
            ],
            [
              -94.47406,
              34.059393
            ],
            [
              -94.47291,
              34.087971
            ],
            [
              -94.46961,
              34.217073
            ],
            [
              -94.468359,
              34.252891
            ],
            [
              -94.46788,
              34.281695
            ],
            [
              -94.46668,
              34.317883
            ],
            [
              -94.46605,
              34.350002
            ],
            [
              -94.46279,
              34.445824
            ],
            [
              -94.461965,
              34.477559
            ],
            [
              -94.46136,
              34.497056
            ],
            [
              -94.46136,
              34.500105
            ],
            [
              -94.46115,
              34.507457
            ],
            [
              -94.466283,
              34.507433
            ],
            [
              -94.533183,
              34.507289
            ],
            [
              -94.56329,
              34.507281
            ],
            [
              -94.570586,
              34.507316
            ],
            [
              -94.616794,
              34.507445
            ],
            [
              -94.62522,
              34.507486
            ],
            [
              -94.641331,
              34.50749
            ],
            [
              -94.673159,
              34.507321
            ],
            [
              -94.68165,
              34.507293
            ],
            [
              -94.697082,
              34.50724
            ],
            [
              -94.747854,
              34.50728
            ],
            [
              -94.750223,
              34.50728
            ],
            [
              -94.83681,
              34.507338
            ],
            [
              -94.89231,
              34.507036
            ],
            [
              -94.932114,
              34.506517
            ],
            [
              -94.93535,
              34.506747
            ],
            [
              -94.9376,
              34.506887
            ],
            [
              -94.93792,
              34.506907
            ],
            [
              -94.939084,
              34.506815
            ],
            [
              -94.941103,
              34.506609
            ],
            [
              -94.94403,
              34.50709
            ],
            [
              -95.046746,
              34.507229
            ],
            [
              -95.04674,
              34.401531
            ],
            [
              -95.04635,
              34.301697
            ],
            [
              -95.04658,
              34.243671
            ],
            [
              -95.151233,
              34.243906
            ],
            [
              -95.15129,
              34.157024
            ],
            [
              -95.15644,
              34.157027
            ],
            [
              -95.156352,
              34.069925
            ],
            [
              -95.15659,
              33.997268
            ],
            [
              -95.15589,
              33.936831
            ]
          ]
        ]
      },
      "properties": {
        "county": "40089",
        "name": "McCurtain"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.40768,
              36.999241
            ],
            [
              -95.40784,
              36.942649
            ],
            [
              -95.431733,
              36.942778
            ],
            [
              -95.43203,
              36.856309
            ],
            [
              -95.43175,
              36.825962
            ],
            [
              -95.43237,
              36.800655
            ],
            [
              -95.43177,
              36.786078
            ],
            [
              -95.43172,
              36.674687
            ],
            [
              -95.43193,
              36.657237
            ],
            [
              -95.43151,
              36.597552
            ],
            [
              -95.36892,
              36.597743
            ],
            [
              -95.32842,
              36.597573
            ],
            [
              -95.32832,
              36.553655
            ],
            [
              -95.32829,
              36.541233
            ],
            [
              -95.32812,
              36.524727
            ],
            [
              -95.32803,
              36.510263
            ],
            [
              -95.25025,
              36.510153
            ],
            [
              -95.22041,
              36.510368
            ],
            [
              -95.11968,
              36.510296
            ],
            [
              -95.00572,
              36.509779
            ],
            [
              -95.00569,
              36.597445
            ],
            [
              -94.9996,
              36.597966
            ],
            [
              -94.99957,
              36.670684
            ],
            [
              -94.99939,
              36.772174
            ],
            [
              -94.99943,
              36.852352
            ],
            [
              -94.9993,
              36.943268
            ],
            [
              -94.99341,
              36.948043
            ],
            [
              -94.9954,
              36.951711
            ],
            [
              -95.00465,
              36.952629
            ],
            [
              -95.022231,
              36.9608
            ],
            [
              -95.028062,
              36.966503
            ],
            [
              -95.030707,
              36.972433
            ],
            [
              -95.028065,
              36.97675
            ],
            [
              -95.03228,
              36.981178
            ],
            [
              -95.03472,
              36.989351
            ],
            [
              -95.03386,
              36.994278
            ],
            [
              -95.016971,
              36.994707
            ],
            [
              -95.00762,
              36.999514
            ],
            [
              -95.15907,
              36.999563
            ],
            [
              -95.30433,
              36.999519
            ],
            [
              -95.39975,
              36.999423
            ],
            [
              -95.40768,
              36.999241
            ]
          ]
        ]
      },
      "properties": {
        "county": "40035",
        "name": "Craig"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -94.99957,
              36.670684
            ],
            [
              -94.91392,
              36.670491
            ],
            [
              -94.78223,
              36.670622
            ],
            [
              -94.77924,
              36.667763
            ],
            [
              -94.68593,
              36.667718
            ],
            [
              -94.61808,
              36.667863
            ],
            [
              -94.618193,
              36.780908
            ],
            [
              -94.61853,
              36.861787
            ],
            [
              -94.6181,
              36.941413
            ],
            [
              -94.61808,
              36.998135
            ],
            [
              -94.62522,
              36.998672
            ],
            [
              -94.691309,
              36.998841
            ],
            [
              -94.76741,
              36.998624
            ],
            [
              -94.88637,
              36.99894
            ],
            [
              -94.95728,
              36.999474
            ],
            [
              -95.00762,
              36.999514
            ],
            [
              -95.016971,
              36.994707
            ],
            [
              -95.03386,
              36.994278
            ],
            [
              -95.03472,
              36.989351
            ],
            [
              -95.03228,
              36.981178
            ],
            [
              -95.028065,
              36.97675
            ],
            [
              -95.030707,
              36.972433
            ],
            [
              -95.028062,
              36.966503
            ],
            [
              -95.022231,
              36.9608
            ],
            [
              -95.00465,
              36.952629
            ],
            [
              -94.9954,
              36.951711
            ],
            [
              -94.99341,
              36.948043
            ],
            [
              -94.9993,
              36.943268
            ],
            [
              -94.99943,
              36.852352
            ],
            [
              -94.99939,
              36.772174
            ],
            [
              -94.99957,
              36.670684
            ]
          ]
        ]
      },
      "properties": {
        "county": "40115",
        "name": "Ottawa"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.11198,
              36.998133
            ],
            [
              -98.11148,
              36.942089
            ],
            [
              -98.10948,
              36.94209
            ],
            [
              -98.10971,
              36.862112
            ],
            [
              -98.11034,
              36.767683
            ],
            [
              -98.10989,
              36.737955
            ],
            [
              -98.10951,
              36.675746
            ],
            [
              -98.109294,
              36.593679
            ],
            [
              -98.10407,
              36.593681
            ],
            [
              -98.05083,
              36.593503
            ],
            [
              -98.00034,
              36.59367
            ],
            [
              -97.94386,
              36.59348
            ],
            [
              -97.89368,
              36.593563
            ],
            [
              -97.76505,
              36.593171
            ],
            [
              -97.67812,
              36.593432
            ],
            [
              -97.63357,
              36.593351
            ],
            [
              -97.46246,
              36.593453
            ],
            [
              -97.46238,
              36.68045
            ],
            [
              -97.46221,
              36.781731
            ],
            [
              -97.46245,
              36.825363
            ],
            [
              -97.4624,
              36.926965
            ],
            [
              -97.46228,
              36.998685
            ],
            [
              -97.51031,
              36.998812
            ],
            [
              -97.58426,
              36.998618
            ],
            [
              -97.64253,
              36.998932
            ],
            [
              -97.732638,
              36.998682
            ],
            [
              -97.78343,
              36.998961
            ],
            [
              -97.87644,
              36.998629
            ],
            [
              -97.9472,
              36.998739
            ],
            [
              -97.96649,
              36.998508
            ],
            [
              -98.11198,
              36.998133
            ]
          ]
        ]
      },
      "properties": {
        "county": "40053",
        "name": "Grant"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.54487,
              36.998997
            ],
            [
              -98.54503,
              36.942329
            ],
            [
              -98.54035,
              36.942213
            ],
            [
              -98.5406,
              36.884491
            ],
            [
              -98.54024,
              36.818887
            ],
            [
              -98.54054,
              36.688232
            ],
            [
              -98.54031,
              36.608709
            ],
            [
              -98.54048,
              36.594284
            ],
            [
              -98.53341,
              36.594259
            ],
            [
              -98.53324,
              36.521054
            ],
            [
              -98.53357,
              36.46333
            ],
            [
              -98.42634,
              36.462921
            ],
            [
              -98.34695,
              36.463329
            ],
            [
              -98.2118,
              36.463375
            ],
            [
              -98.17608,
              36.463125
            ],
            [
              -98.10462,
              36.463164
            ],
            [
              -98.10419,
              36.506581
            ],
            [
              -98.10407,
              36.593681
            ],
            [
              -98.109294,
              36.593679
            ],
            [
              -98.10951,
              36.675746
            ],
            [
              -98.10989,
              36.737955
            ],
            [
              -98.11034,
              36.767683
            ],
            [
              -98.10971,
              36.862112
            ],
            [
              -98.10948,
              36.94209
            ],
            [
              -98.11148,
              36.942089
            ],
            [
              -98.11198,
              36.998133
            ],
            [
              -98.16421,
              36.997939
            ],
            [
              -98.23771,
              36.997972
            ],
            [
              -98.30046,
              36.997684
            ],
            [
              -98.41827,
              36.998538
            ],
            [
              -98.490432,
              36.998506
            ],
            [
              -98.54487,
              36.998997
            ]
          ]
        ]
      },
      "properties": {
        "county": "40003",
        "name": "Alfalfa"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.46164,
              36.593454
            ],
            [
              -97.46246,
              36.593453
            ],
            [
              -97.63357,
              36.593351
            ],
            [
              -97.67812,
              36.593432
            ],
            [
              -97.76505,
              36.593171
            ],
            [
              -97.89368,
              36.593563
            ],
            [
              -97.94386,
              36.59348
            ],
            [
              -98.00034,
              36.59367
            ],
            [
              -98.05083,
              36.593503
            ],
            [
              -98.10407,
              36.593681
            ],
            [
              -98.10419,
              36.506581
            ],
            [
              -98.10462,
              36.463164
            ],
            [
              -98.10443,
              36.375033
            ],
            [
              -98.10466,
              36.322207
            ],
            [
              -98.10447,
              36.271396
            ],
            [
              -98.10374,
              36.245844
            ],
            [
              -98.10384,
              36.164876
            ],
            [
              -98.09735,
              36.165039
            ],
            [
              -97.99721,
              36.164802
            ],
            [
              -97.95729,
              36.164516
            ],
            [
              -97.92072,
              36.164676
            ],
            [
              -97.76703,
              36.164619
            ],
            [
              -97.675712,
              36.164663
            ],
            [
              -97.586,
              36.164749
            ],
            [
              -97.46074,
              36.164463
            ],
            [
              -97.46049,
              36.244882
            ],
            [
              -97.46131,
              36.246849
            ],
            [
              -97.46114,
              36.360972
            ],
            [
              -97.46141,
              36.376126
            ],
            [
              -97.4617,
              36.492941
            ],
            [
              -97.46148,
              36.534962
            ],
            [
              -97.46164,
              36.593454
            ]
          ]
        ]
      },
      "properties": {
        "county": "40047",
        "name": "Garfield"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.00572,
              36.509779
            ],
            [
              -95.11968,
              36.510296
            ],
            [
              -95.22041,
              36.510368
            ],
            [
              -95.25025,
              36.510153
            ],
            [
              -95.32803,
              36.510263
            ],
            [
              -95.43551,
              36.510154
            ],
            [
              -95.43554,
              36.495418
            ],
            [
              -95.43566,
              36.481275
            ],
            [
              -95.43569,
              36.464439
            ],
            [
              -95.43571,
              36.452211
            ],
            [
              -95.43563,
              36.43761
            ],
            [
              -95.43563,
              36.43365
            ],
            [
              -95.43563,
              36.408721
            ],
            [
              -95.435739,
              36.39074
            ],
            [
              -95.43541,
              36.327651
            ],
            [
              -95.43546,
              36.322047
            ],
            [
              -95.43549,
              36.318437
            ],
            [
              -95.43557,
              36.307439
            ],
            [
              -95.43561,
              36.249315
            ],
            [
              -95.43997,
              36.249336
            ],
            [
              -95.43997,
              36.235792
            ],
            [
              -95.43997,
              36.234593
            ],
            [
              -95.43998,
              36.220576
            ],
            [
              -95.43998,
              36.205969
            ],
            [
              -95.43998,
              36.176902
            ],
            [
              -95.43999,
              36.169266
            ],
            [
              -95.44012,
              36.075226
            ],
            [
              -95.41494,
              36.075316
            ],
            [
              -95.39877,
              36.075271
            ],
            [
              -95.38187,
              36.07526
            ],
            [
              -95.37688,
              36.075235
            ],
            [
              -95.37043,
              36.075152
            ],
            [
              -95.32934,
              36.075048
            ],
            [
              -95.32458,
              36.075037
            ],
            [
              -95.32323,
              36.075035
            ],
            [
              -95.3146,
              36.07502
            ],
            [
              -95.29027,
              36.074996
            ],
            [
              -95.28638,
              36.075014
            ],
            [
              -95.27529,
              36.07499
            ],
            [
              -95.25908,
              36.074846
            ],
            [
              -95.217259,
              36.074763
            ],
            [
              -95.207946,
              36.074708
            ],
            [
              -95.118198,
              36.074431
            ],
            [
              -95.11837,
              36.118059
            ],
            [
              -95.117841,
              36.12859
            ],
            [
              -95.11846,
              36.161638
            ],
            [
              -95.0113,
              36.161798
            ],
            [
              -95.01107,
              36.166926
            ],
            [
              -95.01138,
              36.249468
            ],
            [
              -95.00594,
              36.249547
            ],
            [
              -95.00561,
              36.353954
            ],
            [
              -95.00592,
              36.463133
            ],
            [
              -95.00572,
              36.509779
            ]
          ]
        ]
      },
      "properties": {
        "county": "40097",
        "name": "Mayes"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.10462,
              36.463164
            ],
            [
              -98.17608,
              36.463125
            ],
            [
              -98.2118,
              36.463375
            ],
            [
              -98.34695,
              36.463329
            ],
            [
              -98.42634,
              36.462921
            ],
            [
              -98.53357,
              36.46333
            ],
            [
              -98.53355,
              36.397592
            ],
            [
              -98.55254,
              36.402318
            ],
            [
              -98.56403,
              36.400182
            ],
            [
              -98.59345,
              36.392031
            ],
            [
              -98.60281,
              36.390848
            ],
            [
              -98.625361,
              36.392595
            ],
            [
              -98.64427,
              36.397167
            ],
            [
              -98.66278,
              36.404571
            ],
            [
              -98.699493,
              36.416013
            ],
            [
              -98.70922,
              36.421958
            ],
            [
              -98.71854,
              36.437497
            ],
            [
              -98.72681,
              36.445332
            ],
            [
              -98.74334,
              36.448617
            ],
            [
              -98.76446,
              36.446666
            ],
            [
              -98.7777,
              36.448442
            ],
            [
              -98.792471,
              36.453263
            ],
            [
              -98.80782,
              36.460744
            ],
            [
              -98.81946,
              36.470995
            ],
            [
              -98.82913,
              36.484163
            ],
            [
              -98.83847,
              36.500034
            ],
            [
              -98.843646,
              36.506248
            ],
            [
              -98.87537,
              36.506664
            ],
            [
              -98.96033,
              36.506914
            ],
            [
              -98.96057,
              36.496474
            ],
            [
              -98.96047,
              36.391248
            ],
            [
              -98.96093,
              36.319147
            ],
            [
              -98.96088,
              36.246772
            ],
            [
              -98.95594,
              36.24668
            ],
            [
              -98.95619,
              36.240433
            ],
            [
              -98.95586,
              36.161569
            ],
            [
              -98.92084,
              36.161253
            ],
            [
              -98.86017,
              36.161257
            ],
            [
              -98.75037,
              36.163096
            ],
            [
              -98.72582,
              36.163275
            ],
            [
              -98.67232,
              36.164438
            ],
            [
              -98.63686,
              36.164895
            ],
            [
              -98.601245,
              36.165772
            ],
            [
              -98.48541,
              36.164942
            ],
            [
              -98.264081,
              36.164815
            ],
            [
              -98.210544,
              36.16489
            ],
            [
              -98.15173,
              36.164694
            ],
            [
              -98.10384,
              36.164876
            ],
            [
              -98.10374,
              36.245844
            ],
            [
              -98.10447,
              36.271396
            ],
            [
              -98.10466,
              36.322207
            ],
            [
              -98.10443,
              36.375033
            ],
            [
              -98.10462,
              36.463164
            ]
          ]
        ]
      },
      "properties": {
        "county": "40093",
        "name": "Major"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.210544,
              36.16489
            ],
            [
              -98.264081,
              36.164815
            ],
            [
              -98.48541,
              36.164942
            ],
            [
              -98.601245,
              36.165772
            ],
            [
              -98.63686,
              36.164895
            ],
            [
              -98.63636,
              36.070508
            ],
            [
              -98.636462,
              36.039049
            ],
            [
              -98.636106,
              35.934983
            ],
            [
              -98.63627,
              35.898846
            ],
            [
              -98.632498,
              35.898775
            ],
            [
              -98.63208,
              35.856061
            ],
            [
              -98.63211,
              35.812366
            ],
            [
              -98.63219,
              35.768923
            ],
            [
              -98.63169,
              35.740385
            ],
            [
              -98.6322,
              35.717805
            ],
            [
              -98.63186,
              35.694636
            ],
            [
              -98.632259,
              35.66749
            ],
            [
              -98.63236,
              35.590701
            ],
            [
              -98.63207,
              35.551617
            ],
            [
              -98.623149,
              35.551597
            ],
            [
              -98.50078,
              35.551397
            ],
            [
              -98.40705,
              35.551483
            ],
            [
              -98.35955,
              35.551336
            ],
            [
              -98.31325,
              35.551523
            ],
            [
              -98.31337,
              35.638281
            ],
            [
              -98.31337,
              35.725204
            ],
            [
              -98.207293,
              35.725141
            ],
            [
              -98.20692,
              35.7505
            ],
            [
              -98.207063,
              35.783108
            ],
            [
              -98.20681,
              35.898625
            ],
            [
              -98.20999,
              35.89867
            ],
            [
              -98.20986,
              35.942088
            ],
            [
              -98.21018,
              35.971055
            ],
            [
              -98.21013,
              36.086916
            ],
            [
              -98.210544,
              36.16489
            ]
          ]
        ]
      },
      "properties": {
        "county": "40011",
        "name": "Blaine"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.207293,
              35.725141
            ],
            [
              -97.99478,
              35.725541
            ],
            [
              -97.95897,
              35.726078
            ],
            [
              -97.88773,
              35.726091
            ],
            [
              -97.81721,
              35.725695
            ],
            [
              -97.69927,
              35.725712
            ],
            [
              -97.67392,
              35.725985
            ],
            [
              -97.67433,
              35.82772
            ],
            [
              -97.67454,
              35.898428
            ],
            [
              -97.67564,
              35.927484
            ],
            [
              -97.67585,
              36.043712
            ],
            [
              -97.67564,
              36.072767
            ],
            [
              -97.675712,
              36.164663
            ],
            [
              -97.76703,
              36.164619
            ],
            [
              -97.92072,
              36.164676
            ],
            [
              -97.95729,
              36.164516
            ],
            [
              -97.99721,
              36.164802
            ],
            [
              -98.09735,
              36.165039
            ],
            [
              -98.10384,
              36.164876
            ],
            [
              -98.15173,
              36.164694
            ],
            [
              -98.210544,
              36.16489
            ],
            [
              -98.21013,
              36.086916
            ],
            [
              -98.21018,
              35.971055
            ],
            [
              -98.20986,
              35.942088
            ],
            [
              -98.20999,
              35.89867
            ],
            [
              -98.20681,
              35.898625
            ],
            [
              -98.207063,
              35.783108
            ],
            [
              -98.20692,
              35.7505
            ],
            [
              -98.207293,
              35.725141
            ]
          ]
        ]
      },
      "properties": {
        "county": "40073",
        "name": "Kingfisher"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.95586,
              36.161569
            ],
            [
              -99.07502,
              36.162376
            ],
            [
              -99.11726,
              36.162812
            ],
            [
              -99.12538,
              36.162257
            ],
            [
              -99.17194,
              36.162587
            ],
            [
              -99.245689,
              36.163407
            ],
            [
              -99.271381,
              36.164173
            ],
            [
              -99.38216,
              36.1643
            ],
            [
              -99.382177,
              36.087462
            ],
            [
              -99.38102,
              36.012925
            ],
            [
              -99.380798,
              35.910555
            ],
            [
              -99.38108,
              35.898831
            ],
            [
              -99.37583,
              35.898754
            ],
            [
              -99.37603,
              35.81218
            ],
            [
              -99.28942,
              35.812114
            ],
            [
              -99.20483,
              35.812369
            ],
            [
              -99.11067,
              35.812416
            ],
            [
              -99.000372,
              35.812271
            ],
            [
              -98.83141,
              35.812857
            ],
            [
              -98.81237,
              35.812576
            ],
            [
              -98.70908,
              35.811923
            ],
            [
              -98.7091,
              35.81244
            ],
            [
              -98.63211,
              35.812366
            ],
            [
              -98.63208,
              35.856061
            ],
            [
              -98.632498,
              35.898775
            ],
            [
              -98.63627,
              35.898846
            ],
            [
              -98.636106,
              35.934983
            ],
            [
              -98.636462,
              36.039049
            ],
            [
              -98.63636,
              36.070508
            ],
            [
              -98.63686,
              36.164895
            ],
            [
              -98.67232,
              36.164438
            ],
            [
              -98.72582,
              36.163275
            ],
            [
              -98.75037,
              36.163096
            ],
            [
              -98.86017,
              36.161257
            ],
            [
              -98.92084,
              36.161253
            ],
            [
              -98.95586,
              36.161569
            ]
          ]
        ]
      },
      "properties": {
        "county": "40043",
        "name": "Dewey"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -94.5628,
              36.161749
            ],
            [
              -94.66347,
              36.161636
            ],
            [
              -94.74621,
              36.16162
            ],
            [
              -94.7559,
              36.161192
            ],
            [
              -94.79728,
              36.16139
            ],
            [
              -94.79687,
              36.125156
            ],
            [
              -94.79727,
              36.113105
            ],
            [
              -94.79732,
              36.007973
            ],
            [
              -94.79721,
              35.90088
            ],
            [
              -94.80733,
              35.900926
            ],
            [
              -94.807218,
              35.871053
            ],
            [
              -94.80755,
              35.797825
            ],
            [
              -94.80736,
              35.762925
            ],
            [
              -94.80779,
              35.750089
            ],
            [
              -94.80775,
              35.682198
            ],
            [
              -94.80753,
              35.660896
            ],
            [
              -94.8073,
              35.638604
            ],
            [
              -94.78953,
              35.638602
            ],
            [
              -94.786922,
              35.638586
            ],
            [
              -94.778704,
              35.638515
            ],
            [
              -94.750223,
              35.638599
            ],
            [
              -94.70407,
              35.638413
            ],
            [
              -94.684951,
              35.638228
            ],
            [
              -94.676927,
              35.63833
            ],
            [
              -94.665894,
              35.638519
            ],
            [
              -94.64326,
              35.638476
            ],
            [
              -94.62979,
              35.638293
            ],
            [
              -94.58636,
              35.638277
            ],
            [
              -94.583537,
              35.63828
            ],
            [
              -94.572337,
              35.638329
            ],
            [
              -94.533761,
              35.6383
            ],
            [
              -94.515161,
              35.63838
            ],
            [
              -94.500216,
              35.63836
            ],
            [
              -94.49202,
              35.638451
            ],
            [
              -94.48046,
              35.638512
            ],
            [
              -94.47265,
              35.638556
            ],
            [
              -94.484488,
              35.706667
            ],
            [
              -94.50763,
              35.845901
            ],
            [
              -94.51757,
              35.901866
            ],
            [
              -94.52434,
              35.94405
            ],
            [
              -94.53485,
              36.002678
            ],
            [
              -94.54787,
              36.078281
            ],
            [
              -94.5628,
              36.161749
            ]
          ]
        ]
      },
      "properties": {
        "county": "40001",
        "name": "Adair"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.6211,
              35.941519
            ],
            [
              -96.642286,
              35.941922
            ],
            [
              -96.76723,
              35.942103
            ],
            [
              -96.87397,
              35.942119
            ],
            [
              -96.891591,
              35.941357
            ],
            [
              -96.94504,
              35.942062
            ],
            [
              -97.02965,
              35.941894
            ],
            [
              -97.087244,
              35.942171
            ],
            [
              -97.14052,
              35.941817
            ],
            [
              -97.14065,
              35.898366
            ],
            [
              -97.14178,
              35.875055
            ],
            [
              -97.14123,
              35.821926
            ],
            [
              -97.14137,
              35.778108
            ],
            [
              -97.140997,
              35.724442
            ],
            [
              -97.14109,
              35.709915
            ],
            [
              -97.14109,
              35.70621
            ],
            [
              -97.140997,
              35.703243
            ],
            [
              -97.14104,
              35.698146
            ],
            [
              -97.14116,
              35.68471
            ],
            [
              -97.14119,
              35.681003
            ],
            [
              -97.14138,
              35.666556
            ],
            [
              -97.14135,
              35.6571
            ],
            [
              -97.14136,
              35.65246
            ],
            [
              -97.14142,
              35.647687
            ],
            [
              -97.14141,
              35.644663
            ],
            [
              -97.1414,
              35.637532
            ],
            [
              -97.14124,
              35.623021
            ],
            [
              -97.1409,
              35.574222
            ],
            [
              -97.140755,
              35.56971
            ],
            [
              -97.14079,
              35.563486
            ],
            [
              -97.14087,
              35.550542
            ],
            [
              -97.14144,
              35.550574
            ],
            [
              -97.1413,
              35.538879
            ],
            [
              -97.14123,
              35.532431
            ],
            [
              -97.14123,
              35.527039
            ],
            [
              -97.14128,
              35.520223
            ],
            [
              -97.14125,
              35.516319
            ],
            [
              -97.14128,
              35.50641
            ],
            [
              -97.14142,
              35.500242
            ],
            [
              -97.14149,
              35.479472
            ],
            [
              -97.14135,
              35.471131
            ],
            [
              -97.14123,
              35.464064
            ],
            [
              -97.12061,
              35.463591
            ],
            [
              -97.001017,
              35.463527
            ],
            [
              -96.84162,
              35.463565
            ],
            [
              -96.7008,
              35.462766
            ],
            [
              -96.62487,
              35.462726
            ],
            [
              -96.62399,
              35.491726
            ],
            [
              -96.62389,
              35.513696
            ],
            [
              -96.62169,
              35.551793
            ],
            [
              -96.62186,
              35.56398
            ],
            [
              -96.62065,
              35.639005
            ],
            [
              -96.62064,
              35.639126
            ],
            [
              -96.62063,
              35.662444
            ],
            [
              -96.62067,
              35.670107
            ],
            [
              -96.62,
              35.694944
            ],
            [
              -96.62026,
              35.709776
            ],
            [
              -96.62019,
              35.724425
            ],
            [
              -96.61991,
              35.745452
            ],
            [
              -96.61993,
              35.748629
            ],
            [
              -96.61996,
              35.750069
            ],
            [
              -96.61987,
              35.752158
            ],
            [
              -96.61974,
              35.754802
            ],
            [
              -96.619659,
              35.768571
            ],
            [
              -96.61959,
              35.819719
            ],
            [
              -96.61959,
              35.822293
            ],
            [
              -96.61923,
              35.876587
            ],
            [
              -96.61954,
              35.88675
            ],
            [
              -96.61946,
              35.915531
            ],
            [
              -96.6211,
              35.941519
            ]
          ]
        ]
      },
      "properties": {
        "county": "40081",
        "name": "Lincoln"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.63211,
              35.812366
            ],
            [
              -98.7091,
              35.81244
            ],
            [
              -98.70908,
              35.811923
            ],
            [
              -98.81237,
              35.812576
            ],
            [
              -98.83141,
              35.812857
            ],
            [
              -99.000372,
              35.812271
            ],
            [
              -99.11067,
              35.812416
            ],
            [
              -99.20483,
              35.812369
            ],
            [
              -99.28942,
              35.812114
            ],
            [
              -99.37603,
              35.81218
            ],
            [
              -99.37662,
              35.740085
            ],
            [
              -99.37691,
              35.678572
            ],
            [
              -99.37695,
              35.551739
            ],
            [
              -99.36399,
              35.551675
            ],
            [
              -99.3641,
              35.508825
            ],
            [
              -99.36432,
              35.465381
            ],
            [
              -99.1989,
              35.465619
            ],
            [
              -99.103567,
              35.465111
            ],
            [
              -99.0639,
              35.465279
            ],
            [
              -98.95847,
              35.465209
            ],
            [
              -98.81803,
              35.464869
            ],
            [
              -98.72914,
              35.464359
            ],
            [
              -98.62323,
              35.464419
            ],
            [
              -98.6234,
              35.53555
            ],
            [
              -98.623149,
              35.551597
            ],
            [
              -98.63207,
              35.551617
            ],
            [
              -98.63236,
              35.590701
            ],
            [
              -98.632259,
              35.66749
            ],
            [
              -98.63186,
              35.694636
            ],
            [
              -98.6322,
              35.717805
            ],
            [
              -98.63169,
              35.740385
            ],
            [
              -98.63219,
              35.768923
            ],
            [
              -98.63211,
              35.812366
            ]
          ]
        ]
      },
      "properties": {
        "county": "40039",
        "name": "Custer"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.67392,
              35.725985
            ],
            [
              -97.69927,
              35.725712
            ],
            [
              -97.81721,
              35.725695
            ],
            [
              -97.88773,
              35.726091
            ],
            [
              -97.95897,
              35.726078
            ],
            [
              -97.99478,
              35.725541
            ],
            [
              -98.207293,
              35.725141
            ],
            [
              -98.31337,
              35.725204
            ],
            [
              -98.31337,
              35.638281
            ],
            [
              -98.31325,
              35.551523
            ],
            [
              -98.3083,
              35.551505
            ],
            [
              -98.30671,
              35.541043
            ],
            [
              -98.30617,
              35.507328
            ],
            [
              -98.30637,
              35.377177
            ],
            [
              -98.26563,
              35.3771
            ],
            [
              -98.23654,
              35.376643
            ],
            [
              -98.20131,
              35.376812
            ],
            [
              -98.09596,
              35.377726
            ],
            [
              -98.03414,
              35.377911
            ],
            [
              -98.02075,
              35.377526
            ],
            [
              -98.01324,
              35.372825
            ],
            [
              -98.01006,
              35.364554
            ],
            [
              -97.99905,
              35.361155
            ],
            [
              -97.98406,
              35.360177
            ],
            [
              -97.975981,
              35.357386
            ],
            [
              -97.96413,
              35.348869
            ],
            [
              -97.95848,
              35.347748
            ],
            [
              -97.9499,
              35.352009
            ],
            [
              -97.94677,
              35.359543
            ],
            [
              -97.94582,
              35.375477
            ],
            [
              -97.94277,
              35.37723
            ],
            [
              -97.93259,
              35.373398
            ],
            [
              -97.930806,
              35.36378
            ],
            [
              -97.92785,
              35.35986
            ],
            [
              -97.91942,
              35.354333
            ],
            [
              -97.90929,
              35.355297
            ],
            [
              -97.90695,
              35.351081
            ],
            [
              -97.89747,
              35.345664
            ],
            [
              -97.891546,
              35.347062
            ],
            [
              -97.890346,
              35.35079
            ],
            [
              -97.88269,
              35.349792
            ],
            [
              -97.870017,
              35.362354
            ],
            [
              -97.86378,
              35.361394
            ],
            [
              -97.85597,
              35.342139
            ],
            [
              -97.84338,
              35.334059
            ],
            [
              -97.83311,
              35.335051
            ],
            [
              -97.81434,
              35.333947
            ],
            [
              -97.80707,
              35.340539
            ],
            [
              -97.79648,
              35.339083
            ],
            [
              -97.77998,
              35.342012
            ],
            [
              -97.76498,
              35.342476
            ],
            [
              -97.75464,
              35.337196
            ],
            [
              -97.75109,
              35.331308
            ],
            [
              -97.73891,
              35.324525
            ],
            [
              -97.72808,
              35.325288
            ],
            [
              -97.71771,
              35.329466
            ],
            [
              -97.71137,
              35.324861
            ],
            [
              -97.69587,
              35.327709
            ],
            [
              -97.68672,
              35.333837
            ],
            [
              -97.680243,
              35.335785
            ],
            [
              -97.67159,
              35.335934
            ],
            [
              -97.67152,
              35.350589
            ],
            [
              -97.67137,
              35.362684
            ],
            [
              -97.67122,
              35.37726
            ],
            [
              -97.67122,
              35.37946
            ],
            [
              -97.67139,
              35.381724
            ],
            [
              -97.67141,
              35.385611
            ],
            [
              -97.67132,
              35.391559
            ],
            [
              -97.67142,
              35.435258
            ],
            [
              -97.67152,
              35.448458
            ],
            [
              -97.67142,
              35.472757
            ],
            [
              -97.67142,
              35.478757
            ],
            [
              -97.67132,
              35.479957
            ],
            [
              -97.67142,
              35.481757
            ],
            [
              -97.67132,
              35.551054
            ],
            [
              -97.67422,
              35.554954
            ],
            [
              -97.67412,
              35.560754
            ],
            [
              -97.674,
              35.575134
            ],
            [
              -97.67408,
              35.590485
            ],
            [
              -97.67397,
              35.653027
            ],
            [
              -97.67397,
              35.659379
            ],
            [
              -97.67405,
              35.661571
            ],
            [
              -97.67405,
              35.667491
            ],
            [
              -97.67402,
              35.682066
            ],
            [
              -97.67392,
              35.725985
            ]
          ]
        ]
      },
      "properties": {
        "county": "40017",
        "name": "Canadian"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.3641,
              35.508825
            ],
            [
              -99.49082,
              35.50912
            ],
            [
              -99.5188,
              35.508644
            ],
            [
              -99.5756,
              35.50895
            ],
            [
              -99.57596,
              35.500049
            ],
            [
              -99.57572,
              35.421693
            ],
            [
              -99.61125,
              35.421547
            ],
            [
              -99.6996,
              35.421694
            ],
            [
              -99.75038,
              35.422297
            ],
            [
              -99.80597,
              35.422198
            ],
            [
              -99.929381,
              35.422428
            ],
            [
              -100.000389,
              35.42234
            ],
            [
              -100.000386,
              35.262993
            ],
            [
              -100.00038,
              35.164834
            ],
            [
              -100.00038,
              35.030385
            ],
            [
              -99.95161,
              35.029932
            ],
            [
              -99.88857,
              35.030262
            ],
            [
              -99.866944,
              35.029872
            ],
            [
              -99.78295,
              35.030111
            ],
            [
              -99.78283,
              35.116777
            ],
            [
              -99.676893,
              35.116598
            ],
            [
              -99.636435,
              35.116956
            ],
            [
              -99.54626,
              35.116713
            ],
            [
              -99.49414,
              35.116839
            ],
            [
              -99.44066,
              35.116538
            ],
            [
              -99.443827,
              35.112848
            ],
            [
              -99.44,
              35.109104
            ],
            [
              -99.42817,
              35.109294
            ],
            [
              -99.42394,
              35.114057
            ],
            [
              -99.41587,
              35.111766
            ],
            [
              -99.40929,
              35.114509
            ],
            [
              -99.40927,
              35.116493
            ],
            [
              -99.36008,
              35.116684
            ],
            [
              -99.36008,
              35.204393
            ],
            [
              -99.36429,
              35.204437
            ],
            [
              -99.36481,
              35.276872
            ],
            [
              -99.36455,
              35.305867
            ],
            [
              -99.36459,
              35.363882
            ],
            [
              -99.36432,
              35.465381
            ],
            [
              -99.3641,
              35.508825
            ]
          ]
        ]
      },
      "properties": {
        "county": "40009",
        "name": "Beckham"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -94.92786,
              35.058279
            ],
            [
              -94.940126,
              35.058204
            ],
            [
              -94.95439,
              35.058117
            ],
            [
              -94.98258,
              35.057946
            ],
            [
              -95.00023,
              35.057847
            ],
            [
              -95.09914,
              35.057497
            ],
            [
              -95.15844,
              35.057897
            ],
            [
              -95.254847,
              35.057898
            ],
            [
              -95.34941,
              35.05828
            ],
            [
              -95.34944,
              35.029299
            ],
            [
              -95.40545,
              35.029497
            ],
            [
              -95.50766,
              35.029197
            ],
            [
              -95.50746,
              35.000097
            ],
            [
              -95.50779,
              34.945843
            ],
            [
              -95.50751,
              34.910704
            ],
            [
              -95.50753,
              34.854811
            ],
            [
              -95.513963,
              34.854795
            ],
            [
              -95.51438,
              34.841706
            ],
            [
              -95.51411,
              34.784695
            ],
            [
              -95.514514,
              34.681142
            ],
            [
              -95.484407,
              34.680759
            ],
            [
              -95.40768,
              34.680792
            ],
            [
              -95.35695,
              34.681082
            ],
            [
              -95.30499,
              34.680977
            ],
            [
              -95.25024,
              34.680492
            ],
            [
              -95.15674,
              34.680875
            ],
            [
              -95.059616,
              34.680736
            ],
            [
              -95.05963,
              34.692684
            ],
            [
              -95.0598,
              34.717129
            ],
            [
              -95.059931,
              34.725059
            ],
            [
              -95.05993,
              34.726577
            ],
            [
              -95.059754,
              34.761313
            ],
            [
              -95.0598,
              34.76374
            ],
            [
              -95.059934,
              34.788072
            ],
            [
              -95.059976,
              34.79646
            ],
            [
              -95.06005,
              34.803962
            ],
            [
              -95.059446,
              34.820333
            ],
            [
              -95.05945,
              34.820455
            ],
            [
              -95.059712,
              34.822735
            ],
            [
              -95.05972,
              34.824044
            ],
            [
              -95.05958,
              34.82743
            ],
            [
              -95.05944,
              34.834679
            ],
            [
              -95.059446,
              34.837656
            ],
            [
              -95.059475,
              34.850576
            ],
            [
              -95.059512,
              34.855019
            ],
            [
              -95.015606,
              34.855127
            ],
            [
              -95.0056,
              34.855168
            ],
            [
              -95.00508,
              34.855131
            ],
            [
              -95.00024,
              34.855056
            ],
            [
              -95.00004,
              34.855056
            ],
            [
              -94.99765,
              34.855055
            ],
            [
              -94.99762,
              34.856262
            ],
            [
              -94.9976,
              34.866268
            ],
            [
              -94.997852,
              34.877635
            ],
            [
              -94.997836,
              34.889014
            ],
            [
              -94.997836,
              34.898491
            ],
            [
              -94.997845,
              34.900403
            ],
            [
              -94.9979,
              34.911218
            ],
            [
              -94.99791,
              34.913099
            ],
            [
              -94.99804,
              34.936194
            ],
            [
              -94.99807,
              34.942157
            ],
            [
              -94.98097,
              34.942139
            ],
            [
              -94.975783,
              34.942174
            ],
            [
              -94.92783,
              34.942213
            ],
            [
              -94.92779,
              34.957219
            ],
            [
              -94.92775,
              34.973187
            ],
            [
              -94.9277,
              34.99297
            ],
            [
              -94.927687,
              34.998541
            ],
            [
              -94.927703,
              35.014329
            ],
            [
              -94.927825,
              35.035379
            ],
            [
              -94.927838,
              35.043028
            ],
            [
              -94.92786,
              35.058279
            ]
          ]
        ]
      },
      "properties": {
        "county": "40077",
        "name": "Latimer"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -99.88857,
              35.030262
            ],
            [
              -99.95161,
              35.029932
            ],
            [
              -100.00038,
              35.030385
            ],
            [
              -100.00038,
              34.913895
            ],
            [
              -100.00038,
              34.746461
            ],
            [
              -100.00038,
              34.637836
            ],
            [
              -100.00038,
              34.560509
            ],
            [
              -99.99302,
              34.559521
            ],
            [
              -99.97096,
              34.562508
            ],
            [
              -99.957541,
              34.572709
            ],
            [
              -99.95457,
              34.578195
            ],
            [
              -99.94464,
              34.579134
            ],
            [
              -99.92321,
              34.574552
            ],
            [
              -99.9218,
              34.570253
            ],
            [
              -99.909988,
              34.562135
            ],
            [
              -99.88874,
              34.550452
            ],
            [
              -99.8809,
              34.542219
            ],
            [
              -99.8766,
              34.539709
            ],
            [
              -99.87225,
              34.531722
            ],
            [
              -99.86492,
              34.523018
            ],
            [
              -99.853066,
              34.511593
            ],
            [
              -99.84458,
              34.506915
            ],
            [
              -99.77162,
              34.507171
            ],
            [
              -99.66656,
              34.507131
            ],
            [
              -99.6666,
              34.608484
            ],
            [
              -99.66668,
              34.710003
            ],
            [
              -99.6669,
              34.724638
            ],
            [
              -99.66736,
              34.753712
            ],
            [
              -99.68493,
              34.753645
            ],
            [
              -99.68501,
              34.768281
            ],
            [
              -99.72007,
              34.768298
            ],
            [
              -99.72045,
              34.81193
            ],
            [
              -99.72,
              34.857033
            ],
            [
              -99.73107,
              34.85699
            ],
            [
              -99.73124,
              34.944115
            ],
            [
              -99.81677,
              34.944374
            ],
            [
              -99.888425,
              34.943946
            ],
            [
              -99.88818,
              34.980275
            ],
            [
              -99.88857,
              35.030262
            ]
          ]
        ]
      },
      "properties": {
        "county": "40057",
        "name": "Harmon"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.09264,
              34.854919
            ],
            [
              -98.15153,
              34.854735
            ],
            [
              -98.3482,
              34.855088
            ],
            [
              -98.37707,
              34.855284
            ],
            [
              -98.49268,
              34.855012
            ],
            [
              -98.56178,
              34.85528
            ],
            [
              -98.61982,
              34.854953
            ],
            [
              -98.672588,
              34.85548
            ],
            [
              -98.74016,
              34.855062
            ],
            [
              -98.7872,
              34.855752
            ],
            [
              -98.82629,
              34.855411
            ],
            [
              -98.82613,
              34.742681
            ],
            [
              -98.82633,
              34.695944
            ],
            [
              -98.8262,
              34.594222
            ],
            [
              -98.82633,
              34.565155
            ],
            [
              -98.82606,
              34.507249
            ],
            [
              -98.66175,
              34.50734
            ],
            [
              -98.662,
              34.406007
            ],
            [
              -98.60938,
              34.406184
            ],
            [
              -98.60939,
              34.420638
            ],
            [
              -98.50482,
              34.420564
            ],
            [
              -98.50474,
              34.449333
            ],
            [
              -98.40023,
              34.448883
            ],
            [
              -98.29582,
              34.449072
            ],
            [
              -98.29582,
              34.463547
            ],
            [
              -98.24415,
              34.463765
            ],
            [
              -98.24402,
              34.506968
            ],
            [
              -98.21325,
              34.507207
            ],
            [
              -98.18118,
              34.50689
            ],
            [
              -98.14214,
              34.507042
            ],
            [
              -98.14187,
              34.652102
            ],
            [
              -98.14158,
              34.681098
            ],
            [
              -98.08908,
              34.681106
            ],
            [
              -98.08908,
              34.768083
            ],
            [
              -98.08931,
              34.796597
            ],
            [
              -98.08901,
              34.837616
            ],
            [
              -98.08956,
              34.854929
            ],
            [
              -98.09264,
              34.854919
            ]
          ]
        ]
      },
      "properties": {
        "county": "40031",
        "name": "Comanche"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.09212,
              34.76759
            ],
            [
              -96.12528,
              34.767243
            ],
            [
              -96.22848,
              34.766892
            ],
            [
              -96.29508,
              34.766791
            ],
            [
              -96.40648,
              34.76759
            ],
            [
              -96.40642,
              34.716684
            ],
            [
              -96.40601,
              34.698235
            ],
            [
              -96.4065,
              34.680163
            ],
            [
              -96.51213,
              34.680016
            ],
            [
              -96.51225,
              34.614513
            ],
            [
              -96.51197,
              34.527341
            ],
            [
              -96.51248,
              34.505525
            ],
            [
              -96.51386,
              34.505389
            ],
            [
              -96.51434,
              34.488516
            ],
            [
              -96.51379,
              34.419627
            ],
            [
              -96.45438,
              34.419592
            ],
            [
              -96.45278,
              34.418493
            ],
            [
              -96.407334,
              34.41854
            ],
            [
              -96.33736,
              34.418309
            ],
            [
              -96.22282,
              34.418446
            ],
            [
              -96.1451,
              34.418677
            ],
            [
              -96.14534,
              34.506102
            ],
            [
              -96.1052,
              34.506467
            ],
            [
              -96.09187,
              34.506155
            ],
            [
              -96.092251,
              34.535188
            ],
            [
              -96.09196,
              34.585951
            ],
            [
              -96.0923,
              34.615846
            ],
            [
              -96.09188,
              34.653194
            ],
            [
              -96.09217,
              34.680586
            ],
            [
              -96.09237,
              34.709293
            ],
            [
              -96.09212,
              34.76759
            ]
          ]
        ]
      },
      "properties": {
        "county": "40029",
        "name": "Coal"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.668431,
              34.681339
            ],
            [
              -97.76137,
              34.681253
            ],
            [
              -97.86161,
              34.681467
            ],
            [
              -97.9672,
              34.681748
            ],
            [
              -98.08908,
              34.681106
            ],
            [
              -98.14158,
              34.681098
            ],
            [
              -98.14187,
              34.652102
            ],
            [
              -98.14214,
              34.507042
            ],
            [
              -98.13923,
              34.507018
            ],
            [
              -98.13888,
              34.40559
            ],
            [
              -98.13915,
              34.319395
            ],
            [
              -98.13895,
              34.28978
            ],
            [
              -98.09404,
              34.290321
            ],
            [
              -98.06751,
              34.289722
            ],
            [
              -98.00031,
              34.289499
            ],
            [
              -97.99988,
              34.288893
            ],
            [
              -97.91565,
              34.289171
            ],
            [
              -97.750308,
              34.289234
            ],
            [
              -97.67454,
              34.289105
            ],
            [
              -97.56258,
              34.289048
            ],
            [
              -97.562709,
              34.332575
            ],
            [
              -97.56236,
              34.463228
            ],
            [
              -97.56236,
              34.506925
            ],
            [
              -97.56311,
              34.521581
            ],
            [
              -97.56275,
              34.550827
            ],
            [
              -97.56272,
              34.623124
            ],
            [
              -97.56304,
              34.638467
            ],
            [
              -97.562757,
              34.681147
            ],
            [
              -97.668431,
              34.681339
            ]
          ]
        ]
      },
      "properties": {
        "county": "40137",
        "name": "Stephens"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.67198,
              34.593852
            ],
            [
              -95.70248,
              34.594108
            ],
            [
              -95.88217,
              34.593521
            ],
            [
              -95.8821,
              34.680475
            ],
            [
              -95.92062,
              34.680349
            ],
            [
              -95.9608,
              34.680827
            ],
            [
              -96.00027,
              34.680374
            ],
            [
              -96.09217,
              34.680586
            ],
            [
              -96.09188,
              34.653194
            ],
            [
              -96.0923,
              34.615846
            ],
            [
              -96.09196,
              34.585951
            ],
            [
              -96.092251,
              34.535188
            ],
            [
              -96.09187,
              34.506155
            ],
            [
              -96.1052,
              34.506467
            ],
            [
              -96.14534,
              34.506102
            ],
            [
              -96.1451,
              34.418677
            ],
            [
              -96.22282,
              34.418446
            ],
            [
              -96.33736,
              34.418309
            ],
            [
              -96.407334,
              34.41854
            ],
            [
              -96.40695,
              34.404025
            ],
            [
              -96.40713,
              34.250091
            ],
            [
              -96.40772,
              34.184194
            ],
            [
              -96.40764,
              34.157317
            ],
            [
              -96.31048,
              34.15714
            ],
            [
              -96.26792,
              34.157474
            ],
            [
              -96.23342,
              34.157042
            ],
            [
              -96.08424,
              34.156962
            ],
            [
              -96.03686,
              34.15758
            ],
            [
              -95.99158,
              34.156816
            ],
            [
              -95.87526,
              34.156562
            ],
            [
              -95.82865,
              34.156816
            ],
            [
              -95.77938,
              34.156699
            ],
            [
              -95.77893,
              34.185918
            ],
            [
              -95.77923,
              34.258226
            ],
            [
              -95.77919,
              34.395498
            ],
            [
              -95.779,
              34.500097
            ],
            [
              -95.77942,
              34.506556
            ],
            [
              -95.75026,
              34.506808
            ],
            [
              -95.6717,
              34.506799
            ],
            [
              -95.67198,
              34.593852
            ]
          ]
        ]
      },
      "properties": {
        "county": "40005",
        "name": "Atoka"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -98.8262,
              34.594222
            ],
            [
              -98.92802,
              34.594475
            ],
            [
              -99.00089,
              34.594345
            ],
            [
              -99.00103,
              34.637819
            ],
            [
              -99.10315,
              34.637989
            ],
            [
              -99.09606,
              34.634074
            ],
            [
              -99.09001,
              34.625562
            ],
            [
              -99.08272,
              34.624319
            ],
            [
              -99.0792,
              34.618113
            ],
            [
              -99.08183,
              34.613806
            ],
            [
              -99.088457,
              34.615248
            ],
            [
              -99.08255,
              34.596054
            ],
            [
              -99.08288,
              34.590854
            ],
            [
              -99.09396,
              34.587095
            ],
            [
              -99.09967,
              34.594126
            ],
            [
              -99.11155,
              34.592221
            ],
            [
              -99.1218,
              34.587887
            ],
            [
              -99.12459,
              34.582983
            ],
            [
              -99.12995,
              34.584887
            ],
            [
              -99.13221,
              34.59208
            ],
            [
              -99.14099,
              34.592541
            ],
            [
              -99.15637,
              34.587966
            ],
            [
              -99.16332,
              34.588036
            ],
            [
              -99.1711,
              34.578233
            ],
            [
              -99.17775,
              34.566483
            ],
            [
              -99.18451,
              34.562315
            ],
            [
              -99.17989,
              34.554733
            ],
            [
              -99.17623,
              34.544791
            ],
            [
              -99.17798,
              34.540097
            ],
            [
              -99.18861,
              34.540624
            ],
            [
              -99.19331,
              34.54454
            ],
            [
              -99.1968,
              34.542386
            ],
            [
              -99.1984,
              34.530751
            ],
            [
              -99.20125,
              34.527933
            ],
            [
              -99.2087,
              34.513066
            ],
            [
              -99.20784,
              34.505347
            ],
            [
              -99.21011,
              34.501658
            ],
            [
              -99.22071,
              34.494484
            ],
            [
              -99.2215,
              34.478248
            ],
            [
              -99.21486,
              34.481022
            ],
            [
              -99.21726,
              34.471057
            ],
            [
              -99.22116,
              34.464184
            ],
            [
              -99.21444,
              34.460498
            ],
            [
              -99.21338,
              34.456169
            ],
            [
              -99.228038,
              34.451836
            ],
            [
              -99.23077,
              34.441366
            ],
            [
              -99.22789,
              34.4339
            ],
            [
              -99.22297,
              34.432847
            ],
            [
              -99.22164,
              34.426893
            ],
            [
              -99.22354,
              34.421486
            ],
            [
              -99.22802,
              34.419561
            ],
            [
              -99.23403,
              34.428514
            ],
            [
              -99.23806,
              34.425009
            ],
            [
              -99.23528,
              34.408677
            ],
            [
              -99.23514,
              34.401072
            ],
            [
              -99.22663,
              34.401281
            ],
            [
              -99.22886,
              34.387698
            ],
            [
              -99.22312,
              34.387173
            ],
            [
              -99.21497,
              34.394024
            ],
            [
              -99.20955,
              34.392811
            ],
            [
              -99.20916,
              34.388619
            ],
            [
              -99.21927,
              34.379179
            ],
            [
              -99.21974,
              34.374304
            ],
            [
              -99.20764,
              34.374238
            ],
            [
              -99.20267,
              34.369109
            ],
            [
              -99.20272,
              34.365146
            ],
            [
              -99.19275,
              34.354861
            ],
            [
              -99.19232,
              34.346718
            ],
            [
              -99.19828,
              34.339622
            ],
            [
              -99.21095,
              34.336838
            ],
            [
              -99.209724,
              34.324935
            ],
            [
              -99.20609,
              34.320594
            ],
            [
              -99.21348,
              34.309275
            ],
            [
              -99.20983,
              34.297799
            ],
            [
              -99.21165,
              34.292232
            ],
            [
              -99.20797,
              34.283803
            ],
            [
              -99.19575,
              34.281273
            ],
            [
              -99.19456,
              34.272972
            ],
            [
              -99.19948,
              34.260743
            ],
            [
              -99.19299,
              34.259774
            ],
            [
              -99.19224,
              34.255582
            ],
            [
              -99.19644,
              34.249315
            ],
            [
              -99.19715,
              34.244298
            ],
            [
              -99.191139,
              34.23234
            ],
            [
              -99.19004,
              34.227186
            ],
            [
              -99.1921,
              34.216694
            ],
            [
              -99.18656,
              34.21351
            ],
            [
              -99.1736,
              34.211746
            ],
            [
              -99.156425,
              34.207116
            ],
            [
              -99.147104,
              34.209862
            ],
            [
              -99.14398,
              34.214763
            ],
            [
              -99.1377,
              34.219274
            ],
            [
              -99.12755,
              34.217986
            ],
            [
              -99.12752,
              34.213771
            ],
            [
              -99.13188,
              34.207382
            ],
            [
              -99.12979,
              34.204403
            ],
            [
              -99.12095,
              34.201788
            ],
            [
              -99.11284,
              34.205758
            ],
            [
              -99.10749,
              34.203791
            ],
            [
              -99.10225,
              34.205419
            ],
            [
              -99.09542,
              34.21179
            ],
            [
              -99.08987,
              34.208515
            ],
            [
              -99.08072,
              34.211449
            ],
            [
              -99.066465,
              34.208404
            ],
            [
              -99.05646,
              34.199973
            ],
            [
              -99.04347,
              34.198208
            ],
            [
              -99.037459,
              34.206454
            ],
            [
              -99.02458,
              34.203999
            ],
            [
              -99.01739,
              34.20635
            ],
            [
              -99.01307,
              34.203222
            ],
            [
              -99.00579,
              34.206647
            ],
            [
              -99.001944,
              34.210589
            ],
            [
              -99.00481,
              34.214232
            ],
            [
              -98.99182,
              34.221564
            ],
            [
              -98.98136,
              34.217583
            ],
            [
              -98.97678,
              34.206635
            ],
            [
              -98.97273,
              34.202673
            ],
            [
              -98.96586,
              34.201552
            ],
            [
              -98.96247,
              34.204668
            ],
            [
              -98.96231,
              34.211312
            ],
            [
              -98.95847,
              34.213855
            ],
            [
              -98.95136,
              34.212321
            ],
            [
              -98.9333,
              34.197317
            ],
            [
              -98.9207,
              34.183435
            ],
            [
              -98.909349,
              34.177499
            ],
            [
              -98.89838,
              34.175114
            ],
            [
              -98.88711,
              34.16826
            ],
            [
              -98.87292,
              34.166584
            ],
            [
              -98.87121,
              34.163012
            ],
            [
              -98.87495,
              34.157031
            ],
            [
              -98.87327,
              34.153596
            ],
            [
              -98.86575,
              34.149132
            ],
            [
              -98.86012,
              34.149913
            ],
            [
              -98.85732,
              34.161094
            ],
            [
              -98.85451,
              34.161713
            ],
            [
              -98.83707,
              34.156495
            ],
            [
              -98.83111,
              34.162154
            ],
            [
              -98.81527,
              34.158101
            ],
            [
              -98.80441,
              34.153931
            ],
            [
              -98.796203,
              34.142775
            ],
            [
              -98.78794,
              34.146393
            ],
            [
              -98.778076,
              34.139495
            ],
            [
              -98.76667,
              34.136834
            ],
            [
              -98.76056,
              34.132388
            ],
            [
              -98.75745,
              34.124713
            ],
            [
              -98.74929,
              34.124238
            ],
            [
              -98.73946,
              34.127394
            ],
            [
              -98.73547,
              34.135208
            ],
            [
              -98.71864,
              34.136473
            ],
            [
              -98.71247,
              34.13116
            ],
            [
              -98.70613,
              34.134986
            ],
            [
              -98.700182,
              34.135995
            ],
            [
              -98.69007,
              34.133155
            ],
            [
              -98.68453,
              34.138424
            ],
            [
              -98.67715,
              34.142501
            ],
            [
              -98.67153,
              34.148892
            ],
            [
              -98.65565,
              34.158258
            ],
            [
              -98.64807,
              34.164441
            ],
            [
              -98.64322,
              34.164531
            ],
            [
              -98.619351,
              34.156669
            ],
            [
              -98.610158,
              34.157098
            ],
            [
              -98.6098,
              34.173556
            ],
            [
              -98.60949,
              34.26078
            ],
            [
              -98.609502,
              34.33369
            ],
            [
              -98.661719,
              34.333467
            ],
            [
              -98.662,
              34.406007
            ],
            [
              -98.66175,
              34.50734
            ],
            [
              -98.82606,
              34.507249
            ],
            [
              -98.82633,
              34.565155
            ],
            [
              -98.8262,
              34.594222
            ]
          ]
        ]
      },
      "properties": {
        "county": "40141",
        "name": "Tillman"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.93245,
              34.636727
            ],
            [
              -97.0003,
              34.636665
            ],
            [
              -97.00667,
              34.637099
            ],
            [
              -97.07238,
              34.636975
            ],
            [
              -97.14267,
              34.637032
            ],
            [
              -97.14237,
              34.622584
            ],
            [
              -97.199431,
              34.622729
            ],
            [
              -97.19519,
              34.618175
            ],
            [
              -97.19846,
              34.613526
            ],
            [
              -97.19106,
              34.597177
            ],
            [
              -97.17143,
              34.593269
            ],
            [
              -97.167211,
              34.588441
            ],
            [
              -97.173519,
              34.586812
            ],
            [
              -97.17258,
              34.58056
            ],
            [
              -97.16796,
              34.576103
            ],
            [
              -97.17563,
              34.57143
            ],
            [
              -97.17317,
              34.565067
            ],
            [
              -97.16552,
              34.562969
            ],
            [
              -97.16444,
              34.558541
            ],
            [
              -97.15773,
              34.551495
            ],
            [
              -97.16306,
              34.547399
            ],
            [
              -97.158054,
              34.522714
            ],
            [
              -97.14981,
              34.521423
            ],
            [
              -97.15263,
              34.516175
            ],
            [
              -97.144687,
              34.510317
            ],
            [
              -97.14387,
              34.506533
            ],
            [
              -97.184064,
              34.506454
            ],
            [
              -97.2503,
              34.506855
            ],
            [
              -97.35211,
              34.506788
            ],
            [
              -97.35225,
              34.43126
            ],
            [
              -97.35216,
              34.376227
            ],
            [
              -97.27369,
              34.376156
            ],
            [
              -97.18357,
              34.376235
            ],
            [
              -97.11507,
              34.376093
            ],
            [
              -97.036488,
              34.375415
            ],
            [
              -97.03371,
              34.372951
            ],
            [
              -97.03884,
              34.36691
            ],
            [
              -97.034856,
              34.36061
            ],
            [
              -97.03521,
              34.35538
            ],
            [
              -97.031546,
              34.350524
            ],
            [
              -97.042611,
              34.344608
            ],
            [
              -97.03951,
              34.33754
            ],
            [
              -97.028704,
              34.332638
            ],
            [
              -97.00784,
              34.332332
            ],
            [
              -96.93346,
              34.332661
            ],
            [
              -96.881,
              34.332977
            ],
            [
              -96.88064,
              34.38987
            ],
            [
              -96.88095,
              34.477385
            ],
            [
              -96.88082,
              34.50589
            ],
            [
              -96.82729,
              34.505989
            ],
            [
              -96.82729,
              34.59317
            ],
            [
              -96.93242,
              34.593101
            ],
            [
              -96.93245,
              34.636727
            ]
          ]
        ]
      },
      "properties": {
        "county": "40099",
        "name": "Murray"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.51386,
              34.505389
            ],
            [
              -96.64534,
              34.505691
            ],
            [
              -96.67649,
              34.505599
            ],
            [
              -96.82729,
              34.505989
            ],
            [
              -96.88082,
              34.50589
            ],
            [
              -96.88095,
              34.477385
            ],
            [
              -96.88064,
              34.38987
            ],
            [
              -96.881,
              34.332977
            ],
            [
              -96.93346,
              34.332661
            ],
            [
              -96.933417,
              34.250093
            ],
            [
              -96.933732,
              34.23874
            ],
            [
              -96.93367,
              34.172553
            ],
            [
              -96.78254,
              34.172449
            ],
            [
              -96.71828,
              34.172575
            ],
            [
              -96.66996,
              34.172254
            ],
            [
              -96.65615,
              34.161194
            ],
            [
              -96.64945,
              34.16278
            ],
            [
              -96.64338,
              34.168066
            ],
            [
              -96.6386,
              34.168103
            ],
            [
              -96.641157,
              34.158398
            ],
            [
              -96.63207,
              34.154555
            ],
            [
              -96.62724,
              34.15851
            ],
            [
              -96.619783,
              34.161191
            ],
            [
              -96.61919,
              34.154043
            ],
            [
              -96.61313,
              34.151981
            ],
            [
              -96.60978,
              34.146889
            ],
            [
              -96.6138,
              34.14198
            ],
            [
              -96.60682,
              34.139873
            ],
            [
              -96.60299,
              34.145635
            ],
            [
              -96.59869,
              34.140397
            ],
            [
              -96.60087,
              34.135583
            ],
            [
              -96.588569,
              34.126743
            ],
            [
              -96.58225,
              34.125327
            ],
            [
              -96.58179,
              34.121429
            ],
            [
              -96.585355,
              34.114459
            ],
            [
              -96.490266,
              34.114133
            ],
            [
              -96.45384,
              34.114406
            ],
            [
              -96.4539,
              34.157348
            ],
            [
              -96.40764,
              34.157317
            ],
            [
              -96.40772,
              34.184194
            ],
            [
              -96.40713,
              34.250091
            ],
            [
              -96.40695,
              34.404025
            ],
            [
              -96.407334,
              34.41854
            ],
            [
              -96.45278,
              34.418493
            ],
            [
              -96.45438,
              34.419592
            ],
            [
              -96.51379,
              34.419627
            ],
            [
              -96.51434,
              34.488516
            ],
            [
              -96.51386,
              34.505389
            ]
          ]
        ]
      },
      "properties": {
        "county": "40069",
        "name": "Johnston"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.56258,
              34.289048
            ],
            [
              -97.67454,
              34.289105
            ],
            [
              -97.750308,
              34.289234
            ],
            [
              -97.91565,
              34.289171
            ],
            [
              -97.99988,
              34.288893
            ],
            [
              -98.00031,
              34.289499
            ],
            [
              -98.06751,
              34.289722
            ],
            [
              -98.09404,
              34.290321
            ],
            [
              -98.13895,
              34.28978
            ],
            [
              -98.13919,
              34.246419
            ],
            [
              -98.139072,
              34.14187
            ],
            [
              -98.13082,
              34.150532
            ],
            [
              -98.123377,
              34.15454
            ],
            [
              -98.10946,
              34.154111
            ],
            [
              -98.10194,
              34.14683
            ],
            [
              -98.10056,
              34.142135
            ],
            [
              -98.10331,
              34.13414
            ],
            [
              -98.09978,
              34.131346
            ],
            [
              -98.09201,
              34.131944
            ],
            [
              -98.09055,
              34.122484
            ],
            [
              -98.09512,
              34.11119
            ],
            [
              -98.10257,
              34.100033
            ],
            [
              -98.11848,
              34.085619
            ],
            [
              -98.12104,
              34.081266
            ],
            [
              -98.120208,
              34.072127
            ],
            [
              -98.11459,
              34.06228
            ],
            [
              -98.10063,
              34.049984
            ],
            [
              -98.08384,
              34.041719
            ],
            [
              -98.08329,
              34.037138
            ],
            [
              -98.091788,
              34.033654
            ],
            [
              -98.09754,
              34.038578
            ],
            [
              -98.10502,
              34.037545
            ],
            [
              -98.10362,
              34.029207
            ],
            [
              -98.09544,
              34.021697
            ],
            [
              -98.08955,
              34.01927
            ],
            [
              -98.08402,
              34.014369
            ],
            [
              -98.0824,
              34.009834
            ],
            [
              -98.08881,
              34.007176
            ],
            [
              -98.08443,
              34.002893
            ],
            [
              -98.04112,
              33.993456
            ],
            [
              -98.01634,
              33.994098
            ],
            [
              -97.98739,
              33.999823
            ],
            [
              -97.97951,
              34.004722
            ],
            [
              -97.97167,
              34.005434
            ],
            [
              -97.96193,
              33.99325
            ],
            [
              -97.95832,
              33.990846
            ],
            [
              -97.9468,
              33.990893
            ],
            [
              -97.94864,
              33.982601
            ],
            [
              -97.956917,
              33.958502
            ],
            [
              -97.96104,
              33.951103
            ],
            [
              -97.9731,
              33.944184
            ],
            [
              -97.97117,
              33.937129
            ],
            [
              -97.95339,
              33.936445
            ],
            [
              -97.95268,
              33.929482
            ],
            [
              -97.95715,
              33.914454
            ],
            [
              -97.96163,
              33.909414
            ],
            [
              -97.96875,
              33.906023
            ],
            [
              -97.97696,
              33.912549
            ],
            [
              -97.97998,
              33.911402
            ],
            [
              -97.98355,
              33.904002
            ],
            [
              -97.98437,
              33.898024
            ],
            [
              -97.97418,
              33.886643
            ],
            [
              -97.96671,
              33.881949
            ],
            [
              -97.95709,
              33.878859
            ],
            [
              -97.93792,
              33.879662
            ],
            [
              -97.92858,
              33.874187
            ],
            [
              -97.90986,
              33.867221
            ],
            [
              -97.89674,
              33.857985
            ],
            [
              -97.888721,
              33.856723
            ],
            [
              -97.87739,
              33.850236
            ],
            [
              -97.86576,
              33.849393
            ],
            [
              -97.84781,
              33.854759
            ],
            [
              -97.83433,
              33.857671
            ],
            [
              -97.8303,
              33.862253
            ],
            [
              -97.82299,
              33.866467
            ],
            [
              -97.81967,
              33.870544
            ],
            [
              -97.81943,
              33.8779
            ],
            [
              -97.8155,
              33.882
            ],
            [
              -97.80597,
              33.876571
            ],
            [
              -97.80158,
              33.885138
            ],
            [
              -97.80174,
              33.895147
            ],
            [
              -97.79891,
              33.898537
            ],
            [
              -97.7924,
              33.899086
            ],
            [
              -97.78466,
              33.890632
            ],
            [
              -97.78004,
              33.897205
            ],
            [
              -97.78034,
              33.904833
            ],
            [
              -97.786133,
              33.913424
            ],
            [
              -97.78352,
              33.918302
            ],
            [
              -97.77684,
              33.918918
            ],
            [
              -97.77267,
              33.914382
            ],
            [
              -97.76545,
              33.913532
            ],
            [
              -97.7594,
              33.91882
            ],
            [
              -97.75983,
              33.92521
            ],
            [
              -97.76304,
              33.934145
            ],
            [
              -97.75499,
              33.936638
            ],
            [
              -97.74202,
              33.937443
            ],
            [
              -97.73227,
              33.936691
            ],
            [
              -97.72529,
              33.941045
            ],
            [
              -97.71235,
              33.951905
            ],
            [
              -97.704159,
              33.963336
            ],
            [
              -97.69756,
              33.978316
            ],
            [
              -97.68769,
              33.98718
            ],
            [
              -97.67128,
              33.991553
            ],
            [
              -97.66149,
              33.990818
            ],
            [
              -97.63378,
              33.981257
            ],
            [
              -97.61555,
              33.969556
            ],
            [
              -97.60909,
              33.968093
            ],
            [
              -97.60098,
              33.960789
            ],
            [
              -97.59798,
              33.955247
            ],
            [
              -97.58883,
              33.951882
            ],
            [
              -97.59542,
              33.941436
            ],
            [
              -97.59151,
              33.9282
            ],
            [
              -97.596979,
              33.920228
            ],
            [
              -97.59629,
              33.913769
            ],
            [
              -97.58991,
              33.908044
            ],
            [
              -97.58925,
              33.903922
            ],
            [
              -97.58104,
              33.900396
            ],
            [
              -97.566812,
              33.902871
            ],
            [
              -97.56086,
              33.899645
            ],
            [
              -97.560927,
              33.983973
            ],
            [
              -97.53682,
              33.983877
            ],
            [
              -97.54515,
              33.98759
            ],
            [
              -97.55133,
              33.997095
            ],
            [
              -97.55642,
              34.001988
            ],
            [
              -97.56087,
              34.002978
            ],
            [
              -97.56076,
              34.071089
            ],
            [
              -97.562388,
              34.071074
            ],
            [
              -97.56272,
              34.125094
            ],
            [
              -97.562416,
              34.216443
            ],
            [
              -97.56274,
              34.24571
            ],
            [
              -97.56258,
              34.289048
            ]
          ]
        ]
      },
      "properties": {
        "county": "40067",
        "name": "Jefferson"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.585355,
              34.114459
            ],
            [
              -96.58179,
              34.121429
            ],
            [
              -96.58225,
              34.125327
            ],
            [
              -96.588569,
              34.126743
            ],
            [
              -96.60087,
              34.135583
            ],
            [
              -96.59869,
              34.140397
            ],
            [
              -96.60299,
              34.145635
            ],
            [
              -96.60682,
              34.139873
            ],
            [
              -96.6138,
              34.14198
            ],
            [
              -96.60978,
              34.146889
            ],
            [
              -96.61313,
              34.151981
            ],
            [
              -96.61919,
              34.154043
            ],
            [
              -96.619783,
              34.161191
            ],
            [
              -96.62724,
              34.15851
            ],
            [
              -96.63207,
              34.154555
            ],
            [
              -96.641157,
              34.158398
            ],
            [
              -96.6386,
              34.168103
            ],
            [
              -96.64338,
              34.168066
            ],
            [
              -96.64945,
              34.16278
            ],
            [
              -96.65615,
              34.161194
            ],
            [
              -96.66996,
              34.172254
            ],
            [
              -96.71828,
              34.172575
            ],
            [
              -96.78254,
              34.172449
            ],
            [
              -96.93367,
              34.172553
            ],
            [
              -96.96841,
              34.172617
            ],
            [
              -96.96866,
              34.159773
            ],
            [
              -96.96827,
              34.076025
            ],
            [
              -96.970006,
              34.07083
            ],
            [
              -96.96972,
              34.013008
            ],
            [
              -96.93479,
              34.012942
            ],
            [
              -96.93484,
              33.954453
            ],
            [
              -96.92427,
              33.959159
            ],
            [
              -96.91765,
              33.95858
            ],
            [
              -96.90525,
              33.947219
            ],
            [
              -96.89944,
              33.933728
            ],
            [
              -96.89647,
              33.913318
            ],
            [
              -96.89722,
              33.904575
            ],
            [
              -96.89573,
              33.896414
            ],
            [
              -96.88301,
              33.868019
            ],
            [
              -96.86644,
              33.853149
            ],
            [
              -96.85609,
              33.84749
            ],
            [
              -96.85059,
              33.847211
            ],
            [
              -96.84159,
              33.852894
            ],
            [
              -96.83978,
              33.868396
            ],
            [
              -96.83216,
              33.874835
            ],
            [
              -96.812778,
              33.872646
            ],
            [
              -96.79428,
              33.868886
            ],
            [
              -96.783485,
              33.863534
            ],
            [
              -96.779588,
              33.857939
            ],
            [
              -96.77677,
              33.841976
            ],
            [
              -96.76938,
              33.827477
            ],
            [
              -96.76159,
              33.824406
            ],
            [
              -96.74378,
              33.826065
            ],
            [
              -96.7251,
              33.830313
            ],
            [
              -96.71373,
              33.831328
            ],
            [
              -96.70446,
              33.835021
            ],
            [
              -96.699574,
              33.839049
            ],
            [
              -96.69071,
              33.849959
            ],
            [
              -96.68473,
              33.862905
            ],
            [
              -96.6821,
              33.876645
            ],
            [
              -96.68346,
              33.884217
            ],
            [
              -96.68149,
              33.894675
            ],
            [
              -96.67345,
              33.912278
            ],
            [
              -96.667187,
              33.91694
            ],
            [
              -96.6599,
              33.916666
            ],
            [
              -96.65498,
              33.913789
            ],
            [
              -96.630117,
              33.895422
            ],
            [
              -96.61471,
              33.894539
            ],
            [
              -96.592948,
              33.895616
            ],
            [
              -96.5885,
              33.894983
            ],
            [
              -96.590334,
              33.904362
            ],
            [
              -96.58174,
              33.909903
            ],
            [
              -96.58103,
              33.925015
            ],
            [
              -96.58828,
              33.926696
            ],
            [
              -96.59316,
              33.932961
            ],
            [
              -96.59093,
              33.935944
            ],
            [
              -96.59582,
              33.944051
            ],
            [
              -96.59306,
              33.950922
            ],
            [
              -96.5879,
              33.948005
            ],
            [
              -96.5778,
              33.95845
            ],
            [
              -96.57701,
              33.964406
            ],
            [
              -96.58436,
              33.966505
            ],
            [
              -96.58469,
              33.97093
            ],
            [
              -96.594332,
              33.971655
            ],
            [
              -96.60398,
              33.985351
            ],
            [
              -96.61272,
              33.989852
            ],
            [
              -96.61432,
              33.997017
            ],
            [
              -96.61994,
              33.999449
            ],
            [
              -96.62067,
              34.005672
            ],
            [
              -96.61699,
              34.010209
            ],
            [
              -96.60393,
              34.008224
            ],
            [
              -96.60234,
              34.014194
            ],
            [
              -96.59342,
              34.016728
            ],
            [
              -96.59003,
              34.011311
            ],
            [
              -96.58295,
              34.006875
            ],
            [
              -96.57895,
              34.00914
            ],
            [
              -96.5741,
              34.016679
            ],
            [
              -96.5789,
              34.023537
            ],
            [
              -96.573022,
              34.02862
            ],
            [
              -96.576361,
              34.033804
            ],
            [
              -96.57398,
              34.041969
            ],
            [
              -96.56758,
              34.047948
            ],
            [
              -96.55801,
              34.050463
            ],
            [
              -96.55598,
              34.056326
            ],
            [
              -96.54803,
              34.063302
            ],
            [
              -96.55075,
              34.071749
            ],
            [
              -96.56098,
              34.07372
            ],
            [
              -96.55589,
              34.081178
            ],
            [
              -96.56474,
              34.082088
            ],
            [
              -96.56577,
              34.0884
            ],
            [
              -96.57012,
              34.094951
            ],
            [
              -96.58139,
              34.104808
            ],
            [
              -96.57913,
              34.107997
            ],
            [
              -96.585355,
              34.114459
            ]
          ]
        ]
      },
      "properties": {
        "county": "40095",
        "name": "Marshall"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.99158,
              34.156816
            ],
            [
              -96.03686,
              34.15758
            ],
            [
              -96.08424,
              34.156962
            ],
            [
              -96.23342,
              34.157042
            ],
            [
              -96.26792,
              34.157474
            ],
            [
              -96.31048,
              34.15714
            ],
            [
              -96.40764,
              34.157317
            ],
            [
              -96.4539,
              34.157348
            ],
            [
              -96.45384,
              34.114406
            ],
            [
              -96.490266,
              34.114133
            ],
            [
              -96.585355,
              34.114459
            ],
            [
              -96.57913,
              34.107997
            ],
            [
              -96.58139,
              34.104808
            ],
            [
              -96.57012,
              34.094951
            ],
            [
              -96.56577,
              34.0884
            ],
            [
              -96.56474,
              34.082088
            ],
            [
              -96.55589,
              34.081178
            ],
            [
              -96.56098,
              34.07372
            ],
            [
              -96.55075,
              34.071749
            ],
            [
              -96.54803,
              34.063302
            ],
            [
              -96.55598,
              34.056326
            ],
            [
              -96.55801,
              34.050463
            ],
            [
              -96.56758,
              34.047948
            ],
            [
              -96.57398,
              34.041969
            ],
            [
              -96.576361,
              34.033804
            ],
            [
              -96.573022,
              34.02862
            ],
            [
              -96.5789,
              34.023537
            ],
            [
              -96.5741,
              34.016679
            ],
            [
              -96.57895,
              34.00914
            ],
            [
              -96.58295,
              34.006875
            ],
            [
              -96.59003,
              34.011311
            ],
            [
              -96.59342,
              34.016728
            ],
            [
              -96.60234,
              34.014194
            ],
            [
              -96.60393,
              34.008224
            ],
            [
              -96.61699,
              34.010209
            ],
            [
              -96.62067,
              34.005672
            ],
            [
              -96.61994,
              33.999449
            ],
            [
              -96.61432,
              33.997017
            ],
            [
              -96.61272,
              33.989852
            ],
            [
              -96.60398,
              33.985351
            ],
            [
              -96.594332,
              33.971655
            ],
            [
              -96.58469,
              33.97093
            ],
            [
              -96.58436,
              33.966505
            ],
            [
              -96.57701,
              33.964406
            ],
            [
              -96.5778,
              33.95845
            ],
            [
              -96.5879,
              33.948005
            ],
            [
              -96.59306,
              33.950922
            ],
            [
              -96.59582,
              33.944051
            ],
            [
              -96.59093,
              33.935944
            ],
            [
              -96.59316,
              33.932961
            ],
            [
              -96.58828,
              33.926696
            ],
            [
              -96.58103,
              33.925015
            ],
            [
              -96.58174,
              33.909903
            ],
            [
              -96.590334,
              33.904362
            ],
            [
              -96.5885,
              33.894983
            ],
            [
              -96.58536,
              33.888948
            ],
            [
              -96.59011,
              33.880665
            ],
            [
              -96.59735,
              33.875101
            ],
            [
              -96.61163,
              33.869253
            ],
            [
              -96.62897,
              33.852407
            ],
            [
              -96.62929,
              33.845488
            ],
            [
              -96.62315,
              33.841483
            ],
            [
              -96.60126,
              33.834327
            ],
            [
              -96.58707,
              33.828009
            ],
            [
              -96.57315,
              33.819182
            ],
            [
              -96.55075,
              33.819182
            ],
            [
              -96.53286,
              33.823005
            ],
            [
              -96.52386,
              33.818114
            ],
            [
              -96.51658,
              33.803168
            ],
            [
              -96.51606,
              33.788512
            ],
            [
              -96.51207,
              33.781646
            ],
            [
              -96.50076,
              33.772652
            ],
            [
              -96.48606,
              33.77301
            ],
            [
              -96.47669,
              33.775
            ],
            [
              -96.45625,
              33.776035
            ],
            [
              -96.44965,
              33.780823
            ],
            [
              -96.44192,
              33.780799
            ],
            [
              -96.42264,
              33.776041
            ],
            [
              -96.41615,
              33.766099
            ],
            [
              -96.41292,
              33.756911
            ],
            [
              -96.40351,
              33.746289
            ],
            [
              -96.3823,
              33.728808
            ],
            [
              -96.37549,
              33.720878
            ],
            [
              -96.37085,
              33.717996
            ],
            [
              -96.36343,
              33.701567
            ],
            [
              -96.362198,
              33.691818
            ],
            [
              -96.35595,
              33.687155
            ],
            [
              -96.34338,
              33.686746
            ],
            [
              -96.33119,
              33.693639
            ],
            [
              -96.31876,
              33.696753
            ],
            [
              -96.30996,
              33.710489
            ],
            [
              -96.30665,
              33.721658
            ],
            [
              -96.30824,
              33.73402
            ],
            [
              -96.30301,
              33.750878
            ],
            [
              -96.29487,
              33.764771
            ],
            [
              -96.28801,
              33.765548
            ],
            [
              -96.27727,
              33.769735
            ],
            [
              -96.2699,
              33.768405
            ],
            [
              -96.26066,
              33.763708
            ],
            [
              -96.25026,
              33.760089
            ],
            [
              -96.23035,
              33.748523
            ],
            [
              -96.22052,
              33.74739
            ],
            [
              -96.20091,
              33.751751
            ],
            [
              -96.18655,
              33.756375
            ],
            [
              -96.17806,
              33.760518
            ],
            [
              -96.16945,
              33.770131
            ],
            [
              -96.1652,
              33.78013
            ],
            [
              -96.159692,
              33.813558
            ],
            [
              -96.163765,
              33.813051
            ],
            [
              -96.16829,
              33.802977
            ],
            [
              -96.17572,
              33.802319
            ],
            [
              -96.179122,
              33.810223
            ],
            [
              -96.17691,
              33.813934
            ],
            [
              -96.1665,
              33.817867
            ],
            [
              -96.1593,
              33.818599
            ],
            [
              -96.15076,
              33.816987
            ],
            [
              -96.14879,
              33.819197
            ],
            [
              -96.15163,
              33.831946
            ],
            [
              -96.14923,
              33.837091
            ],
            [
              -96.1389,
              33.839159
            ],
            [
              -96.13106,
              33.837438
            ],
            [
              -96.12295,
              33.839964
            ],
            [
              -96.10999,
              33.832396
            ],
            [
              -96.09936,
              33.83047
            ],
            [
              -96.09764,
              33.837935
            ],
            [
              -96.101473,
              33.846709
            ],
            [
              -96.08463,
              33.846656
            ],
            [
              -96.06828,
              33.842689
            ],
            [
              -96.04883,
              33.836468
            ],
            [
              -96.03464,
              33.843258
            ],
            [
              -96.03096,
              33.854312
            ],
            [
              -96.02697,
              33.857474
            ],
            [
              -96.01954,
              33.853497
            ],
            [
              -96.02324,
              33.842479
            ],
            [
              -96.02062,
              33.840627
            ],
            [
              -96.0053,
              33.845505
            ],
            [
              -95.99835,
              33.851049
            ],
            [
              -95.994869,
              33.861824
            ],
            [
              -95.99969,
              33.862552
            ],
            [
              -96.00398,
              33.868405
            ],
            [
              -96.00292,
              33.873603
            ],
            [
              -95.98493,
              33.865805
            ],
            [
              -95.98604,
              33.856931
            ],
            [
              -95.98187,
              33.852751
            ],
            [
              -95.97004,
              33.857173
            ],
            [
              -95.95633,
              33.858664
            ],
            [
              -95.95287,
              33.856857
            ],
            [
              -95.94192,
              33.861047
            ],
            [
              -95.936631,
              33.870615
            ],
            [
              -95.9352,
              33.876114
            ],
            [
              -95.9372,
              33.884652
            ],
            [
              -95.93212,
              33.886528
            ],
            [
              -95.91596,
              33.881148
            ],
            [
              -95.90534,
              33.875629
            ],
            [
              -95.8794,
              33.859047
            ],
            [
              -95.85988,
              33.852616
            ],
            [
              -95.83889,
              33.835983
            ],
            [
              -95.83195,
              33.835161
            ],
            [
              -95.82078,
              33.840564
            ],
            [
              -95.81898,
              33.844456
            ],
            [
              -95.82167,
              33.856633
            ],
            [
              -95.81917,
              33.858922
            ],
            [
              -95.80084,
              33.861212
            ],
            [
              -95.78789,
              33.856336
            ],
            [
              -95.77625,
              33.845145
            ],
            [
              -95.77328,
              33.843834
            ],
            [
              -95.759251,
              33.849256
            ],
            [
              -95.753513,
              33.856464
            ],
            [
              -95.75746,
              33.867957
            ],
            [
              -95.76205,
              33.872932
            ],
            [
              -95.76588,
              33.870958
            ],
            [
              -95.77477,
              33.874417
            ],
            [
              -95.78111,
              33.868421
            ],
            [
              -95.78591,
              33.872359
            ],
            [
              -95.79678,
              33.873642
            ],
            [
              -95.80509,
              33.870048
            ],
            [
              -95.81431,
              33.870551
            ],
            [
              -95.83088,
              33.875488
            ],
            [
              -95.8406,
              33.874163
            ],
            [
              -95.84266,
              33.877709
            ],
            [
              -95.8513,
              33.881278
            ],
            [
              -95.85474,
              33.885305
            ],
            [
              -95.86292,
              33.889421
            ],
            [
              -95.865477,
              33.899743
            ],
            [
              -95.87292,
              33.910749
            ],
            [
              -95.87878,
              33.916019
            ],
            [
              -95.88361,
              33.916639
            ],
            [
              -95.89646,
              33.921542
            ],
            [
              -95.90983,
              33.921751
            ],
            [
              -95.91754,
              33.924178
            ],
            [
              -95.92636,
              33.9337
            ],
            [
              -95.92891,
              33.939857
            ],
            [
              -95.9352,
              33.941391
            ],
            [
              -95.93795,
              33.948257
            ],
            [
              -95.93793,
              33.985691
            ],
            [
              -95.93836,
              34.049178
            ],
            [
              -95.93815,
              34.125096
            ],
            [
              -95.943954,
              34.124088
            ],
            [
              -95.95039,
              34.130622
            ],
            [
              -95.94841,
              34.134147
            ],
            [
              -95.95278,
              34.140051
            ],
            [
              -95.95345,
              34.148336
            ],
            [
              -95.96482,
              34.150256
            ],
            [
              -95.973105,
              34.154008
            ],
            [
              -95.9847,
              34.154301
            ],
            [
              -95.99158,
              34.156816
            ]
          ]
        ]
      },
      "properties": {
        "county": "40013",
        "name": "Bryan"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.8096,
              36.669878
            ],
            [
              -95.80969,
              36.684448
            ],
            [
              -95.809705,
              36.691764
            ],
            [
              -95.80972,
              36.698954
            ],
            [
              -95.809692,
              36.713392
            ],
            [
              -95.80965,
              36.716293
            ],
            [
              -95.80975,
              36.727853
            ],
            [
              -95.80979,
              36.73567
            ],
            [
              -95.80983,
              36.742243
            ],
            [
              -95.80992,
              36.742783
            ],
            [
              -95.80983,
              36.858543
            ],
            [
              -95.81008,
              36.909707
            ],
            [
              -95.80993,
              36.910622
            ],
            [
              -95.80997,
              36.916746
            ],
            [
              -95.81002,
              36.918607
            ],
            [
              -95.809992,
              36.941875
            ],
            [
              -95.80651,
              36.941921
            ],
            [
              -95.79189,
              36.941874
            ],
            [
              -95.786819,
              36.941919
            ],
            [
              -95.78687,
              36.974568
            ],
            [
              -95.78672,
              36.985595
            ],
            [
              -95.78676,
              36.99931
            ],
            [
              -95.81219,
              36.999117
            ],
            [
              -95.932,
              36.999314
            ],
            [
              -96.00081,
              36.99886
            ],
            [
              -96.001,
              36.888774
            ],
            [
              -96.00057,
              36.81493
            ],
            [
              -96.00065,
              36.750089
            ],
            [
              -96.00096,
              36.736455
            ],
            [
              -96.00064,
              36.673403
            ],
            [
              -96.00105,
              36.644121
            ],
            [
              -96.00067,
              36.599331
            ],
            [
              -96.00102,
              36.500091
            ],
            [
              -96.001177,
              36.424125
            ],
            [
              -96.000668,
              36.423687
            ],
            [
              -95.986104,
              36.423717
            ],
            [
              -95.977228,
              36.423674
            ],
            [
              -95.973467,
              36.423668
            ],
            [
              -95.970574,
              36.423668
            ],
            [
              -95.962716,
              36.423671
            ],
            [
              -95.955975,
              36.423695
            ],
            [
              -95.939646,
              36.423715
            ],
            [
              -95.938012,
              36.423702
            ],
            [
              -95.920943,
              36.42372
            ],
            [
              -95.920484,
              36.423713
            ],
            [
              -95.90769,
              36.423724
            ],
            [
              -95.907095,
              36.423723
            ],
            [
              -95.90235,
              36.423716
            ],
            [
              -95.894142,
              36.423703
            ],
            [
              -95.884201,
              36.423718
            ],
            [
              -95.867904,
              36.423733
            ],
            [
              -95.829827,
              36.42365
            ],
            [
              -95.812423,
              36.423602
            ],
            [
              -95.81245,
              36.51823
            ],
            [
              -95.81214,
              36.541718
            ],
            [
              -95.81269,
              36.561467
            ],
            [
              -95.81245,
              36.597516
            ],
            [
              -95.80962,
              36.597476
            ],
            [
              -95.80955,
              36.611961
            ],
            [
              -95.80957,
              36.621811
            ],
            [
              -95.80959,
              36.623081
            ],
            [
              -95.80964,
              36.62509
            ],
            [
              -95.8096,
              36.669878
            ]
          ]
        ]
      },
      "properties": {
        "county": "40147",
        "name": "Washington"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -95.87566,
              35.431324
            ],
            [
              -95.87568,
              35.432181
            ],
            [
              -95.87559,
              35.445554
            ],
            [
              -95.87559,
              35.453464
            ],
            [
              -95.87527,
              35.463577
            ],
            [
              -95.87442,
              35.463653
            ],
            [
              -95.86083,
              35.463755
            ],
            [
              -95.85224,
              35.463731
            ],
            [
              -95.84032,
              35.463793
            ],
            [
              -95.8234,
              35.463969
            ],
            [
              -95.82248,
              35.507307
            ],
            [
              -95.82242,
              35.514518
            ],
            [
              -95.822317,
              35.551726
            ],
            [
              -95.7715,
              35.551708
            ],
            [
              -95.75027,
              35.551952
            ],
            [
              -95.73856,
              35.551765
            ],
            [
              -95.73111,
              35.551716
            ],
            [
              -95.73103,
              35.551875
            ],
            [
              -95.712957,
              35.551802
            ],
            [
              -95.71334,
              35.58566
            ],
            [
              -95.71308,
              35.637335
            ],
            [
              -95.71264,
              35.653251
            ],
            [
              -95.71315,
              35.69258
            ],
            [
              -95.71308,
              35.725877
            ],
            [
              -95.76621,
              35.725713
            ],
            [
              -95.76603,
              35.783889
            ],
            [
              -95.76612,
              35.82753
            ],
            [
              -95.766003,
              35.848985
            ],
            [
              -95.766168,
              35.856457
            ],
            [
              -95.771722,
              35.85641
            ],
            [
              -95.794133,
              35.856316
            ],
            [
              -95.801771,
              35.856298
            ],
            [
              -95.81941,
              35.856206
            ],
            [
              -95.822777,
              35.856141
            ],
            [
              -95.855014,
              35.856163
            ],
            [
              -95.872774,
              35.856295
            ],
            [
              -95.876274,
              35.856283
            ],
            [
              -95.890569,
              35.856349
            ],
            [
              -95.900468,
              35.856371
            ],
            [
              -95.901855,
              35.856387
            ],
            [
              -95.908397,
              35.856387
            ],
            [
              -95.912278,
              35.856428
            ],
            [
              -95.913496,
              35.85644
            ],
            [
              -95.917955,
              35.856481
            ],
            [
              -95.921388,
              35.856497
            ],
            [
              -95.923198,
              35.856498
            ],
            [
              -95.92619,
              35.856514
            ],
            [
              -95.961856,
              35.856698
            ],
            [
              -95.9686,
              35.856749
            ],
            [
              -95.971456,
              35.856785
            ],
            [
              -95.979772,
              35.856888
            ],
            [
              -95.99601,
              35.856862
            ],
            [
              -95.997911,
              35.856875
            ],
            [
              -96.006428,
              35.856903
            ],
            [
              -96.033121,
              35.856822
            ],
            [
              -96.0403,
              35.85684
            ],
            [
              -96.05136,
              35.856933
            ],
            [
              -96.12528,
              35.857341
            ],
            [
              -96.192482,
              35.857021
            ],
            [
              -96.19238,
              35.769608
            ],
            [
              -96.19271,
              35.67136
            ],
            [
              -96.19256,
              35.639087
            ],
            [
              -96.19273,
              35.618766
            ],
            [
              -96.19272,
              35.617774
            ],
            [
              -96.19274,
              35.570206
            ],
            [
              -96.19284,
              35.551902
            ],
            [
              -96.15888,
              35.552056
            ],
            [
              -96.15731,
              35.552079
            ],
            [
              -96.12528,
              35.552104
            ],
            [
              -96.12138,
              35.551911
            ],
            [
              -96.10394,
              35.552128
            ],
            [
              -96.08956,
              35.552121
            ],
            [
              -96.08779,
              35.552119
            ],
            [
              -96.08788,
              35.5001
            ],
            [
              -96.08764,
              35.464021
            ],
            [
              -96.08761,
              35.453083
            ],
            [
              -96.087576,
              35.426812
            ],
            [
              -96.0876,
              35.420473
            ],
            [
              -96.08777,
              35.404819
            ],
            [
              -96.08767,
              35.400007
            ],
            [
              -96.08748,
              35.384613
            ],
            [
              -96.08747,
              35.384178
            ],
            [
              -96.08737,
              35.376993
            ],
            [
              -96.05155,
              35.377066
            ],
            [
              -96.0499,
              35.377043
            ],
            [
              -95.98131,
              35.376828
            ],
            [
              -95.95665,
              35.37668
            ],
            [
              -95.95037,
              35.37661
            ],
            [
              -95.94362,
              35.376616
            ],
            [
              -95.94147,
              35.376616
            ],
            [
              -95.93744,
              35.376636
            ],
            [
              -95.92855,
              35.376679
            ],
            [
              -95.89535,
              35.376682
            ],
            [
              -95.89396,
              35.376688
            ],
            [
              -95.87563,
              35.37669
            ],
            [
              -95.87565,
              35.389828
            ],
            [
              -95.87564,
              35.391629
            ],
            [
              -95.875627,
              35.408489
            ],
            [
              -95.87563,
              35.412862
            ],
            [
              -95.87566,
              35.431324
            ]
          ]
        ]
      },
      "properties": {
        "county": "40111",
        "name": "Okmulgee"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -97.14175,
              35.418786
            ],
            [
              -97.14173,
              35.42094
            ],
            [
              -97.14178,
              35.422016
            ],
            [
              -97.14167,
              35.423686
            ],
            [
              -97.14167,
              35.425809
            ],
            [
              -97.14178,
              35.429221
            ],
            [
              -97.14148,
              35.434786
            ],
            [
              -97.14149,
              35.437281
            ],
            [
              -97.14156,
              35.438719
            ],
            [
              -97.14138,
              35.448009
            ],
            [
              -97.14133,
              35.448897
            ],
            [
              -97.14136,
              35.449361
            ],
            [
              -97.14143,
              35.452001
            ],
            [
              -97.1413,
              35.461153
            ],
            [
              -97.14125,
              35.462424
            ],
            [
              -97.14123,
              35.464064
            ],
            [
              -97.14135,
              35.471131
            ],
            [
              -97.14149,
              35.479472
            ],
            [
              -97.14142,
              35.500242
            ],
            [
              -97.14128,
              35.50641
            ],
            [
              -97.14125,
              35.516319
            ],
            [
              -97.14128,
              35.520223
            ],
            [
              -97.14123,
              35.527039
            ],
            [
              -97.14123,
              35.532431
            ],
            [
              -97.1413,
              35.538879
            ],
            [
              -97.14144,
              35.550574
            ],
            [
              -97.14087,
              35.550542
            ],
            [
              -97.14079,
              35.563486
            ],
            [
              -97.140755,
              35.56971
            ],
            [
              -97.1409,
              35.574222
            ],
            [
              -97.14124,
              35.623021
            ],
            [
              -97.1414,
              35.637532
            ],
            [
              -97.14141,
              35.644663
            ],
            [
              -97.14142,
              35.647687
            ],
            [
              -97.14136,
              35.65246
            ],
            [
              -97.14135,
              35.6571
            ],
            [
              -97.14138,
              35.666556
            ],
            [
              -97.14119,
              35.681003
            ],
            [
              -97.14116,
              35.68471
            ],
            [
              -97.14104,
              35.698146
            ],
            [
              -97.140997,
              35.703243
            ],
            [
              -97.14109,
              35.70621
            ],
            [
              -97.14109,
              35.709915
            ],
            [
              -97.140997,
              35.724442
            ],
            [
              -97.14952,
              35.724378
            ],
            [
              -97.16906,
              35.724442
            ],
            [
              -97.17673,
              35.724441
            ],
            [
              -97.18457,
              35.724537
            ],
            [
              -97.19437,
              35.724553
            ],
            [
              -97.19644,
              35.724537
            ],
            [
              -97.21212,
              35.724713
            ],
            [
              -97.22156,
              35.724876
            ],
            [
              -97.22501,
              35.724936
            ],
            [
              -97.23361,
              35.724904
            ],
            [
              -97.26503,
              35.724983
            ],
            [
              -97.28284,
              35.724969
            ],
            [
              -97.28553,
              35.724967
            ],
            [
              -97.2882,
              35.724995
            ],
            [
              -97.29668,
              35.725015
            ],
            [
              -97.30068,
              35.724999
            ],
            [
              -97.31841,
              35.725154
            ],
            [
              -97.32362,
              35.725154
            ],
            [
              -97.33621,
              35.725154
            ],
            [
              -97.33761,
              35.725154
            ],
            [
              -97.35365,
              35.725253
            ],
            [
              -97.35407,
              35.725254
            ],
            [
              -97.35768,
              35.725247
            ],
            [
              -97.36243,
              35.725238
            ],
            [
              -97.37151,
              35.725153
            ],
            [
              -97.38801,
              35.725163
            ],
            [
              -97.39976,
              35.725205
            ],
            [
              -97.40196,
              35.725253
            ],
            [
              -97.40732,
              35.725253
            ],
            [
              -97.40932,
              35.725253
            ],
            [
              -97.41292,
              35.725153
            ],
            [
              -97.41722,
              35.725153
            ],
            [
              -97.41952,
              35.725205
            ],
            [
              -97.42522,
              35.725152
            ],
            [
              -97.43872,
              35.725152
            ],
            [
              -97.44012,
              35.725172
            ],
            [
              -97.46008,
              35.725248
            ],
            [
              -97.46579,
              35.725284
            ],
            [
              -97.478218,
              35.725351
            ],
            [
              -97.48362,
              35.725351
            ],
            [
              -97.4864,
              35.725373
            ],
            [
              -97.49245,
              35.725422
            ],
            [
              -97.50296,
              35.725523
            ],
            [
              -97.51392,
              35.725551
            ],
            [
              -97.54942,
              35.72575
            ],
            [
              -97.56702,
              35.72585
            ],
            [
              -97.64237,
              35.725964
            ],
            [
              -97.66511,
              35.725985
            ],
            [
              -97.67392,
              35.725985
            ],
            [
              -97.67402,
              35.682066
            ],
            [
              -97.67405,
              35.667491
            ],
            [
              -97.67405,
              35.661571
            ],
            [
              -97.67397,
              35.659379
            ],
            [
              -97.67397,
              35.653027
            ],
            [
              -97.67408,
              35.590485
            ],
            [
              -97.674,
              35.575134
            ],
            [
              -97.67412,
              35.560754
            ],
            [
              -97.67422,
              35.554954
            ],
            [
              -97.67132,
              35.551054
            ],
            [
              -97.67142,
              35.481757
            ],
            [
              -97.67132,
              35.479957
            ],
            [
              -97.67142,
              35.478757
            ],
            [
              -97.67142,
              35.472757
            ],
            [
              -97.67152,
              35.448458
            ],
            [
              -97.67142,
              35.435258
            ],
            [
              -97.67132,
              35.391559
            ],
            [
              -97.67141,
              35.385611
            ],
            [
              -97.67139,
              35.381724
            ],
            [
              -97.67122,
              35.37946
            ],
            [
              -97.67122,
              35.37726
            ],
            [
              -97.63363,
              35.376988
            ],
            [
              -97.60092,
              35.377261
            ],
            [
              -97.516845,
              35.377189
            ],
            [
              -97.512415,
              35.377175
            ],
            [
              -97.459214,
              35.377329
            ],
            [
              -97.332177,
              35.377211
            ],
            [
              -97.24117,
              35.377428
            ],
            [
              -97.23907,
              35.377416
            ],
            [
              -97.15984,
              35.377138
            ],
            [
              -97.14182,
              35.376818
            ],
            [
              -97.14206,
              35.379554
            ],
            [
              -97.141937,
              35.381666
            ],
            [
              -97.14181,
              35.38309
            ],
            [
              -97.14184,
              35.396002
            ],
            [
              -97.14176,
              35.397678
            ],
            [
              -97.14176,
              35.397762
            ],
            [
              -97.14184,
              35.399634
            ],
            [
              -97.141753,
              35.405974
            ],
            [
              -97.14181,
              35.407826
            ],
            [
              -97.14184,
              35.40989
            ],
            [
              -97.14171,
              35.41173
            ],
            [
              -97.14173,
              35.412546
            ],
            [
              -97.14178,
              35.415202
            ],
            [
              -97.14171,
              35.416626
            ],
            [
              -97.14181,
              35.417874
            ],
            [
              -97.14175,
              35.418786
            ]
          ]
        ]
      },
      "properties": {
        "county": "40109",
        "name": "Oklahoma"
      }
    }
  ]
} as FeatureCollection<Polygon | MultiPolygon>;
